import {checkJsonProp} from './';
import {TranslationContexts, store} from '../Redux';

function getClassificatorsFn() {
    const state = store.getState();
    const {translations} = state.translationReducer;
    const {language} = state.languageReducer;

    return checkJsonProp(translations.find(e => e.context === TranslationContexts.classificators && e.culture === language), 'Groups');
}

export const getClassificatorsConst = () => {
    return {
      "CTF": {
        "1": "Taikomas",
        "2": "Netaikomas"
      },
      "GUARANTEE": {
        "1": "Paprastoji garantija",
        "2": "CKU garantija"
      },
      "GUAR": {
        "1": "Pasiūlymo",
        "2": "Sutarties įvykdymo",
        "3": "Kredito grąžinimo",
        "4": "Mokėjimo",
        "5": "Avanso grąžinimo",
        "6": "Kita (nurodyti): "
      },
      "MEMBR": {
        "MEMBR1": "Gyvena/vykdoma veikla Unijos teritorijoje ",
        "MEMBR2": "Dirba",
        "MEMBR3": "Mokosi",
        "MEMBR4": "Šeimos narys"
      },
      "TYP_AMRTSTN": {
        "1": "Prancūzijos",
        "2": "Vokietijos",
        "3": "Fiksuotos amortizacijos grafikas",
        "4": "Vienkartinė įmoka",
        "5": "Kita"
      },
      "TYP_PRTCTN": {
        "2": "Įkeisti gyvybės draudimo liudijimai",
        "4": "Kredito išvestinės finansinės priemonės",
        "7": "Kita apsauga",
        "13": "Auksas",
        "16": "Paskolos",
        "10_A": "Komercinio nekilnojamojo turto įkaitas: prekybos paskirties pastatai",
        "10_B": "Komercinio nekilnojamojo turto įkaitas: viešbučiai, restoranai, kt. poilsio paskirties pastatai",
        "10_C": "Komercinio nekilnojamojo turto įkaitas: gamybinės, sandėliavimo paskirties pastatai",
        "10_D": "Komercinio nekilnojamojo turto įkaitas: komercinės paskirties žemė",
        "10_E": "Komercinio nekilnojamojo turto įkaitas: žemės ūkio paskirties žemė",
        "10_F": "Komercinio nekilnojamojo turto įkaitas: kitas komercinio nekilnojamojo turto įkaitas",
        "12_A": "Vertybiniai popieriai: LR ir kitų valstybių vyriausybių vertybiniai popieriai",
        "12_B": "Vertybiniai popieriai: kotiruojami įmonių skolos vertybiniai popieriai",
        "12_C": "Vertybiniai popieriai: nekotiruojami įmonių skolos vertybiniai popieriai",
        "12_D": "Vertybiniai popieriai: kiti vertybiniai popieriai",
        "15_A": "Pinigai ir indėliai: deponuotos lėšos",
        "15_B": "Pinigai ir indėliai: lėšos atsiskaitomojoje sąskaitoje",
        "15_C": "Pinigai ir indėliai: kiti pinigai ir indėliai",
        "17_A": "Gautinos prekybos sumos: gautinos sumos ne pagal faktoringo sandorius",
        "17_B": "Gautinos prekybos sumos: vekseliai",
        "17_C": "Gautinos prekybos sumos: gautinos sumos pagal faktoringo sandorius",
        "17_D": "Gautinos prekybos sumos: kitos gautinos prekybos sumos",
        "18_A": "Nuosavybės priemonės ir investicinių fondų akcijos (vienetai): kotiruojami įmonių NVP (biržinės akcijos)",
        "18_B": "Nuosavybės priemonės ir investicinių fondų akcijos (vienetai): nekotiruojami įmonių NVP (nebiržinės akcijos)",
        "18_C": "Nuosavybės priemonės ir investicinių fondų akcijos (vienetai): skolininko NVP",
        "18_D": "Nuosavybės priemonės ir investicinių fondų akcijos (vienetai): investicinių fondų akcijos ar vienetai",
        "18_E": "Nuosavybės priemonės ir investicinių fondų akcijos (vienetai): kitos nuosavybės priemonės ir investicinių fondų akcijos (vienetai)",
        "3_A": "Kitos fizinės užtikrinimo priemonės: transporto priemonės ir įranga",
        "3_B": "Kitos fizinės užtikrinimo priemonės: įrenginiai ir įranga",
        "3_C": "Kitos fizinės užtikrinimo priemonės: žaliavos ir medžiagos",
        "3_D": "Kitos fizinės užtikrinimo priemonės: nebaigta gamyba",
        "3_E": "Kitos fizinės užtikrinimo priemonės: gyvenamosios paskirties žemės sklypas",
        "3_F": "Kitos fizinės užtikrinimo priemonės: kitos kitos fizinės užtikrinimo priemonės",
        "5_A": "Finansinės garantijos, išskyrus kredito išvestines finansines priemones: centrinės valdymo įstaigos",
        "5_B": "Finansinės garantijos, išskyrus kredito išvestines finansines priemones: vietinės valdymo įstaigos",
        "5_C": "Finansinės garantijos, išskyrus kredito išvestines finansines priemones: bankai",
        "5_D": "Finansinės garantijos, išskyrus kredito išvestines finansines priemones: garantijas teikiančios įmonės (INVEGA, ŽŪPGF)",
        "5_E": "Finansinės garantijos, išskyrus kredito išvestines finansines priemones: kredito draudimą teikiančios įmonės",
        "5_F": "Finansinės garantijos, išskyrus kredito išvestines finansines priemones: ne finansų įmonės (taip pat vekselio davėjai)",
        "5_G": "Finansinės garantijos, išskyrus kredito išvestines finansines priemones: namų ūkiai (taip pat vekselių davėjai)",
        "5_H": "Finansinės garantijos, išskyrus kredito išvestines finansines priemones: kitos finansinės garantijos, išskyrus kredito išvestines finansines priemones",
        "8_A": "Gyvenamojo nekilnojamojo turto įkaitas: gyvenamasis namas su žemės sklypu, sodyba,  kotedžas, sodo namas                        ",
        "8_B": "Gyvenamojo nekilnojamojo turto įkaitas: butas",
        "8_C": "Gyvenamojo nekilnojamojo turto įkaitas: kitas gyvenamojo nekilnojamojo turto įkaitas",
        "9_A": "Biurai ir komercinės paskirties patalpos: biurai",
        "9_B": "Biurai ir komercinės paskirties patalpos: kitos komercinės paskirties patalpos"
      },
      "PRMR_PRTCTN_PRVDR": {
        "1": "Pagrindinis apsaugos teikėjas",
        "2": "Nepagrindinis apsaugos teikėjas",
        "9": "Jau nebėra apsaugos teikėjas"
      },
      "TYP_PRTCTN_VL": {
        "1": "Tikroji vertė",
        "2": "Ilgalaikė tvari vertė",
        "3": "Rinkos vertė",
        "4": "Tariamoji suma",
        "5": "Kita užtikrinimo vertė"
      },
      "PRTCTN_VLTN_APPRCH": {
        "1": "Kitos sandorio šalies vertinimas",
        "2": "Kreditoriaus vertinimas",
        "3": "Rinkos vertė",
        "4": "Kita vertinimo rūšis",
        "5": "Trečiosios šalies vertinimas"
      },
      "RCRS": {
        "1": "Atgręžtinis reikalavimas",
        "2": "Be atgręžtinio reikalavimo"
      },
      "RCGNTN_STTS": {
        "1": "Visiškai pripažinta",
        "2": "Pripažįstama tiek, kiek įstaiga toliau ją kontroliuoja",
        "3": "Pripažįstama tiek, kiek įstaiga toliau ją kontroliuoja"
      },
      "ECNMC_ACTVTY": {
        "24": "Manufacture of basic metals",
        "25": "Manufacture of fabricated metal products, except machinery and equipment",
        "26": "Manufacture of computer, electronic and optical products",
        "27": "Manufacture of electrical equipment",
        "28": "Manufacture of machinery and equipment n.e.c.",
        "29": "Manufacture of motor vehicles, trailers and semi-trailers",
        "30": "Manufacture of other transport equipment",
        "31": "Manufacture of furniture",
        "32": "Other manufacturing",
        "33": "Repair and installation of machinery and equipment",
        "35": "Electricity, gas, steam and air conditioning supply",
        "36": "Water collection, treatment and supply",
        "37": "Sewerage",
        "38": "Waste collection, treatment and disposal activities, materials recovery",
        "39": "Remediation activities and other waste management services",
        "41": "Construction of buildings",
        "42": "Civil engineering",
        "43": "Specialised construction activities",
        "45": "Wholesale and retail trade and repair of motor vehicles and motorcycles",
        "46": "Wholesale trade, except of motor vehicles and motorcycles",
        "47": "Retail trade, except of motor vehicles and motorcycles",
        "49": "Land transport and transport via pipelines",
        "50": "Water transport",
        "51": "Air transport",
        "52": "Warehousing and support activities for transportation",
        "53": "Postal and courier activities",
        "55": "Accommodation",
        "56": "Food and beverage service activities",
        "58": "Publishing activities",
        "59": "Motion picture, video and television programme production, sound recording and music publishing activities",
        "60": "Programming and broadcasting activities",
        "61": "Telecommunications",
        "62": "Computer programming, consultancy and related activities",
        "63": "Information service activities",
        "64": "Financial service activities, except insurance and pension funding",
        "65": "Insurance, reinsurance and pension funding, except compulsory social security",
        "66": "Activities auxiliary to financial services and insurance activities",
        "68": "Real estate activities",
        "69": "Legal and accounting activities",
        "70": "Activities of head offices, management consultancy activities",
        "71": "Architectural and engineering activities, technical testing and analysis",
        "72": "Scientific research and development ",
        "73": "Advertising and market research",
        "74": "Other professional, scientific and technical activities",
        "75": "Veterinary activities",
        "77": "Rental and leasing activities",
        "78": "Employment activities",
        "79": "Travel agency, tour operator and other reservation service and related activities",
        "80": "Security and investigation activities",
        "81": "Services to buildings and landscape activities",
        "82": "Office administrative, office support and other business support activities",
        "84": "Public administration and defence, compulsory social security",
        "85": "Education",
        "86": "Human health activities",
        "87": "Residential care activities",
        "88": "Social work activities without accommodation",
        "90": "Creative, arts and entertainment activities",
        "91": "Libraries, archives, museums and other cultural activities",
        "92": "Gambling and betting activities",
        "93": "Sports activities and amusement and recreation activities",
        "94": "Activities of membership organisations",
        "95": "Repair of computers and personal and household goods",
        "96": "Other personal service activities",
        "97": "Activities of households as employers of domestic personnel",
        "98": "Undifferentiated goods- and services-producing activities of private households for own use",
        "99": "Activities of extraterritorial organisations and bodies"
      },
      "EBANK": {
        "EBANK1": "El. bankininkystė"
      },
      "TYP_NTNL_ID_NP": {
        "AT_CONCAT": "CONCAT",
        "BE_CONCAT": "CONCAT",
        "BE_NN": "Belgian National Number",
        "BG_CONCAT": "CONCAT",
        "BG_PN": "Bulgarian Personal Number",
        "CY_CONCAT": "CONCAT",
        "CY_NPN": "National Passport Number",
        "CZ_CONCAT": "CONCAT",
        "CZ_NIN": "National identification number",
        "CZ_PN": "Passport Number",
        "DE_CONCAT": "CONCAT",
        "DK_CONCAT": "CONCAT",
        "DK_PIC": "Personal identity code",
        "EE_PIC": "Estonian Personal Identification Code",
        "ES_TIN": "Tax identification number",
        "FI_CONCAT": "CONCAT",
        "FI_PIC": "Personal identity code",
        "FR_CONCAT": "CONCAT",
        "GB_CONCAT": "CONCAT",
        "GB_NIN": "UK National Insurance number",
        "GEN_CONCAT": "CONCAT",
        "GEN_NPN": "National Passport Number",
        "GR_CONCAT": "CONCAT",
        "GR_DSS": "10 DSS digit investor share",
        "HR_CONCAT": "CONCAT",
        "HR_PIN": "Personal Identification Number",
        "HU_CONCAT": "CONCAT",
        "IE_CONCAT": "CONCAT",
        "IS_PIC": "Personal Identity Code",
        "IT_FC": "Fiscal code",
        "LI_CONCAT": "CONCAT",
        "LI_NICN": "National Identity Card Number",
        "LI_NPN": "National Passport Number",
        "LT_PC": "Personal code",
        "LU_CONCAT": "CONCAT",
        "LV_CONCAT": "CONCAT",
        "LV_PC": "Personal code",
        "MT_NIN": "National Identification Number",
        "MT_NPN": "National Passport Number",
        "NL_CONCAT": "CONCAT",
        "NL_NICN": "National identity card number",
        "NL_NPN": "National Passport Number",
        "NO_CONCAT": "CONCAT",
        "NO_PID": "11 digit personal id",
        "PL_NIN": "National Identification Number",
        "PL_TN": "Tax Number",
        "PT_CONCAT": "CONCAT",
        "PT_NPN": "National Passport Number",
        "PT_TN": "Tax number",
        "RO_CONCAT": "CONCAT",
        "RO_NIN": "National Identification Number",
        "RO_NPN": "National Passport Number",
        "SE_CONCAT": "CONCAT",
        "SE_PIN": "Personal identity number",
        "SI_CONCAT": "CONCAT",
        "SI_PIN": "Personal Identification Number",
        "SK_CONCAT": "CONCAT",
        "SK_NPN": "National Passport Number",
        "SK_PN": "Personal number"
      },
      "FINAL_STATUS": {
        "1": "Grąžinta arba pasibaigė kreditavimo įsipareigojimas",
        "2": "Parduota",
        "3": "Perduota",
        "4": "Nurašyta su reikalavimo teise",
        "5": "Nurašyta be reikalavimo teisės",
        "6": "Nurašyta paskola grąžinta į balansą"
      },
      "RPYMNT_RGHTS": {
        "1": "Pagal pareikalavimą arba įspėjus prieš trumpą laikotarpį",
        "2": "Kita"
      },
      "IDF": {
        "0": "Ne",
        "1": "Taip"
      },
      "ENTRPRS_SZ": {
        "1": "Didelė įmonė",
        "2": "Vidutinė įmonė",
        "3": "Mažoji įmonė",
        "4": "Labai maža įmonė"
      },
      "CLRS": {
        "CLRS2": "Indėlininko iniciatyva",
        "CLRS1": "Dėl palūkanų sąlygų keitimo Unijos sprendimu",
        "CLRS3": "Dėl paveldėjimo"
      },
      "INSTTTNL_SCTR": {
        "S11": "Ne finansų bendrovės",
        "S121": "Centrinis Bankas",
        "S122": "Indėlių bendrovės",
        "S123": "Pinigų rinkos fondai (PRF)",
        "S124": "Ne PRF investiciniai fondai",
        "S125": "Kiti finansiniai tarpininkai, išskyrus draudimo bendroves ir pensijų fondus",
        "S126": "Finansiniai pagalbininkai",
        "S127": "Priklausomos finansų įstaigos ir pinigų skolintojai",
        "S128": "Draudimo bendrovės",
        "S129": "Pensijų fondai",
        "S1311": "Centrinė valdžia",
        "S1312": "Krašto (regiono) valdžia",
        "S1313": "Vietos valdžia",
        "S1314": "Socialinės apsaugos fondai",
        "S14_A": "Namų ūkiai, kurie yra individualiosios įmonės ir partnerystės, neturinčios nepriklausomo juridinio statuso",
        "S14_B": "Namų ūkiai, išskyrus individualiąsias įmones ir partnerystes, neturinčias nepriklausomo juridinio statuso",
        "S15": "Ne pelno institucijos, teikiančios paslaugas namų ūkiams"
      },
      "ENTTY_RL": {
        "1": "Kreditorius",
        "2": "Skolininkas",
        "3": "Iniciatorius",
        "7": "Administratorius",
        "13": "Finansinio užstato gavėjas pagal FUSĮ",
        "14": "Platformos operatorius"
      },
      "CRDT_RSDNTL": {
        "1": "Taip",
        "2": "Ne"
      },
      "CRDT_EXCPTN": {
        "1": "Taip",
        "2": "Ne"
      },
      "Warr": {
        "WARR1": "Reikalaujamas",
        "WARR2": "Nereikalaujamas"
      },
      "PYMNT_FRQNCY": {
        "1": "Metų",
        "4": "Vienkartinė įmoka",
        "8": "Mėnesio",
        "15": "Kita",
        "18": "Ketvirčio",
        "19": "Pusmečio",
        "22": "Nulinė atkarpa"
      },
      "TYP_NTNL_ID": {
        "AT_FB_CD": "Firmenbuchnummer",
        "AT_GEM_CD": "Gemeindenummer",
        "AT_IDENT_CD": "Identnummer",
        "AT_LAE_CD": "Ländernummer",
        "AT_ZVR_CD": "Vereinsregisternummer",
        "BE_OND_CD": "Numéro d'entreprise / Ondernemingsnummer / Unternehmensnummer",
        "BG_BULSTAT_CD": "Единен идентификационен код (по БУЛСТАТ)",
        "BG_OTHER_CD": "Друг идентификационен код",
        "BG_UIC_CD": "Единен (Персонален) идентификационен код",
        "BG_VAT_CD": "Идентификационен номер по ДДС ",
        "BIC": "Bank Identifier Code by SWIFT",
        "BR_CNPJ_CD": "Cadastro Nacional da Pessoa Jurídica",
        "CA_BN_CD": "Business Number / Federal Tax ID",
        "CH_UID_CD": "Unternehmens-Identifikationsnummer",
        "CN_CC_CD": "Credibility Code, or USCN code",
        "CY_DRCOR_CD": "Αριθμός Εγγραφής στο Τμήμα Εφόρου Εταιρειών και Επίσημου Παραλήπτη ",
        "CY_GG_CD": "Αριθμός μονάδων γενικής κυβέρνησης",
        "CY_IF_CD": "Investment Fund code",
        "CY_NOTAP_CD": "Not applicable",
        "CY_PF_CD": "Pension Fund code",
        "CY_TIC_CD": "Αριθμός φορολογικής ταυτότητας ",
        "CY_VAT_CD": "Αριθμός Εγγραφής Φ.Π.Α.",
        "CZ_ICO_CD": "Identifikační číslo osoby",
        "CZ_NID_CD": "Náhradní identifikační číslo",
        "DE_GNR_CD": "Genossenschaftsregister",
        "DE_HRA_CD": "Handelsregister Abteilung A",
        "DE_HRB_CD": "Handelsregister Abteilung B",
        "DE_NOTAP_CD": "Kein Registereintrag (Not applicable)",
        "DE_PR_CD": "Partnerschaftsregister",
        "DE_VR_CD": "Vereinsregister",
        "DK_CVR_CD": "CVR-nummer",
        "DK_FT_CD": "FT-nummer",
        "DK_NOTAP_CD": "Not applicable",
        "DK_SE_CD": "SE-nummer",
        "EE_FON_CD": "Aruandja kood",
        "EE_RG_CD": "Äriregistri kood",
        "ES_NIF_CD": "Código de Identificación Fiscal",
        "FI_ALV_CD": "Arvonlisäverotunniste",
        "FI_NOTAP_CD": "Not applicable",
        "FI_SIRA_CD": "Rahastotunnus",
        "FI_Y_CD": "Yritys- ja yhteisötunnus / Y-tunnus",
        "FR_CIB": "Code interbancaire",
        "FR_RNA_CD": "Numéro RNA",
        "FR_SIREN_CD": "Code SIREN",
        "GB_CRN_CD": "Company Registration Number",
        "GB_UTR_CD": "Unique taxpayer reference",
        "GEN_IPF_CD": "Investment/Pension fund identifier",
        "GEN_NBR_ENTTY_CD": "Business register number",
        "GEN_NCB_ENTTY_CD": "National Central Bank identifier",
        "GEN_NSA_ENTTY_CD": "National supervisory authority code",
        "GEN_NSI_ENTTY_CD": "National Statistical Institute number",
        "GEN_OTHER_CD": "Other (please specify)",
        "GEN_PS_CD": "Public sector entity identifier",
        "GEN_TAX_CD": "Tax code",
        "GEN_TRD_RGSTR_ENTTY_CD": "Trade register number",
        "GEN_VAT_CD": "VAT number",
        "GR_AFM_CD": "Arithmós Forologikou Mitroou A-Fi-Mi  Αριθμός Φορολογικού Μητρώου Α.Φ.Μ.",
        "GR_IMO_CD": "International Maritime Organisation number",
        "HK_BR_CD": "Business Registration Number",
        "HR_MB_CD": "Matični broj poslovnog subjekta",
        "HR_MBS_CD": "Matični broj subjekta trgovačkog suda",
        "HR_OIB_CD": "Osobni identifikacijski broj",
        "HU_CEG_CD": "Cégjegyzékszám ",
        "HU_FB_CD": "FB kód",
        "HU_KOZ_CD": "Közösségi adószám",
        "HU_TOR_CD": "Törzsszám",
        "IE_CRO_CD": "Company Registration Office number",
        "IN_CIN_CD": "Corporate identity number",
        "IN_PAN_CD": "Permanent Account Number",
        "IT_CCIAA_CD": "Numero d'iscrizione camerale",
        "IT_CF_CD": "Codice fiscale",
        "IT_UCITS_CD": "Codice OICR",
        "JP_CN_CD": "Corporate Number",
        "LT_INV_CD": "Investicinio/ pensijų fondo kodas",
        "LT_JAR_CD": "Juridinių asmenų registro kodas",
        "LU_IF_CD": "Investment fund entity identifier",
        "LU_RCS_CD": "Numéro registre de commerce et des sociétés (RCS)",
        "LU_VAT_CD": "Public sector entity identifier",
        "LV_FON_CD": "Latvijas Republikas ieguldījumu fondu saraksts",
        "LV_NBR_CD": "Komersanta reģistrācijas numurs Latvijas Republikas Uzņēmumu reģistra komercreģistrā",
        "LV_VAT_CD": "Pievienotās vērtības nodokļa (PVN) maksātāja kods",
        "MC_CIB": "Code interbancaire",
        "MC_NIS_CD": "Numéro d'Identification Statistique",
        "MC_RCI_CD": "Numéro RCI",
        "MT_CNUM_CD": "MFSA Company Number",
        "MT_OLE_CD": "Other Legal Entities code",
        "MT_VAT_CD": "VAT number",
        "MX_RFC_CD": "Clave en el Registro Federal de\nContribuyentes",
        "NL_KVK_CD": "Kamer van Koophandel nummer",
        "NL_RSIN_CD": "Rechtspersonen Samenwerkingsverbanden Informatie nummer",
        "PL_KRS_CD": "Numer w Krajowym Rejesrze Sądowym (KRS)",
        "PL_NIP_CD": "Numer Identyfikacji Podatkowej",
        "PL_REGON_CD": "Numer identyfikacyjny REGON",
        "PL_VAT_CD": "Numer Identyfikacji Podatkowej NIP z prefixem PL",
        "PT_FSA_CD": "Código de registo na autoridade de supervisão",
        "PT_NIF_CD": "Número de Identificação Fiscal ",
        "RO_CUI_CD": "Codul unic de identificare fiscală",
        "RO_TAX_CD": "Identificatorul aferent taxei pe valoarea adaugata",
        "RO_TRN_CD": "Numarul de inregistrare la registrul comertului",
        "RU_INN_CD": "Taxpayer Personal Identification Number",
        "SE_FIN_CD": "Finansinspektionens institutnummer",
        "SE_MOM_CD": "Momsregistreringsnummer",
        "SE_ORG_CD": "Organisationsnummer",
        "SI_DAV_CD": "Davčna številka",
        "SI_DDV_CD": "ID za DDV",
        "SI_MAT_CD": "Matična številka",
        "SK_ICO_CD": "Identifikačné číslo organizácie",
        "SK_IF_CD": "Kód investičného fondu",
        "TR_VKN_CD": "Vergi Kimlik Numarası",
        "US_EIN_CD": "Employer Identification Number"
      },
      "USER": {
        "USER1": "USER1",
        "USER2": "USER2",
        "USER3": "USER3",
        "USER4": "USER4"
      },
      "ISO3166_NUTS_DSJNT": {
        "AD": "Andorra",
        "AE": "United Arab Emirates (the)",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AO": "Angola",
        "AQ": "Antarctica",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT111": "Mittelburgenland",
        "AT112": "Nordburgenland",
        "AT113": "Südburgenland",
        "AT121": "Mostviertel-Eisenwurzen",
        "AT122": "Niederösterreich-Süd",
        "AT123": "Sankt Pölten",
        "AT124": "Waldviertel",
        "AT125": "Weinviertel",
        "AT126": "Wiener Umland/Nordteil",
        "AT127": "Wiener Umland/Südteil",
        "AT130": "Wien",
        "AT211": "Klagenfurt-Villach",
        "AT212": "Oberkärnten",
        "AT213": "Unterkärnten",
        "AT221": "Graz",
        "AT222": "Liezen",
        "AT223": "Östliche Obersteiermark",
        "AT224": "Oststeiermark",
        "AT225": "West- und Südsteiermark",
        "AT226": "Westliche Obersteiermark",
        "AT311": "Innviertel",
        "AT312": "Linz-Wels",
        "AT313": "Mühlviertel",
        "AT314": "Steyr-Kirchdorf",
        "AT315": "Traunviertel",
        "AT321": "Lungau",
        "AT322": "Pinzgau-Pongau",
        "AT323": "Salzburg und Umgebung",
        "AT331": "Außerfern",
        "AT332": "Innsbruck",
        "AT333": "Osttirol",
        "AT334": "Tiroler Oberland",
        "AT335": "Tiroler Unterland",
        "AT341": "Bludenz-Bregenzer Wald",
        "AT342": "Rheintal-Bodenseegebiet",
        "ATZZZ": "Extra-Regio NUTS 3",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE100": "Arr. de Bruxelles-Capitale / Arr. van Brussel-Hoofdstad",
        "BE211": "Arr. Antwerpen",
        "BE212": "Arr. Mechelen",
        "BE213": "Arr. Turnhout",
        "BE221": "Arr. Hasselt",
        "BE222": "Arr. Maaseik",
        "BE223": "Arr. Tongeren",
        "BE231": "Arr. Aalst",
        "BE232": "Arr. Dendermonde",
        "BE233": "Arr. Eeklo",
        "BE234": "Arr. Gent",
        "BE235": "Arr. Oudenaarde",
        "BE236": "Arr. Sint-Niklaas",
        "BE241": "Arr. Halle-Vilvoorde",
        "BE242": "Arr. Leuven",
        "BE251": "Arr. Brugge",
        "BE252": "Arr. Diksmuide",
        "BE253": "Arr. Ieper",
        "BE254": "Arr. Kortrijk",
        "BE255": "Arr. Oostende",
        "BE256": "Arr. Roeselare",
        "BE257": "Arr. Tielt",
        "BE258": "Arr. Veurne",
        "BE310": "Arr. Nivelles",
        "BE321": "Arr. Ath",
        "BE322": "Arr. Charleroi",
        "BE323": "Arr. Mons",
        "BE324": "Arr. Mouscron",
        "BE325": "Arr. Soignies",
        "BE326": "Arr. Thuin",
        "BE327": "Arr. Tournai",
        "BE331": "Arr. Huy",
        "BE332": "Arr. Liège",
        "BE334": "Arr. Waremme",
        "BE335": "Arr. Verviers - communes francophones",
        "BE336": "Bezirk Verviers - Deutschsprachige Gemeinschaft",
        "BE341": "Arr. Arlon",
        "BE342": "Arr. Bastogne",
        "BE343": "Arr. Marche-en-Famenne",
        "BE344": "Arr. Neufchâteau",
        "BE345": "Arr. Virton",
        "BE351": "Arr. Dinant",
        "BE352": "Arr. Namur",
        "BE353": "Arr. Philippeville",
        "BEZZZ": "Extra-Regio NUTS 3",
        "BF": "Burkina Faso",
        "BG311": "Vidin",
        "BG312": "Montana",
        "BG313": "Vratsa",
        "BG314": "Pleven",
        "BG315": "Lovech",
        "BG321": "Veliko Tarnovo",
        "BG322": "Gabrovo",
        "BG323": "Ruse",
        "BG324": "Razgrad",
        "BG325": "Silistra",
        "BG331": "Varna",
        "BG332": "Dobrich",
        "BG333": "Shumen",
        "BG334": "Targovishte",
        "BG341": "Burgas",
        "BG342": "Sliven",
        "BG343": "Yambol",
        "BG344": " Stara Zagora",
        "BG411": " Sofia (stolitsa)",
        "BG412": "Sofia",
        "BG413": "Blagoevgrad",
        "BG414": "Pernik",
        "BG415": "Kyustendil",
        "BG421": "Plovdiv",
        "BG422": "Haskovo",
        "BG423": "Pazardzhik",
        "BG424": "Smolyan",
        "BG425": "Kardzhali",
        "BGZZZ": "Extra-Regio NUTS 3",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthélemy",
        "BM": "Bermuda",
        "BN": "Brunei Darussalam",
        "BO": "Bolivia (Plurinational State of)",
        "BQ": "Bonaire, Saint Eustatius and Saba",
        "BR": "Brazil",
        "BS": "Bahamas (the)",
        "BT": "Bhutan",
        "BV": "Bouvet Island",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos (Keeling) Islands (the)",
        "CD": "Congo (the Democratic Republic of the)",
        "CF": "Central African Republic (the)",
        "CG": "Congo (the)",
        "CH": "Switzerland",
        "CI": "Cote d'Ivoire",
        "CK": "Cook Islands (the)",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cabo Verde",
        "CW": "Curacao",
        "CX": "Christmas Island",
        "CY000": "Kýpros",
        "CYZZZ": "Extra-Regio NUTS 3",
        "CZ010": "Hlavní Mesto Praha",
        "CZ020": "Stredoceský Kraj",
        "CZ031": "Jihoceský Kraj",
        "CZ032": "Plzenský Kraj",
        "CZ041": "Karlovarský kraj",
        "CZ042": "Ústecký kraj",
        "CZ051": "Liberecký kraj",
        "CZ052": "Královéhradecký kraj",
        "CZ053": "Pardubický kraj",
        "CZ063": "Kraj Vysocina",
        "CZ064": "Jihomoravský kraj",
        "CZ071": "Olomoucký kraj",
        "CZ072": "Zlínský kraj",
        "CZ080": "Moravskoslezský kraj",
        "CZZZZ": "Extra-Regio NUTS 3",
        "DE111": "Stuttgart, Stadtkreis",
        "DE112": "Böblingen",
        "DE113": "Esslingen",
        "DE114": "Göppingen",
        "DE115": "Ludwigsburg",
        "DE116": "Rems-Murr-Kreis",
        "DE117": "Heilbronn, Stadtkreis",
        "DE118": "Heilbronn, Landkreis",
        "DE119": "Hohenlohekreis",
        "DE11A": "Schwäbisch Hall",
        "DE11B": "Main-Tauber-Kreis",
        "DE11C": "Heidenheim",
        "DE11D": "Ostalbkreis",
        "DE121": "Baden-Baden, Stadtkreis",
        "DE122": "Karlsruhe, Stadtkreis",
        "DE123": "Karlsruhe, Landkreis",
        "DE124": "Rastatt",
        "DE125": "Heidelberg, Stadtkreis",
        "DE126": "Mannheim, Stadtkreis",
        "DE127": "Neckar-Odenwald-Kreis",
        "DE128": "Rhein-Neckar-Kreis",
        "DE129": "Pforzheim, Stadtkreis",
        "DE12A": "Calw",
        "DE12B": "Enzkreis",
        "DE12C": "Freudenstadt",
        "DE131": "Freiburg im Breisgau, Stadtkreis",
        "DE132": "Breisgau-Hochschwarzwald",
        "DE133": "Emmendingen",
        "DE134": "Ortenaukreis",
        "DE135": "Rottweil",
        "DE136": "Schwarzwald-Baar-Kreis",
        "DE137": "Tuttlingen",
        "DE138": "Konstanz",
        "DE139": "Lörrach",
        "DE13A": "Waldshut",
        "DE141": "Reutlingen",
        "DE142": "Tübingen, Landkreis",
        "DE143": "Zollernalbkreis",
        "DE144": "Ulm, Stadtkreis",
        "DE145": "Alb-Donau-Kreis",
        "DE146": "Biberach",
        "DE147": "Bodenseekreis",
        "DE148": "Ravensburg",
        "DE149": "Sigmaringen",
        "DE211": "Ingolstadt, Kreisfreie Stadt",
        "DE212": "München, Kreisfreie Stadt",
        "DE213": "Rosenheim, Kreisfreie Stadt",
        "DE214": "Altötting",
        "DE215": "Berchtesgadener Land",
        "DE216": "Bad Tölz-Wolfratshausen",
        "DE217": "Dachau",
        "DE218": "Ebersberg",
        "DE219": "Eichstätt",
        "DE21A": "Erding",
        "DE21B": "Freising",
        "DE21C": "Fürstenfeldbruck",
        "DE21D": "Garmisch-Partenkirchen",
        "DE21E": "Landsberg am Lech",
        "DE21F": "Miesbach",
        "DE21G": "Mühldorf a. Inn",
        "DE21H": "München, Landkreis",
        "DE21I": "Neuburg-Schrobenhausen",
        "DE21J": "Pfaffenhofen a. d. Ilm",
        "DE21K": "Rosenheim, Landkreis",
        "DE21L": "Starnberg",
        "DE21M": "Traunstein",
        "DE21N": "Weilheim-Schongau",
        "DE221": "Landshut, Kreisfreie Stadt",
        "DE222": "Passau, Kreisfreie Stadt",
        "DE223": "Straubing, Kreisfreie Stadt",
        "DE224": "Deggendorf",
        "DE225": "Freyung-Grafenau",
        "DE226": "Kelheim",
        "DE227": "Landshut, Landkreis",
        "DE228": "Passau, Landkreis",
        "DE229": "Regen",
        "DE22A": "Rottal-Inn",
        "DE22B": "Straubing-Bogen",
        "DE22C": "Dingolfing-Landau",
        "DE231": "Amberg, Kreisfreie Stadt",
        "DE232": "Regensburg, Kreisfreie Stadt",
        "DE233": "Weiden i. d. Opf, Kreisfreie Stadt",
        "DE234": "Amberg-Sulzbach",
        "DE235": "Cham",
        "DE236": "Neumarkt i. d. OPf.",
        "DE237": "Neustadt a. d. Waldnaab",
        "DE238": "Regensburg, Landkreis",
        "DE239": "Schwandorf",
        "DE23A": "Tirschenreuth",
        "DE241": "Bamberg, Kreisfreie Stadt",
        "DE242": "Bayreuth, Kreisfreie Stadt",
        "DE243": "Coburg, Kreisfreie Stadt",
        "DE244": "Hof, Kreisfreie Stadt",
        "DE245": "Bamberg, Landkreis",
        "DE246": "Bayreuth, Landkreis",
        "DE247": "Coburg, Landkreis",
        "DE248": "Forchheim",
        "DE249": "Hof, Landkreis",
        "DE24A": "Kronach",
        "DE24B": "Kulmbach",
        "DE24C": "Lichtenfels",
        "DE24D": "Wunsiedel i. Fichtelgebirge",
        "DE251": "Ansbach, Kreisfreie Stadt",
        "DE252": "Erlangen, Kreisfreie Stadt",
        "DE253": "Fürth, Kreisfreie Stadt",
        "DE254": "Nürnberg, Kreisfreie Stadt",
        "DE255": "Schwabach, Kreisfreie Stadt",
        "DE256": "Ansbach, Landkreis",
        "DE257": "Erlangen-Höchstadt",
        "DE258": "Fürth, Landkreis",
        "DE259": "Nürnberger Land",
        "DE25A": "Neustadt a. d. Aisch-Bad Windsheim",
        "DE25B": "Roth",
        "DE25C": "Weißenburg-Gunzenhausen",
        "DE261": "Aschaffenburg, Kreisfreie Stadt",
        "DE262": "Schweinfurt, Kreisfreie Stadt",
        "DE263": "Würzburg, Kreisfreie Stadt",
        "DE264": "Aschaffenburg, Landkreis",
        "DE265": "Bad Kissingen",
        "DE266": "Rhön-Grabfeld",
        "DE267": "Haßberge",
        "DE268": "Kitzingen",
        "DE269": "Miltenberg",
        "DE26A": "Main-Spessart",
        "DE26B": "Schweinfurt, Landkreis",
        "DE26C": "Würzburg, Landkreis",
        "DE271": "Augsburg, Kreisfreie Stadt",
        "DE272": "Kaufbeuren, Kreisfreie Stadt",
        "DE273": "Kempten (Allgäu), Kreisfreie Stadt",
        "DE274": "Memmingen, Kreisfreie Stadt",
        "DE275": "Aichach-Friedberg",
        "DE276": "Augsburg, Landkreis",
        "DE277": "Dillingen a.d. Donau",
        "DE278": "Günzburg",
        "DE279": "Neu-Ulm",
        "DE27A": "Lindau (Bodensee)",
        "DE27B": "Ostallgäu",
        "DE27C": "Unterallgäu",
        "DE27D": "Donau-Ries",
        "DE27E": "Oberallgäu",
        "DE300": "Berlin",
        "DE401": "Brandenburg an der Havel, Kreisfreie Stadt",
        "DE402": "Cottbus, Kreisfreie Stadt",
        "DE403": "Frankfurt (Oder), Kreisfreie Stadt",
        "DE404": "Potsdam, Kreisfreie Stadt",
        "DE405": "Barnim",
        "DE406": "Dahme-Spreewald",
        "DE407": "Elbe-Elster",
        "DE408": "Havelland",
        "DE409": "Märkisch-Oderland",
        "DE40A": "Oberhavel",
        "DE40B": "Oberspreewald-Lausitz",
        "DE40C": "Oder-Spree",
        "DE40D": "Ostprignitz-Ruppin",
        "DE40E": "Potsdam-Mittelmark",
        "DE40F": "Prignitz",
        "DE40G": "Spree-Neiße",
        "DE40H": "Teltow-Fläming",
        "DE40I": "Uckermark",
        "DE501": "Bremen, Kreisfreie Stadt",
        "DE502": "Bremerhaven, Kreisfreie Stadt",
        "DE600": "Hamburg",
        "DE711": "Darmstadt, Kreisfreie Stadt",
        "DE712": "Frankfurt am Main, Kreisfreie Stadt",
        "DE713": "Offenbach am Main, Kreisfreie Stadt",
        "DE714": "Wiesbaden, Kreisfreie Stadt",
        "DE715": "Bergstraße",
        "DE716": "Darmstadt-Dieburg",
        "DE717": "Groß-Gerau",
        "DE718": "Hochtaunuskreis",
        "DE719": "Main-Kinzig-Kreis",
        "DE71A": "Main-Taunus-Kreis",
        "DE71B": "Odenwaldkreis",
        "DE71C": "Offenbach, Landkreis",
        "DE71D": "Rheingau-Taunus-Kreis",
        "DE71E": "Wetteraukreis",
        "DE721": "Gießen, Landkreis",
        "DE722": "Lahn-Dill-Kreis",
        "DE723": "Limburg-Weilburg",
        "DE724": "Marburg-Biedenkopf",
        "DE725": "Vogelsbergkreis",
        "DE731": "Kassel, Kreisfreie Stadt",
        "DE732": "Fulda",
        "DE733": "Hersfeld-Rotenburg",
        "DE734": "Kassel, Landkreis",
        "DE735": "Schwalm-Eder-Kreis",
        "DE736": "Waldeck-Frankenberg",
        "DE737": "Werra-Meißner-Kreis",
        "DE803": "Rostock, Kreisfreie Stadt",
        "DE804": "Schwerin, Kreisfreie Stadt",
        "DE80J": "Mecklenburgische Seenplatte",
        "DE80K": "Landkreis Rostock",
        "DE80L": "Vorpommern-Rügen",
        "DE80M": "Nordwestmecklenburg",
        "DE80N": "Vorpommern-Greifswald",
        "DE80O": "Ludwigslust-Parchim",
        "DE911": "Braunschweig, Kreisfreie Stadt",
        "DE912": "Salzgitter, Kreisfreie Stadt",
        "DE913": "Wolfsburg, Kreisfreie Stadt",
        "DE914": "Gifhorn",
        "DE916": "Goslar",
        "DE917": "Helmstedt",
        "DE918": "Northeim",
        "DE91A": "Peine",
        "DE91B": "Wolfenbüttel",
        "DE91C": "Göttingen",
        "DE922": "Diepholz",
        "DE923": "Hameln-Pyrmont",
        "DE925": "Hildesheim",
        "DE926": "Holzminden",
        "DE927": "Nienburg (Weser)",
        "DE928": "Schaumburg",
        "DE929": "Region Hannover",
        "DE931": "Celle",
        "DE932": "Cuxhaven",
        "DE933": "Harburg",
        "DE934": "Lüchow-Dannenberg",
        "DE935": "Lüneburg, Landkreis",
        "DE936": "Osterholz",
        "DE937": "Rotenburg (Wümme)",
        "DE938": "Soltau-Fallingbostel",
        "DE939": "Stade",
        "DE93A": "Uelzen",
        "DE93B": "Verden",
        "DE941": "Delmenhorst, Kreisfreie Stadt",
        "DE942": "Emden, Kreisfreie Stadt",
        "DE943": "Oldenburg (Oldenburg), Kreisfreie Stadt",
        "DE944": "Osnabrück, Kreisfreie Stadt",
        "DE945": "Wilhelmshaven, Kreisfreie Stadt",
        "DE946": "Ammerland",
        "DE947": "Aurich",
        "DE948": "Cloppenburg",
        "DE949": "Emsland",
        "DE94A": "Friesland (DE)",
        "DE94B": "Grafschaft Bentheim",
        "DE94C": "Leer",
        "DE94D": "Oldenburg, Landkreis",
        "DE94E": "Osnabrück, Landkreis",
        "DE94F": "Vechta",
        "DE94G": "Wesermarsch",
        "DE94H": "Wittmund",
        "DEA11": "Düsseldorf, Kreisfreie Stadt",
        "DEA12": "Duisburg, Kreisfreie Stadt",
        "DEA13": "Essen, Kreisfreie Stadt",
        "DEA14": "Krefeld, Kreisfreie Stadt",
        "DEA15": "Mönchengladbach, Kreisfreie Stadt",
        "DEA16": "Mülheim an der Ruhr,Kreisfreie Stadt",
        "DEA17": "Oberhausen, Kreisfreie Stadt",
        "DEA18": "Remscheid, Kreisfreie Stadt",
        "DEA19": "Solingen, Kreisfreie Stadt",
        "DEA1A": "Wuppertal, Kreisfreie Stadt",
        "DEA1B": "Kleve",
        "DEA1C": "Mettmann",
        "DEA1D": "Rhein-Kreis Neuss",
        "DEA1E": "Viersen",
        "DEA1F": "Wesel",
        "DEA22": "Bonn, Kreisfreie Stadt",
        "DEA23": "Köln, Kreisfreie Stadt",
        "DEA24": "Leverkusen, Kreisfreie Stadt",
        "DEA26": "Düren",
        "DEA27": "Rhein-Erft-Kreis",
        "DEA28": "Euskirchen",
        "DEA29": "Heinsberg",
        "DEA2A": "Oberbergischer Kreis",
        "DEA2B": "Rheinisch-Bergischer Kreis",
        "DEA2C": "Rhein-Sieg-Kreis",
        "DEA2D": "Städteregion Aachen",
        "DEA31": "Bottrop, Kreisfreie Stadt",
        "DEA32": "Gelsenkirchen, Kreisfreie Stadt",
        "DEA33": "Münster, Kreisfreie Stadt",
        "DEA34": "Borken",
        "DEA35": "Coesfeld",
        "DEA36": "Recklinghausen",
        "DEA37": "Steinfurt",
        "DEA38": "Warendorf",
        "DEA41": "Bielefeld, Kreisfreie Stadt",
        "DEA42": "Gütersloh",
        "DEA43": "Herford",
        "DEA44": "Höxter",
        "DEA45": "Lippe",
        "DEA46": "Minden-Lübbecke",
        "DEA47": "Paderborn",
        "DEA51": "Bochum, Kreisfreie Stadt",
        "DEA52": "Dortmund, Kreisfreie Stadt",
        "DEA53": "Hagen, Kreisfreie Stadt",
        "DEA54": "Hamm, Kreisfreie Stadt",
        "DEA55": "Herne, Kreisfreie Stadt",
        "DEA56": "Ennepe-Ruhr-Kreis",
        "DEA57": "Hochsauerlandkreis",
        "DEA58": "Märkischer Kreis",
        "DEA59": "Olpe",
        "DEA5A": "Siegen-Wittgenstein",
        "DEA5B": "Soest",
        "DEA5C": "Unna",
        "DEB11": "Koblenz, Kreisfreie Stadt",
        "DEB12": "Ahrweiler",
        "DEB13": "Altenkirchen (Westerwald)",
        "DEB14": "Bad Kreuznach",
        "DEB15": "Birkenfeld",
        "DEB17": "Mayen-Koblenz",
        "DEB18": "Neuwied",
        "DEB1A": "Rhein-Lahn-Kreis",
        "DEB1B": "Westerwaldkreis",
        "DEB1C": "Cochem-Zell",
        "DEB1D": "Rhein-Hunsrück-Kreis",
        "DEB21": "Trier, Kreisfreie Stadt",
        "DEB22": "Bernkastel-Wittlich",
        "DEB23": "Eifelkreis Bitburg-Prüm",
        "DEB24": "Vulkaneifel",
        "DEB25": "Trier-Saarburg",
        "DEB31": "Frankenthal (Pfalz), Kreisfreie Stadt",
        "DEB32": "Kaiserslautern, Kreisfreie Stadt",
        "DEB33": "Landau in der Pfalz, Kreisfreie Stadt",
        "DEB34": "Ludwigshafen am Rhein, Kreisfreie Stadt",
        "DEB35": "Mainz, Kreisfreie Stadt",
        "DEB36": "Neustadt an der Weinstraße, Kreisfreie Stadt",
        "DEB37": "Pirmasens, Kreisfreie Stadt",
        "DEB38": "Speyer, Kreisfreie Stadt",
        "DEB39": "Worms, Kreisfreie Stadt",
        "DEB3A": "Zweibrücken, Kreisfreie Stadt",
        "DEB3B": "Alzey-Worms",
        "DEB3C": "Bad Dürkheim",
        "DEB3D": "Donnersbergkreis",
        "DEB3E": "Germersheim",
        "DEB3F": "Kaiserslautern, Landkreis",
        "DEB3G": "Kusel",
        "DEB3H": "Südliche Weinstraße",
        "DEB3I": "Rhein-Pfalz-Kreis",
        "DEB3J": "Mainz-Bingen",
        "DEB3K": "Südwestpfalz",
        "DEC01": "Regionalverband Saarbrücken",
        "DEC02": "Merzig-Wadern",
        "DEC03": "Neunkirchen",
        "DEC04": "Saarlouis",
        "DEC05": "Saarpfalz-Kreis",
        "DEC06": "St. Wendel",
        "DED21": "Dresden, Kreisfreie Stadt",
        "DED2C": "Bautzen",
        "DED2D": "Görlitz",
        "DED2E": "Meißen",
        "DED2F": "Sächsische Schweiz-Osterzgebirge",
        "DED41": "Chemnitz, Kreisfreie Stadt",
        "DED42": "Erzgebirgskreis",
        "DED43": "Mittelsachsen",
        "DED44": "Vogtlandkreis",
        "DED45": "Zwichau",
        "DED51": "Leipzig, Kreisfreie Stadt",
        "DED52": "Leipzig",
        "DED53": "Nordsachsen",
        "DEE01": "Dessau-Roßlau, Kreisfreie Stadt",
        "DEE02": "Halle (Saale), Kreisfreie Stadt",
        "DEE03": "Magdeburg, Kreisfreie Stadt",
        "DEE04": "Altmarkkreis Salzwedel",
        "DEE05": "Anhalt-Bitterfeld",
        "DEE06": "Jerichower Land",
        "DEE07": "Börde",
        "DEE08": "Burgenland (DE)",
        "DEE09": "Harz",
        "DEE0A": "Mansfeld-Südharz",
        "DEE0B": "Saalekreis",
        "DEE0C": "Salzlandkreis",
        "DEE0D": "Stendal",
        "DEE0E": "Wittenberg",
        "DEF01": "Flensburg, Kreisfreie Stadt",
        "DEF02": "Kiel, Kreisfreie Stadt",
        "DEF03": "Lübeck, Kreisfreie Stadt",
        "DEF04": "Neumünster, Kreisfreie Stadt",
        "DEF05": "Dithmarschen",
        "DEF06": "Herzogtum Lauenburg",
        "DEF07": "Nordfriesland",
        "DEF08": "Ostholstein",
        "DEF09": "Pinneberg",
        "DEF0A": "Plön",
        "DEF0B": "Rendsburg-Eckernförde",
        "DEF0C": "Schleswig-Flensburg",
        "DEF0D": "Segeberg",
        "DEF0E": "Steinburg",
        "DEF0F": "Stormarn",
        "DEG01": "Erfurt, Kreisfreie Stadt",
        "DEG02": "Gera, Kreisfreie Stadt",
        "DEG03": "Jena, Kreisfreie Stadt",
        "DEG04": "Suhl, Kreisfreie Stadt",
        "DEG05": "Weimar, Kreisfreie Stadt",
        "DEG06": "Eichsfeld",
        "DEG07": "Nordhausen",
        "DEG09": "Unstrut-Hainich-Kreis",
        "DEG0A": "Kyffhäuserkreis",
        "DEG0B": "Schmalkalden-Meiningen",
        "DEG0C": "Gotha",
        "DEG0D": "Sömmerda",
        "DEG0E": "Hildburghausen",
        "DEG0F": "Ilm-Kreis",
        "DEG0G": "Weimarer Land",
        "DEG0H": "Sonneberg",
        "DEG0I": "Saalfeld-Rudolstadt",
        "DEG0J": "Saale-Holzland-Kreis",
        "DEG0K": "Saale-Orla-Kreis",
        "DEG0L": "Greiz",
        "DEG0M": "Altenburger Land",
        "DEG0N": "Eisenach, Kreisfreie Stadt",
        "DEG0P": "Wartburgkreis",
        "DEZZZ": "Extra-Regio NUTS 3",
        "DJ": "Djibouti",
        "DK011": "Byen København",
        "DK012": "Københavns omegn",
        "DK013": "Nordsjælland",
        "DK014": "Bornholm",
        "DK021": "Østsjælland",
        "DK022": "Vest- og Sydsjælland",
        "DK031": "Fyn",
        "DK032": "Sydjylland",
        "DK041": "Vestjylland",
        "DK042": "Østjylland",
        "DK050": "Nordjylland",
        "DKZZZ": "Extra-Regio NUTS 3",
        "DM": "Dominica",
        "DO": "Dominican Republic (the)",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE001": "Põhja-Eesti",
        "EE004": "Lääne-Eesti",
        "EE006": "Kesk-Eesti",
        "EE007": "Kirde-Eesti",
        "EE008": "Lõuna-Eesti",
        "EEZZZ": "Extra-Regio NUTS 3",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "EL301": "Voreios Tomeas Athinon",
        "EL302": "Dytikos Tomeas Athinon",
        "EL303": "Kentrikos Tomeas Athinon",
        "EL304": "Notios Tomeas Athinon",
        "EL305": "Anatoliki Attiki",
        "EL306": "Dytiki Attiki",
        "EL307": "Peiraias, Nisoi",
        "EL411": "Lesvos",
        "EL412": "Samos",
        "EL413": "Chios",
        "EL421": "Dodekanisos",
        "EL422": "Kyklades",
        "EL431": "Irakleio",
        "EL432": "Lasithi",
        "EL433": "Rethymni",
        "EL434": "Chania",
        "EL511": "Evros",
        "EL512": "Xanthi",
        "EL513": "Rodopi",
        "EL514": "Drama",
        "EL515": "Thasos, Kavala",
        "EL521": "Imathia",
        "EL522": "Thessaloniki",
        "EL523": "Kilkis",
        "EL524": "Pella",
        "EL525": "Pieria",
        "EL526": "Serres",
        "EL527": "Chalkidiki",
        "EL531": "Grevena, Kozani",
        "EL532": "Kastoria",
        "EL533": "Florina",
        "EL541": "Arta, Preveza",
        "EL542": "Thesprotia",
        "EL543": "Ioannina",
        "EL611": "Karditsa, Trikala",
        "EL612": "Larisa",
        "EL613": "Magnisia, Sporades",
        "EL621": "Zakynthos",
        "EL622": "Kerkyra",
        "EL623": "Ithaki, Kefallinia",
        "EL624": "Lefkada",
        "EL631": "Aitoloakarnania",
        "EL632": "Achaia",
        "EL633": "Ileia",
        "EL641": "Voiotia",
        "EL642": "Evvoia",
        "EL643": "Evrytania",
        "EL644": "Fthiotida",
        "EL645": "Fokida",
        "EL651": "Argolida, Arkadia",
        "EL652": "Korinthia",
        "EL653": "lakonia, Messinia",
        "ELZZZ": "Extra-Regio NUTS 3",
        "ER": "Eritrea",
        "ES111": "A Coruña",
        "ES112": "Lugo",
        "ES113": "Ourense",
        "ES114": "Pontevedra",
        "ES120": "Asturias",
        "ES130": "Cantabria",
        "ES211": "Álava",
        "ES212": "Guipúzcoa",
        "ES213": "Vizcaya",
        "ES220": "Navarra",
        "ES230": "La Rioja",
        "ES241": "Huesca",
        "ES242": "Teruel",
        "ES243": "Zaragoza",
        "ES300": "Madrid",
        "ES411": "Ávila",
        "ES412": "Burgos",
        "ES413": "León",
        "ES414": "Palencia",
        "ES415": "Salamanca",
        "ES416": "Segovia",
        "ES417": "Soria",
        "ES418": "Valladolid",
        "ES419": "Zamora",
        "ES421": "Albacete",
        "ES422": "Ciudad Real",
        "ES423": "Cuenca",
        "ES424": "Guadalajara",
        "ES425": "Toledo",
        "ES431": "Badajoz",
        "ES432": "Cáceres",
        "ES511": "Barcelona",
        "ES512": "Girona",
        "ES513": "Lleida",
        "ES514": "Tarragona",
        "ES521": "Alicante / Alacant",
        "ES522": "Castellón / Castelló",
        "ES523": "Valencia / València",
        "ES531": "Eivissa y Formentera",
        "ES532": "Mallorca",
        "ES533": "Menorca",
        "ES611": "Almería",
        "ES612": "Cádiz",
        "ES613": "Córdoba",
        "ES614": "Granada",
        "ES615": "Huelva",
        "ES616": "Jaén",
        "ES617": "Málaga",
        "ES618": "Sevilla",
        "ES620": "Murcia",
        "ES630": "Ceuta",
        "ES640": "Melilla",
        "ES703": "El Hierro",
        "ES704": "Fuerteventura",
        "ES705": "Gran Canaria",
        "ES706": "La Gomera",
        "ES707": "La Palma",
        "ES708": "Lanzarote",
        "ES709": "Tenerife",
        "ESZZZ": "Extra-Regio NUTS 3",
        "ET": "Ethiopia",
        "FI193": "Keski-Suomi",
        "FI194": "Etelä-Pohjanmaa",
        "FI195": "Pohjanmaa",
        "FI196": "Satakunta",
        "FI197": "Pirkanmaa",
        "FI1B1": "Helsinki-Uusimaa",
        "FI1C1": "Varsinais-Suomi",
        "FI1C2": "Kanta-Häme",
        "FI1C3": "Päijät-Häme",
        "FI1C4": "Kymenlaakso",
        "FI1C5": "Etelä-Karjala",
        "FI1D1": "Etelä-Savo",
        "FI1D2": "Pohjois-Savo",
        "FI1D3": "Pohjois-Karjala",
        "FI1D5": "Keski-Pohjanmaa",
        "FI1D7": "Lappi",
        "FI1D8": "Kainuu",
        "FI1D9": "Pohjois-Pohjanmaa",
        "FI200": "Åland",
        "FIZZZ": "Extra-Regio NUTS 3",
        "FJ": "Fiji",
        "FK": "Falkland Islands (the) [Malvinas]",
        "FM": "Micronesia (Federated States of)",
        "FO": "Faroe Islands (the)",
        "FR101": "Paris",
        "FR102": "Seine-et-Marne",
        "FR103": "Yvelines",
        "FR104": "Essonne",
        "FR105": "Hauts-de-Seine",
        "FR106": "Seine-Saint-Denis",
        "FR107": "Val-de-Marne",
        "FR108": "Val-d''Oise",
        "FRB01": "Cher",
        "FRB02": "Eure-et-Loir",
        "FRB03": "Indre",
        "FRB04": "Indre-et-Loire",
        "FRB05": "Loir-et-Cher",
        "FRB06": "Loiret",
        "FRC11": "Côte-d’Or",
        "FRC12": "Nièvre",
        "FRC13": "Saône-et-Loire",
        "FRC14": "Yonne",
        "FRC21": "Doubs",
        "FRC22": "Jura",
        "FRC23": "Haute-Saône",
        "FRC24": "Territoire de Belfort",
        "FRD11": "Calvados",
        "FRD12": "Manche",
        "FRD13": "Orne",
        "FRD21": "Eure",
        "FRD22": "Seine-Maritime",
        "FRE11": "Nord",
        "FRE12": "Pas-de-Calais",
        "FRE21": "Aisne",
        "FRE22": "Oise",
        "FRE23": "Somme",
        "FRF11": "Bas-Rhin",
        "FRF12": "Haut-Rhin",
        "FRF21": "Ardennes",
        "FRF22": "Aube",
        "FRF23": "Marne",
        "FRF24": "Haute-Marne",
        "FRF31": "Meurthe-et-Moselle",
        "FRF32": "Meuse",
        "FRF33": "Moselle",
        "FRF34": "Vosges",
        "FRG01": "Loire-Atlantique",
        "FRG02": "Maine-et-Loire",
        "FRG03": "Mayenne",
        "FRG04": "Sarthe",
        "FRG05": "Vendée",
        "FRH01": "Côtes-d’Armor",
        "FRH02": "Finistère",
        "FRH03": "Ille-et-Vilaine",
        "FRH04": "Morbihan",
        "FRI11": "Dordogne",
        "FRI12": "Gironde",
        "FRI13": "Landes",
        "FRI14": "Lot-et-Garonne",
        "FRI15": "Pyrénées-Atlantiques",
        "FRI21": "Corrèze",
        "FRI22": "Creuse",
        "FRI23": "Haute-Vienne",
        "FRI31": "Charente",
        "FRI32": "Charente-Maritime",
        "FRI33": "Deux-Sèvres",
        "FRI34": "Vienne",
        "FRJ11": "Aude",
        "FRJ12": "Gard",
        "FRJ13": "Hérault",
        "FRJ14": "Lozère",
        "FRJ15": "Pyrénées-Orientales",
        "FRJ21": "Ariège",
        "FRJ22": "Aveyron",
        "FRJ23": "Haute-Garonne",
        "FRJ24": "Gers",
        "FRJ25": "Lot",
        "FRJ26": "Hautes-Pyrénées",
        "FRJ27": "Tarn",
        "FRJ28": "Tarn-et-Garonne",
        "FRK11": "Allier",
        "FRK12": "Cantal",
        "FRK13": "Haute-Loire",
        "FRK14": "Puy-de-Dôme",
        "FRK21": "Ain",
        "FRK22": "Ardèche",
        "FRK23": "Drôme",
        "FRK24": "Isère",
        "FRK25": "Loire",
        "FRK26": "Rhône",
        "FRK27": "Savoie",
        "FRK28": "Haute-Savoie",
        "FRL01": "Alpes-de-Haute-Provence",
        "FRL02": "Hautes-Alpes",
        "FRL03": "Alpes-Maritimes",
        "FRL04": "Bouches-du-Rhône",
        "FRL05": "Var",
        "FRL06": "Vaucluse",
        "FRM01": "Corse-du-Sud",
        "FRM02": "Haute-Corse",
        "FRY10": "Guadeloupe",
        "FRY20": "Martinique",
        "FRY30": "Guyane",
        "FRY40": "La Réunion",
        "FRY50": "Mayotte",
        "FRZZZ": "Extra-Regio NUTS 3",
        "GA": "Gabon",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia (the)",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GS": "South Georgia and the South Sandwich Islands",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HM": "Heard Island and McDonald Islands",
        "HN": "Honduras",
        "HR031": "Primorsko-goranska županija",
        "HR032": "Licko-senjska Županija",
        "HR033": "Zadarska županija",
        "HR034": "Šibensko-kninska županija",
        "HR035": "Splitsko-dalmatinska županija",
        "HR036": "Istarska županija",
        "HR037": "Dubrovacko-neretvanska Županija",
        "HR041": "Grad Zagreb",
        "HR042": "Zagrebacka Županija",
        "HR043": "Krapinsko-zagorska županija",
        "HR044": "Varaždinska županija",
        "HR045": "Koprivnicko-križevacka Županija",
        "HR046": "Medimurska Županija",
        "HR047": "Bjelovarsko-bilogorska županija",
        "HR048": "Viroviticko-podravska Županija",
        "HR049": "Požeško-slavonska županija",
        "HR04A": "Brodsko-posavska županija",
        "HR04B": "Osjecko-baranjska Županija",
        "HR04C": "Vukovarsko-srijemska županija",
        "HR04D": "Karlovacka Županija",
        "HR04E": "Sisacko-moslavacka Županija",
        "HRZZZ": "Extra-Regio NUTS 3",
        "HT": "Haiti",
        "HU110": "Budapest",
        "HU120": "Pest",
        "HU211": "Fejér",
        "HU212": "Komárom-Esztergom",
        "HU213": "Veszprém",
        "HU221": "Gyor-moson-sopron",
        "HU222": "Vas",
        "HU223": "Zala",
        "HU231": "Baranya",
        "HU232": "Somogy",
        "HU233": "Tolna",
        "HU311": "Borsod-Abaúj-Zemplén",
        "HU312": "Heves",
        "HU313": "Nógrád",
        "HU321": "Hajdú-Bihar",
        "HU322": "Jász-Nagykun-Szolnok",
        "HU323": "Szabolcs-Szatmár-Bereg",
        "HU331": "Bács-Kiskun",
        "HU332": "Békés",
        "HU333": "Csongrád",
        "HUZZZ": "Extra-Regio NUTS 3",
        "ID": "Indonesia",
        "IE041": "Border",
        "IE042": "West",
        "IE051": "Mid-West",
        "IE052": "South-East",
        "IE053": "South-West",
        "IE061": "Dublin",
        "IE062": "Mid-East",
        "IE063": "Midland",
        "IEZZZ": "Extra-Regio NUTS 3",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory (the)",
        "IQ": "Iraq",
        "IR": "Iran (Islamic Republic of)",
        "IS": "Iceland",
        "ITC11": "Torino",
        "ITC12": "Vercelli",
        "ITC13": "Biella",
        "ITC14": "Verbano-Cusio-Ossola",
        "ITC15": "Novara",
        "ITC16": "Cuneo",
        "ITC17": "Asti",
        "ITC18": "Alessandria",
        "ITC20": "Valle d''Aosta/Vallée d''Aoste",
        "ITC31": "Imperia",
        "ITC32": "Savona",
        "ITC33": "Genova",
        "ITC34": "La Spezia",
        "ITC41": "Varese",
        "ITC42": "Como",
        "ITC43": "Lecco",
        "ITC44": "Sondrio",
        "ITC46": "Bergamo",
        "ITC47": "Brescia",
        "ITC48": "Pavia",
        "ITC49": "Lodi",
        "ITC4A": "Cremona",
        "ITC4B": "Mantova",
        "ITC4C": "Milano",
        "ITC4D": "Monza e della Brianza",
        "ITF11": "L''Aquila",
        "ITF12": "Teramo",
        "ITF13": "Pescara",
        "ITF14": "Chieti",
        "ITF21": "Isernia",
        "ITF22": "Campobasso",
        "ITF31": "Caserta",
        "ITF32": "Benevento",
        "ITF33": "Napoli",
        "ITF34": "Avellino",
        "ITF35": "Salerno",
        "ITF43": "Taranto",
        "ITF44": "Brindisi",
        "ITF45": "Lecce",
        "ITF46": "Foggia",
        "ITF47": "Bari",
        "ITF48": "Barletta-Andria-Trani",
        "ITF51": "Potenza",
        "ITF52": "Matera",
        "ITF61": "Cosenza",
        "ITF62": "Crotone",
        "ITF63": "Catanzaro",
        "ITF64": "Vibo Valentia",
        "ITF65": "Reggio di Calabria",
        "ITG11": "Trapani",
        "ITG12": "Palermo",
        "ITG13": "Messina",
        "ITG14": "Agrigento",
        "ITG15": "Caltanissetta",
        "ITG16": "Enna",
        "ITG17": "Catania",
        "ITG18": "Ragusa",
        "ITG19": "Siracusa",
        "ITG25": "Sassari",
        "ITG26": "Nuoro",
        "ITG27": "Cagliari",
        "ITG28": "Oristano",
        "ITG29": "Olbia-Tempio",
        "ITG2A": "Ogliastra",
        "ITG2B": "Medio Campidano",
        "ITG2C": "Carbonia-Iglesias",
        "ITH10": "Bolzano-Bozen",
        "ITH20": "Trento",
        "ITH31": "Verona",
        "ITH32": "Vicenza",
        "ITH33": "Belluno",
        "ITH34": "Treviso",
        "ITH35": "Venezia",
        "ITH36": "Padova",
        "ITH37": "Rovigo",
        "ITH41": "Pordenone",
        "ITH42": "Udine",
        "ITH43": "Gorizia",
        "ITH44": "Trieste",
        "ITH51": "Piacenza",
        "ITH52": "Parma",
        "ITH53": "Reggio nell''Emilia",
        "ITH54": "Modena",
        "ITH55": "Bologna",
        "ITH56": "Ferrara",
        "ITH57": "Ravenna",
        "ITH58": "Forlì-Cesena",
        "ITH59": "Rimini",
        "ITI11": "Massa-Carrara",
        "ITI12": "Lucca",
        "ITI13": "Pistoia",
        "ITI14": "Firenze",
        "ITI15": "Prato",
        "ITI16": "Livorno",
        "ITI17": "Pisa",
        "ITI18": "Arezzo",
        "ITI19": "Siena",
        "ITI1A": "Grosseto",
        "ITI21": "Perugia",
        "ITI22": "Terni",
        "ITI31": "Pesaro e Urbino",
        "ITI32": "Ancona",
        "ITI33": "Macerata",
        "ITI34": "Ascoli Piceno",
        "ITI35": "Fermo",
        "ITI41": "Viterbo",
        "ITI42": "Rieti",
        "ITI43": "Roma",
        "ITI44": "Latina",
        "ITI45": "Frosinone",
        "ITZZZ": "Extra-Regio NUTS 3",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros (the)",
        "KN": "Saint Kitts and Nevis",
        "KP": "Korea (the Democratic People's Republic of)",
        "KR": "Korea (the Republic of)",
        "KW": "Kuwait",
        "KY": "Cayman Islands (the)",
        "KZ": "Kazakhstan",
        "LA": "Lao People's Democratic Republic (the)",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT011A": "Vilnius",
        "LT011B": "Vilniaus apskritis, išskyrus Vilnių",
        "LT021A": "Alytus",
        "LT021B": "Alytaus apskritis, išskyrus Alytų",
        "LT022A": "Kaunas",
        "LT022B": "Kauno apskritis, išskyrus Kauną",
        "LT023A": "Klaipėda",
        "LT023B": "Klaipėdos apskritis, išskyrus Klaipėdą",
        "LT024A": "Marijampolė",
        "LT024B": "Marijampolės apskritis, išskyrus Marijampolę",
        "LT025A": "Panevėžys",
        "LT025B": "Panevėžio apskritis, išskyrus Panevėžį",
        "LT026A": "Šiauliai",
        "LT026B": "Šiaulių apskritis, išskyrus Šiaulius",
        "LT027A": "Tauragė",
        "LT027B": "Tauragės apskritis, išskyrus Tauragę",
        "LT028A": "Telšiai",
        "LT028B": "Telšių apskritis, išskyrus Telšius",
        "LT029A": "Utena",
        "LT029B": "Utenos apskritis, išskyrus Uteną",
        "LTZZZ": "Extra-Regio NUTS 3",
        "LU000": "Luxembourg",
        "LUZZZ": "Extra-Regio NUTS 3",
        "LV003": "Kurzeme",
        "LV005": "Latgale",
        "LV006": "Riga",
        "LV007": "Pieriga",
        "LV008": "Vidzeme",
        "LV009": "Zemgale",
        "LVZZZ": "Extra-Regio NUTS 3",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova (the Republic of)",
        "ME": "Montenegro",
        "MF": "Saint Martin (French part)",
        "MG": "Madagascar",
        "MH": "Marshall Islands (the)",
        "MK": "Macedonia (the former Yugoslav Republic of)",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macao",
        "MP": "Northern Mariana Islands (the)",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT001": "Malta",
        "MT002": "Gozo And CominoGhawdex U Kemmuna",
        "MTZZZ": "Extra-Regio NUTS 3",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger (the)",
        "NF": "Norfolk Island",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL111": "Oost-Groningen",
        "NL112": "Delfzijl en omgeving",
        "NL113": "Overig Groningen",
        "NL124": "Noord-Friesland",
        "NL125": "Zuidwest-Friesland",
        "NL126": "Zuidoost-Friesland",
        "NL131": "Noord-Drenthe",
        "NL132": "Zuidoost-Drenthe",
        "NL133": "Zuidwest-Drenthe",
        "NL211": "Noord-Overijssel",
        "NL212": "Zuidwest-Overijssel",
        "NL213": "Twente",
        "NL221": "Veluwe",
        "NL224": "Zuidwest-Gelderland",
        "NL225": "Achterhoek",
        "NL226": "Arnhem/Nijmegen",
        "NL230": "Flevoland",
        "NL310": "Utrecht",
        "NL321": "Kop van Noord-Holland",
        "NL323": "IJmond",
        "NL324": "Agglomeratie Haarlem",
        "NL325": "Zaanstreek",
        "NL327": "Het Gooi en Vechtstreek",
        "NL328": "Alkmaar en omgeving",
        "NL329": "Groot-Amsterdam",
        "NL332": "Agglomeratie ''s-Gravenhage",
        "NL333": "Delft en Westland",
        "NL337": "Agglomeratie Leiden en Bollenstreek",
        "NL33A": "Zuidoost-Zuid-Holland",
        "NL33B": "Oost-Zuid-Holland",
        "NL33C": "Groot-Rijnmond",
        "NL341": "Zeeuwsch-Vlaanderen",
        "NL342": "Overig Zeeland",
        "NL411": "West-Noord-Brabant",
        "NL412": "Midden-Noord-Brabant",
        "NL413": "Noordoost-Noord-Brabant",
        "NL414": "Zuidoost-Noord-Brabant",
        "NL421": "Noord-Limburg",
        "NL422": "Midden-Limburg",
        "NL423": "Zuid-Limburg",
        "NLZZZ": "Extra-Regio NUTS 3",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines (the)",
        "PK": "Pakistan",
        "PL127": "Miasto Warszawa",
        "PL129": "Warszawski-wschodni",
        "PL12A": "Warszawski-zachodni",
        "PL213": "Miasto Kraków",
        "PL214": "Krakowski",
        "PL217": "Tarnowski",
        "PL218": "Nowosadecki",
        "PL219": "Nowotarski",
        "PL21A": "Oswiecimski",
        "PL224": "Czestochowski",
        "PL225": "Bielski",
        "PL227": "Rybnicki",
        "PL228": "Bytomski",
        "PL229": "Gliwicki",
        "PL22A": "Katowicki",
        "PL22B": "Sosnowiecki",
        "PL22C": "Tyski",
        "PL411": "Pilski",
        "PL414": "Koninski",
        "PL415": "Miasto Poznan",
        "PL416": "Kaliski",
        "PL417": "Leszczynski",
        "PL418": "Poznanski",
        "PL424": "Miasto Szczecin",
        "PL426": "Koszalinski",
        "PL427": "Szczecinecko-pyrzycki",
        "PL428": "Szczecinski",
        "PL431": "Gorzowski",
        "PL432": "Zielonogórski",
        "PL514": "Miasto Wroclaw",
        "PL515": "Jeleniogórski",
        "PL516": "Legnicko-glogowski",
        "PL517": "Walbrzyski",
        "PL518": "Wroclawski",
        "PL523": "Nyski",
        "PL524": "Opolski",
        "PL613": "Bydgosko-torunski",
        "PL616": "Grudziadzki",
        "PL617": "Inowroclawski",
        "PL618": "Swiecki",
        "PL619": "Wloclawski",
        "PL621": "Elblaski",
        "PL622": "Olsztynski",
        "PL63": "Pomorskie",
        "PL634": "Gdanski",
        "PL636": "Slupski",
        "PL637": "Chojnicki",
        "PL638": "Starogardzki",
        "PL711": "Miasto Łódź",
        "PL712": "Łódzki",
        "PL713": "Piotrkowski",
        "PL714": "Sieradzki",
        "PL715": "Skierniewicki",
        "PL721": "Kielecki",
        "PL722": "Sandomiersko-jędrzejowski",
        "PL811": "Bialski",
        "PL812": "Chełmsko-zamojski",
        "PL814": "Lubelski",
        "PL815": "Puławski",
        "PL821": "Krośnieński",
        "PL822": "Przemyski",
        "PL823": "Rzeszowski",
        "PL824": "Tarnobrzeski",
        "PL841": "Białostocki",
        "PL842": "Łomżyński",
        "PL843": "Suwalski",
        "PL911": "Miasto Warszawa",
        "PL912": "Warszawski wschodni",
        "PL913": "Warszawski zachodni",
        "PL921": "Radomski",
        "PL922": "Ciechanowski",
        "PL923": "Płocki",
        "PL924": "Ostrołęcki",
        "PL925": "Siedlecki",
        "PL926": "Żyrardowski",
        "PLZZZ": "Extra-Regio NUTS 3",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine, State of",
        "PT111": "Minho-Lima",
        "PT112": "Cávado",
        "PT119": "Ave",
        "PT11A": "Área Metropolitana do Porto",
        "PT11B": "Alto Tâmega",
        "PT11C": "Tâmega e Sousa",
        "PT11D": "Douro",
        "PT11E": "Terras de Trás-os-Montes",
        "PT150": "Algarve",
        "PT16B": "Oeste",
        "PT16D": "Região de Aveiro",
        "PT16E": "Região de Coimbra",
        "PT16F": "Região de Leiria",
        "PT16G": "Viseu Dão Lafões",
        "PT16H": "Beira Baixa",
        "PT16I": "Médio Tejo",
        "PT16J": "Beiras e Serra da Estrela",
        "PT170": "Área Metropolitana de Lisboa",
        "PT181": "Alentejo Litoral",
        "PT184": "Baixo Alentejo",
        "PT185": "Lezíria do Tejo",
        "PT186": "Alto Alentejo",
        "PT187": "Alentejo Central",
        "PT200": "Região Autónoma dos Açores",
        "PT300": "Região Autónoma da Madeira",
        "PTZZZ": "Extra-Regio NUTS 3",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RO111": "Bihor",
        "RO112": "Bistrita-nasaud",
        "RO113": "Cluj",
        "RO114": "Maramures",
        "RO115": "Satu Mare",
        "RO116": "Salaj",
        "RO121": "Alba",
        "RO122": "Brasov",
        "RO123": "Covasna",
        "RO124": "Harghita",
        "RO125": "Mures",
        "RO126": "Sibiu",
        "RO211": "Bacau",
        "RO212": "Botosani",
        "RO213": "Iasi",
        "RO214": "Neamt",
        "RO215": "Suceava",
        "RO216": "Vaslui",
        "RO221": "Braila",
        "RO222": "Buzau",
        "RO223": "Constanta",
        "RO224": "Galati",
        "RO225": "Tulcea",
        "RO226": "Vrancea",
        "RO311": "Arges",
        "RO312": "Calarasi",
        "RO313": "Dâmbovita",
        "RO314": "Giurgiu",
        "RO315": "Ialomita",
        "RO316": "Prahova",
        "RO317": "Teleorman",
        "RO321": "Bucuresti",
        "RO322": "Ilfov",
        "RO411": "Dolj",
        "RO412": "Gorj",
        "RO413": "Mehedinti",
        "RO414": "Olt",
        "RO415": "Vâlcea",
        "RO421": "Arad",
        "RO422": "Caras-severin",
        "RO423": "Hunedoara",
        "RO424": "Timis",
        "ROZZZ": "Extra-Regio NUTS 3",
        "RS": "Serbia",
        "RU": "Russian Federation (the)",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan (the)",
        "SE110": "Stockholms län",
        "SE121": "Uppsala län",
        "SE122": "Södermanlands län",
        "SE123": "Östergötlands län",
        "SE124": "Örebro län",
        "SE125": "Västmanlands län",
        "SE211": "Jönköpings län",
        "SE212": "Kronobergs län",
        "SE213": "Kalmar län",
        "SE214": "Gotlands län",
        "SE221": "Blekinge län",
        "SE224": "Skåne län",
        "SE231": "Hallands län",
        "SE232": "Västra Götalands län",
        "SE311": "Värmlands län",
        "SE312": "Dalarnas län",
        "SE313": "Gävleborgs län",
        "SE321": "Västernorrlands län",
        "SE322": "Jämtlands län",
        "SE331": "Västerbottens län",
        "SE332": "Norrbottens län",
        "SEZZZ": "Extra-Regio NUTS 3",
        "SG": "Singapore",
        "SH": "Saint Helena, Ascension and Tristan da Cunha",
        "SI031": "Pomurska",
        "SI032": "Podravska",
        "SI033": "Koroška",
        "SI034": "Savinjska",
        "SI035": "Zasavska",
        "SI036": "Posavska",
        "SI037": "Jugovzhodna Slovenija",
        "SI038": "Primorsko-notranjska",
        "SI041": "Osrednjeslovenska",
        "SI042": "Gorenjska",
        "SI043": "Goriška",
        "SI044": "Obalno-kraška",
        "SIZZZ": "Extra-Regio NUTS 3",
        "SJ": "Svalbard and Jan Mayen",
        "SK010": "Bratislavský kraj",
        "SK021": "Trnavský kraj",
        "SK022": "Trenciansky Kraj",
        "SK023": "Nitriansky kraj",
        "SK031": "Žilinský kraj",
        "SK032": "Banskobystrický kraj",
        "SK041": "Prešovský kraj",
        "SK042": "Košický kraj",
        "SKZZZ": "Extra-Regio NUTS 3",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "Sao Tome and Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten (Dutch part)",
        "SY": "Syrian Arab Republic",
        "SZ": "Swaziland",
        "TC": "Turks and Caicos Islands (the)",
        "TD": "Chad",
        "TF": "French Southern Territories (the)",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor-Leste",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan (Province of China)",
        "TZ": "Tanzania, United Republic of",
        "UA": "Ukraine",
        "UG": "Uganda",
        "UKC11": "Hartlepool and Stockton-on-Tees",
        "UKC12": "South Teesside",
        "UKC13": "Darlington",
        "UKC14": "Durham CC",
        "UKC21": "Northumberland",
        "UKC22": "Tyneside",
        "UKC23": "Sunderland",
        "UKD11": "West Cumbria",
        "UKD12": "East Cumbria",
        "UKD33": "Manchester",
        "UKD34": "Greater Manchester South West",
        "UKD35": "Greater Manchester South East",
        "UKD36": "Greater Manchester North West",
        "UKD37": "Greater Manchester North East",
        "UKD41": "Blackburn with Darwen",
        "UKD42": "Blackpool",
        "UKD44": "Lancaster and Wyre",
        "UKD45": "Mid Lancashire",
        "UKD46": "East Lancashire",
        "UKD47": "Chorley and West Lancashire",
        "UKD61": "Warrington",
        "UKD62": "Cheshire East",
        "UKD63": "Cheshire West and Chester",
        "UKD71": "East Merseyside",
        "UKD72": "Liverpool",
        "UKD73": "Sefton",
        "UKD74": "Wirral",
        "UKE11": "Kingston upon Hull, City of",
        "UKE12": "East Riding of Yorkshire",
        "UKE13": "North and North East Lincolnshire",
        "UKE21": "York",
        "UKE22": "North Yorkshire CC",
        "UKE31": "Barnsley, Doncaster and Rotherham",
        "UKE32": "Sheffield",
        "UKE41": "Bradford",
        "UKE42": "Leeds",
        "UKE44": "Calderdale and Kirklees",
        "UKE45": "Wakefield",
        "UKF11": "Derby",
        "UKF12": "East Derbyshire",
        "UKF13": "South and West Derbyshire",
        "UKF14": "Nottingham",
        "UKF15": "North Nottinghamshire",
        "UKF16": "South Nottinghamshire",
        "UKF21": "Leicester",
        "UKF22": "Leicestershire CC and Rutland",
        "UKF24": "West Northamptonshire",
        "UKF25": "North Northamptonshire",
        "UKF30": "Lincolnshire",
        "UKG11": "Herefordshire, County of",
        "UKG12": "Worcestershire",
        "UKG13": "Warwickshire",
        "UKG21": "Telford and Wrekin",
        "UKG22": "Shropshire CC",
        "UKG23": "Stoke-on-Trent",
        "UKG24": "Staffordshire CC",
        "UKG31": "Birmingham",
        "UKG32": "Solihull",
        "UKG33": "Coventry",
        "UKG36": "Dudley",
        "UKG37": "Sandwell",
        "UKG38": "Walsall",
        "UKG39": "Wolverhampton",
        "UKH11": "Peterborough",
        "UKH12": "Cambridgeshire CC",
        "UKH14": "Suffolk",
        "UKH15": "Norwich and East Norfolk",
        "UKH16": "North and West Norfolk",
        "UKH17": "Breckland and South Norfolk",
        "UKH21": "Luton",
        "UKH23": "Hertfordshire",
        "UKH24": "Bedford",
        "UKH25": "Central Bedfordshire",
        "UKH31": "Southend-on-Sea",
        "UKH32": "Thurrock",
        "UKH34": "Essex Haven Gateway",
        "UKH35": "West Essex",
        "UKH36": "Heart of Essex",
        "UKH37": "Essex Thames Gateway",
        "UKI31": "Camden and City of London",
        "UKI32": "Westminster",
        "UKI33": "Kensington & Chelsea and Hammersmith & Fulham",
        "UKI34": "Wandsworth",
        "UKI41": "Hackney and Newham",
        "UKI42": "Tower Hamlets",
        "UKI43": "Haringey and Islington",
        "UKI44": "Lewisham and Southwark",
        "UKI45": "Lambeth",
        "UKI51": "Bexley and Greenwich",
        "UKI52": "Barking & Dagenham and Havering",
        "UKI53": "Redbridge and Waltham Forest",
        "UKI54": "Enfield",
        "UKI61": "Bromley",
        "UKI62": "Croydon",
        "UKI63": "Merton, Kingston upon Thames and Sutton",
        "UKI71": "Barnet",
        "UKI72": "Brent",
        "UKI73": "Ealing",
        "UKI74": "Harrow and Hillingdon",
        "UKI75": "Hounslow and Richmond upon Thames",
        "UKJ11": "Berkshire",
        "UKJ12": "Milton Keynes",
        "UKJ13": "Buckinghamshire CC",
        "UKJ14": "Oxfordshire",
        "UKJ21": "Brighton and Hove",
        "UKJ22": "East Sussex CC",
        "UKJ25": "West Surrey",
        "UKJ26": "East Surrey",
        "UKJ27": "West Sussex (South West)",
        "UKJ28": "West Sussex (North East)",
        "UKJ31": "Portsmouth",
        "UKJ32": "Southampton",
        "UKJ34": "Isle of Wight",
        "UKJ35": "South Hampshire",
        "UKJ36": "Central Hampshire",
        "UKJ37": "North Hampshire",
        "UKJ41": "Medway",
        "UKJ43": "Kent Thames Gateway",
        "UKJ44": "East Kent",
        "UKJ45": "Mid Kent",
        "UKJ46": "West Kent",
        "UKK11": "Bristol, City of",
        "UKK12": "Bath and North East Somerset, North Somerset and South Gloucestershire",
        "UKK13": "Gloucestershire",
        "UKK14": "Swindon",
        "UKK15": "Wiltshire CC",
        "UKK21": "Bournemouth and Poole",
        "UKK22": "Dorset CC",
        "UKK23": "Somerset",
        "UKK30": "Cornwall and Isles of Scilly",
        "UKK41": "Plymouth",
        "UKK42": "Torbay",
        "UKK43": "Devon CC",
        "UKL11": "Isle of Anglesey",
        "UKL12": "Gwynedd",
        "UKL13": "Conwy and Denbighshire",
        "UKL14": "South West Wales",
        "UKL15": "Central Valleys",
        "UKL16": "Gwent Valleys",
        "UKL17": "Bridgend and Neath Port Talbot",
        "UKL18": "Swansea",
        "UKL21": "Monmouthshire and Newport",
        "UKL22": "Cardiff and Vale of Glamorgan",
        "UKL23": "Flintshire and Wrexham",
        "UKL24": "Powys",
        "UKM50": "Aberdeen City and Aberdeenshire",
        "UKM61": "Caithness & Sutherland and Ross & Cromarty",
        "UKM62": "Inverness & Nairn and Moray, Badenoch & Strathspey",
        "UKM63": "Lochaber, Skye & Lochalsh, Arran & Cumbrae and Argyll & Bute",
        "UKM64": "Eilean Siar (Western Isles)",
        "UKM65": "Orkney Islands",
        "UKM66": "Shetland Islands",
        "UKM71": "Angus and Dundee City",
        "UKM72": "Clackmannanshire and Fife",
        "UKM73": "East Lothian and Midlothian",
        "UKM75": "Edinburgh, City of",
        "UKM76": "Falkirk",
        "UKM77": "Perth & Kinross and Stirling",
        "UKM78": "West Lothian",
        "UKM81": "East Dunbartonshire, West Dunbartonshire and Helensburgh & Lomond",
        "UKM82": "Glasgow City",
        "UKM83": "Inverclyde, East Renfrewshire and Renfrewshire",
        "UKM84": "North Lanarkshire",
        "UKM91": "Scottish Borders",
        "UKM92": "Dumfries & Galloway",
        "UKM93": "East Ayrshire and North Ayrshire mainland",
        "UKM94": "South Ayrshire",
        "UKM95": "South Lanarkshire",
        "UKN06": "Belfast",
        "UKN07": "Armagh City, Banbridge and Craigavon",
        "UKN08": "Newry, Mourne and Down",
        "UKN09": "Ards and North Down ",
        "UKN10": "Derry City and Strabane",
        "UKN11": "Mid Ulster",
        "UKN12": "Causeway Coast and Glens",
        "UKN13": "Antrim and Newtownabbey",
        "UKN14": "Lisburn and Castlereagh",
        "UKN15": "Mid and East Antrim",
        "UKN16": "Fermanagh and Omagh",
        "UKZZZ": "Extra-Regio NUTS 3",
        "UM": "United States Minor Outlying Islands (the)",
        "US": "United States of America (the)",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Holy See (the)",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela (Bolivarian Republic of)",
        "VG": "Virgin Islands (British)",
        "VI": "Virgin Islands (U.S.)",
        "VN": "Viet Nam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna",
        "WS": "Samoa",
        "YE": "Yemen",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
      },
      "OPER": {
        "1": "1",
        "2": "2"
      },
      "OPTYPES": {
        "PPIFJA": "Papildomo pajaus įsigijimas"
      },
      "RFRNC_RT_INDX": {
        "CHF_LIBOR": "CHF LIBOR",
        "EUR_LIBOR": "EUR LIBOR",
        "EURIBOR": "EURIBOR",
        "GBP_LIBOR": "GBP LIBOR",
        "JPY_LIBOR": "JPY LIBOR",
        "MIBOR ": "MIBOR",
        "NA": "Netaikytina",
        "NIBOR": "NIBOR",
        "OTHER_MULTIPLE": "Kita sudėtinė orientacinė palūkanų norma",
        "OTHER_SINGLE": "Kita paprasta orientacinė palūkanų norma",
        "SEK_LIBOR": "SEK LIBOR",
        "USD_LIBOR": "USD LIBOR"
      },
      "RFRNC_RT_MTRT": {
        "10M": "Dešimties mėnesių",
        "11M": "Vienuolikos mėnesių",
        "12M": "Dvylikos mėnesių",
        "1M": "Vieno mėnesio",
        "1W": "Vienos savaitės",
        "2M": "Dviejų mėnesių",
        "2W": "Dviejų savaičių",
        "3M": "Trijų mėnesių",
        "3W": "Trijų savaičių",
        "4M": "Keturių mėnesių",
        "5M": "Penkių mėnesių",
        "6M": "Šešių mėnesių",
        "7M": "Septynių mėnesių",
        "8M": "Aštuonių mėnesių",
        "9M": "Devynių mėnesių",
        "NA": "Netaikytina",
        "ON": "Vienos dienos",
        "OVER_12M": "Virš dvylikos mėnesių"
      },
      "TYP_SCRTSTN": {
        "1": "Tradicinis pakeitimas vertybiniais popieriais",
        "6": "Sintetinis pakeitimas vertybiniais popieriais",
        "7": "Nepakeista vertybiniais popieriais"
      },
      "FRQNCY_INTRST_RT_RST": {
        "0": "Neperskaičiuojama",
        "1": "Kasmet",
        "3": "Kreditoriaus nuožiūra",
        "8": "Mėnesio",
        "12": "Kitas dažnumas",
        "16": "Vienadienė",
        "18": "Ketvirčio",
        "19": "Kas pusmetį"
      },
      "TYP_INTRST_RT": {
        "0": "Netaikytina",
        "1": "Fiksuotoji",
        "2": "Kintama",
        "3": "Mišri"
      },
      "ADDC": {
        "ADDC1": "1",
        "ADDC2": "2",
        "ADDC3": "3",
        "ADDC4": "4",
        "ADDC5": "5",
        "ADDC6": "6",
        "ADDC7": "7",
        "ADDC8": "8",
        "ADDC9": "9",
        "ADDC10": "10"
      },
      "LOAN_FRMR_FRM": {
        "1": "Taip",
        "2": "Ne"
      },
      "LOAN_PRPS_HH": {
        "1": "Paskolos vartojimui",
        "2": "Paskolos būstui įsigyti",
        "3": "Paskolos kitiems tikslams"
      },
      "FNNCL_CLLTRL": {
        "1": "Įkeista",
        "2": "Neįkeista",
        "10": "Pateikta vertinimui",
        "11": "Tinkama įkeitimui",
        "12": "Pateikta įkeitimui",
        "13": "Netinkama įkeitimui",
        "14": "Pateikta atsiėmimui"
      },
      "FDCRY": {
        "1": "Patikos priemonė",
        "2": "Ne patikos priemonė"
      },
      "PRJCT_FNNC_LN": {
        "1": "Projektų finansavimo paskola",
        "2": "Ne projektų finansavimo paskola"
      },
      "FRBRNC_STTS": {
        "3": "Restruktūrizuota: refinansuota arba iš dalies refinansuota skola",
        "4": "Restruktūrizuota: priemonės su pakeistomis žemesnėmis nei rinkos sąlygos palūkanų normomis",
        "5": "Restruktūrizuota: priemonės, kurių kitos sąlygos pakeistos",
        "8": "Nerestruktūrizuota arba sąlygos nepakeistos",
        "9": "Priemonė, kurios sąlygos pakeistos be restruktūrizavimo priemonių"
      },
      "PRDNTL_PRTFL": {
        "0": "Netaikytina",
        "1": "Prekybos knyga",
        "2": "Ne prekybos knyga"
      },
      "DIST": {
        "DIST01": "Akmenės rajono savivaldybė",
        "DIST02": "Alytaus miesto savivaldybė",
        "DIST03": "Zarasų rajono savivaldybė",
        "DIST04": "Visagino savivaldybė",
        "DIST05": "Vilniaus rajono savivaldybė",
        "DIST06": "Vilniaus miesto savivaldybė",
        "DIST07": "Vilkaviškio rajono savivaldybė",
        "DIST08": "Varėnos rajono savivaldybė",
        "DIST09": "Utenos rajono savivaldybė",
        "DIST10": "Ukmergės rajono savivaldybė",
        "DIST11": "Trakų rajono savivaldybė",
        "DIST12": "Telšių rajono savivaldybė",
        "DIST13": "Tauragės rajono savivaldybė",
        "DIST14": "Švenčionių rajono savivaldybė",
        "DIST15": "Širvintų rajono savivaldybė",
        "DIST16": "Šilutės rajono savivaldybė",
        "DIST17": "Šilalės rajono savivaldybė",
        "DIST18": "Šiaulių rajono savivaldybė",
        "DIST19": "Šiaulių miesto savivaldybė",
        "DIST20": "Šalčininkų rajono savivaldybė",
        "DIST21": "Šakių rajono savivaldybė",
        "DIST22": "Skuodo rajono savivaldybė",
        "DIST23": "Rokiškio rajono savivaldybė",
        "DIST24": "Rietavo savivaldybė",
        "DIST25": "Raseinių rajono savivaldybė",
        "DIST26": "Radviliškio rajono savivaldybė",
        "DIST27": "Prienų rajono savivaldybė",
        "DIST28": "Plungės rajono savivaldybė",
        "DIST29": "Pasvalio rajono savivaldybė",
        "DIST30": "Panevėžio rajono savivaldybė",
        "DIST31": "Panevėžio miesto savivaldybė",
        "DIST32": "Palangos miesto savivaldybė",
        "DIST33": "Pakruojo rajono savivaldybė",
        "DIST34": "Pagėgių savivaldybė",
        "DIST35": "Neringos savivaldybė",
        "DIST36": "Molėtų rajono savivaldybė",
        "DIST37": "Mažeikių rajono savivaldybė",
        "DIST38": "Marijampolės savivaldybė",
        "DIST39": "Lazdijų rajono savivaldybė",
        "DIST40": "Kupiškio rajono savivaldybė",
        "DIST41": "Kretingos rajono savivaldybė",
        "DIST42": "Klaipėdos rajono savivaldybė",
        "DIST43": "Klaipėdos miesto savivaldybė",
        "DIST44": "Kelmės rajono savivaldybė",
        "DIST45": "Kėdainių rajono savivaldybė",
        "DIST46": "Kazlų Rūdos savivaldybė",
        "DIST47": "Kauno rajono savivaldybė",
        "DIST48": "Kauno miesto savivaldybė",
        "DIST49": "Kalvarijos savivaldybė",
        "DIST50": "Kaišiadorių rajono savivaldybė",
        "DIST51": "Jurbarko rajono savivaldybė",
        "DIST52": "Joniškio rajono savivaldybė",
        "DIST53": "Jonavos rajono savivaldybė",
        "DIST54": "Ignalinos rajono savivaldybė",
        "DIST55": "Elektrėnų savivaldybė",
        "DIST56": "Druskininkų savivaldybė",
        "DIST57": "Biržų rajono savivaldybė",
        "DIST58": "Birštono savivaldybė",
        "DIST59": "Anykščių rajono savivaldybė",
        "DIST60": "Alytaus rajono savivaldybė",
        "DIST61": "testas"
      },
      "PRFRMNG_STTS": {
        "1": "Neveiksnios",
        "2": "Veiksnios"
      },
      "DFLT_STTS": {
        "0": "Netaikytina",
        "14": "Įsipareigojimai vykdomi",
        "18": "Įsipareigojimų neįvykdymas, nes tikėtina, kad bus neatsiskaityta ir praleista 90/180 dienų nuo termino.",
        "19": "Įsipareigojimų neįvykdymas, nes tikėtina, kad bus neatsiskaityta",
        "20": "Įsipareigojimų neįvykdymas, nes praleista 90/180 dienų nuo termino"
      },
      "TYP_INSTRMNT": {
        "20": "Lėšų pereikvojimas",
        "51": "Kredito kortelės skola",
        "1000": "Indėliai, išskyrus atvirkštines atpirkimo sutartis",
        "1001": "Atnaujinamasis kreditas, išskyrus lėšų pereikvojimą ir kredito kortelės skolą.",
        "1002": "Kredito linijos, išskyrus atnaujinamąjį kreditą",
        "1003": "Atvirkštinio atpirkimo sandoriai",
        "1004_A": "Kitos paskolos: tiesioginiai kreditai",
        "1004_B": "Kitos paskolos: išsimokėtinai (skolon, su atidėtu apmokėjimu) parduotas turtas",
        "1004_C": "Kitos paskolos: grįžtamoji finansinė nuoma",
        "1004_D": "Kitos paskolos: kitos paskolos",
        "71_A": "Gautinos prekybos sumos: faktoringas su atgręžtinio reikalavimo teise",
        "71_B": "Gautinos prekybos sumos: faktoringas be atgręžtinio reikalavimo teisės",
        "71_C": "Gautinos prekybos sumos: kitos gautinos prekybos sumos ",
        "80_A": "Finansinė nuoma: išperkamoji nuoma",
        "80_B": "Finansinė nuoma: kita finansinė nuoma"
      },
      "ACCNTNG_CLSSFCTN": {
        "0": "Netaikytina",
        "2": "TFAS apskaitos portfeliai: Prekybai laikomas finansinis turtas",
        "3": "Nacionaliniai BAP apskaitos portfeliai: Prekybinis finansinis turtas",
        "4": "TFAS apskaitos portfeliai: Finansinis turtas, vertinamas tikrąja verte, kurios pokyčiai pripažįstami pelno (nuostolių) ataskaitoje",
        "5": "Nacionaliniai BAP apskaitos portfeliai: Parduoti laikomas finansinis turtas",
        "6": "TFAS apskaitos portfeliai: Finansinis turtas, vertinamas amortizuota savikaina",
        "7": "Nacionaliniai BAP apskaitos portfeliai: Neprekybinis neišvestinis finansinis turtas, apskaičiuotas tikrąja verte, kurios pokyčiai pripažįstami pelno (nuostolių) ataskaitoje",
        "8": "TFAS apskaitos portfeliai: Finansinis turtas tikrąja verte, kurios pokyčiai pripažįstami kitomis bendrosiomis pajamomis",
        "9": "Nacionaliniai BAP apskaitos portfeliai: Neprekybinis neišvestinis finansinis turtas, apskaičiuotas tikrąja verte, kurios pokyčiai pripažįstami nuosavybės vertybiniuose popieriuose",
        "10": "Nacionaliniai BAP apskaitos portfeliai: Paskolos ir gautinos sumos",
        "12": "Nacionaliniai BAP apskaitos portfeliai: Iki termino laikomos investicijos",
        "13": "Nacionaliniai BAP apskaitos portfeliai: Neprekybinės skolos priemonės, vertinamos taikant savikainos metodą",
        "14": "TFAS apskaitos portfeliai: Lėšos centriniuose bankuose ir kiti iki pareikalavimo laikomi indėliai",
        "15": "Nacionaliniai BAP apskaitos portfeliai: Kitas neprekybinis neišvestinis finansinis turtas",
        "41": "TFAS apskaitos portfeliai: Neprekybinis finansinis turtas, privalomai apskaičiuojamas tikrąja verte, kurios pokyčiai pripažįstami pelno (nuostolių) ataskaitoje",
        "45": "Nacionaliniai BAP apskaitos portfeliai: Grynieji pinigai ir lėšos centriniuose bankuose",
        "46": "Nacionaliniai BAP apskaitos portfeliai: Prekybai laikomas finansinis turtas",
        "47": "Nacionaliniai BAP apskaitos portfeliai: Finansinis turtas, vertinamas tikrąja verte, kurios pokyčiai pripažįstami pelno (nuostolių) ataskaitoje",
        "48": "Nacionaliniai BAP apskaitos portfeliai: Neprekybinis finansinis turtas, privalomai apskaičiuojamas tikrąja verte, kurios pokyčiai pripažįstami pelno (nuostolių) ataskaitoje"
      },
      "SBRDNTD_DBT": {
        "1": "Subordinuotoji skola",
        "2": "Ne subordinuotoji skola"
      },
      "TYP_CHNG_ACCRD_INTRST": {
        "1": "Pirkimas",
        "2": "Perėmimas",
        "3": "Visiškai arba iš dalies nurašytos paskolos pripažinimas balanse",
        "4": "Pardavimas",
        "5": "Perdavimas",
        "6": "Nurašymas",
        "7": "Nurašytos paskolos pardavimas",
        "8": "Nurašytos paskolos grąžinimas",
        "9": "Grąžinimas kreditoriui įvykdžius arba pardavus paskolos užtikrinimo priemonę",
        "10": "Grąžinimas kreditoriui perėmus finansinės nuomos objektą"
      },
      "CONN": {
        "CONN1": "Stebėtojų tarybos narys ir jų artimieji šeimos nariai",
        "CONN2": "Valdybos narys ir jų artimieji šeimos nariai",
        "CONN3": " Administracijos vadovas ir jų artimieji šeimos nariai",
        "CONN4": " Paskolų komiteto pirmininkas ir jų artimieji šeimos nariai",
        "CONN5": " Vidaus tarnybos vadovas/ vidaus auditorius ir jų artimieji šeimos nariai"
      },
      "APPLIE": {
        "APPLIE1": "6 paskutinių mėnesių išmokėtų palūkanų dydžio",
        "APPLIE2": "12 paskutinių mėnesių išmokėtų palūkanų dydžio",
        "APPLIE3": "Netaikoma"
      },
      "LGL_FRM": {
        "AT102": "General partnership",
        "AT103": "Limited partnership",
        "AT201": "Plc (UK)",
        "AT202": "Ltd (UK)",
        "AT401": "Cooperative",
        "AT501": "Mutual Insurance Corporation ",
        "AT603": "Private foundation",
        "AT604": "Mutual Savings Bank",
        "AT605": "Other Legal Entity",
        "AT607": "Other",
        "AT610": "public corporation, corporation of public law",
        "AT611": "public trust, corporation of public law",
        "AT612": "registered association, corporation of public law",
        "AT613": "owner association",
        "BE002": "Organisation for financing pensions",
        "BE003": "VAT Group",
        "BE006": "Cooperative partnership with unlimited liability",
        "BE008": "Cooperative company with limited liability",
        "BE011": "General partnership",
        "BE012": "Ordinary limited partnership",
        "BE013": "Partnership limited by shares",
        "BE014": "Public limited company",
        "BE015": "Private limited liability company",
        "BE017": "Non-profit association",
        "BE019": "Mutual health fund / Mutual Benefit Society / National Union of mutual health funds",
        "BE020": "Professional association",
        "BE021": "Mutual insurance association / Mutual insurance fund under private law",
        "BE025": "Agricultural company",
        "BE026": "Private Foundation",
        "BE028": "Non-profit institution",
        "BE029": "Public utility foundation",
        "BE051": "Other private-law form with legal personality",
        "BE060": "Economic interest grouping",
        "BE070": "Joint owners' association",
        "BE107": "Cooperative company with unlimited liability, Participating cooperative, governed by public law",
        "BE108": "Cooperative company with limited liability, governed by public law",
        "BE114": "Public limited company, governed by public law",
        "BE117": "Non-profit association, governed by public law",
        "BE121": "Mutual insurance association, governed by public law",
        "BE124": "Public institution",
        "BE125": "International non-profit association",
        "BE127": "Pawnshop",
        "BE129": "Polder - watering",
        "BE151": "Other legal form",
        "BE200": "Company under formation",
        "BE206": "Non-trading company in the form of a cooperative company with unlimited liability",
        "BE208": "Non-trading company in the form of a cooperative company with limited liability",
        "BE211": "Non-trading company in the form of a general partnership",
        "BE212": "Non-trading company in the form of an ordinary limited partnership",
        "BE213": "Non-trading company in the form of a partnership limited by shares",
        "BE214": "Non-trading company in the form of a public limited company",
        "BE215": "Non-trading company in the form of a private limited liability company",
        "BE217": "European political party",
        "BE218": "European political foundation",
        "BE225": "Non-trading company in the form of an agricultural company",
        "BE301": "Federal Public Service",
        "BE302": "Federal Public Planning Service ",
        "BE303": "Other federal service",
        "BE310": "Authorities of the Flemish Region and the Flemish Community",
        "BE320": "Authorities of the Walloon Region",
        "BE330": "Authorities of the Brussels Capital Region",
        "BE340": "Authorities of the French Community",
        "BE350": "Authorities of the German-speaking Community",
        "BE400": "Provincial Authority",
        "BE411": "City / municipality",
        "BE412": "Public social welfare centre",
        "BE413": "Local Police",
        "BE414": "Intermunicipal company",
        "BE415": "Project association",
        "BE416": "Services provider association (Flemish Region)",
        "BE417": "Project entrusted association (Flemish Region)",
        "BE418": "Autonomous municipal company",
        "BE419": "Autonomous provincial company",
        "BE420": "Association of public centres for social welfare",
        "BE422": "Relief zone",
        "BE506": "Cooperative company with unlimited liability with a social purpose",
        "BE508": "Cooperative company with limited liability with a social purpose",
        "BE511": "General partnership with a social purpose",
        "BE512": "Ordinary limited partnership with a social purpose",
        "BE513": "Partnership limited by shares with a social purpose",
        "BE514": "Public limited company with a social purpose",
        "BE515": "Private limited liability company with a social purpose",
        "BE560": "Economic interest grouping with a social purpose",
        "BE651": "Other form with a social purpose, governed by public law",
        "BE702": "Partnership",
        "BE721": "Company or association without legal personality",
        "BG101": "Joint-stock company",
        "BG102": "Limited liability company",
        "BG103": "Partnership limited by shares",
        "BG104": "Single person joint-stock company",
        "BG105": "Single person limited liability company",
        "BG106": "Limited partnership",
        "BG107": "General partnership",
        "BG1539": "Joint-Stock Special Investment Company",
        "BG462": "Sole proprietor",
        "BG466": "Cooperation/Cooperative society",
        "BG472": "Partnership by Law of Obligations And Contracts",
        "CY102": "Private limited company/ Ltd",
        "CY103": "Public limited company/ Plc",
        "CY109": "Partnership",
        "CY111": "Cooperative Credit Societies",
        "CY112": "Sole proprietorship",
        "CY113": "Societies & Foundations",
        "CY114": "Entities governed by public law",
        "CY116": "Pension/ Provident Funds",
        "CY117": "Other legal form",
        "CZ111": "General partnership",
        "CZ112": "Ltd (UK)",
        "CZ113": "Limited partnership",
        "CZ115": "Joint venture",
        "CZ116": "Special interest club",
        "CZ117": "Foundation",
        "CZ118": "Foundation fund",
        "CZ121": "Plc (UK)",
        "CZ141": "One of the legal forms for non-governmental non-profit organizations",
        "CZ145": "Owners’ association (apartment owners’ association)",
        "CZ151": "Commodity exchange",
        "CZ152": "Guarantee Fund of Investment Firms",
        "CZ161": "Institute",
        "CZ205": "Cooperative",
        "CZ301": "State enterprise",
        "CZ313": "Czech National Bank",
        "CZ325": "Organisational unit of the state",
        "CZ326": "Permanent Court of Arbitration",
        "CZ331": "Subsidised organisation, semi-budgetary organisation",
        "CZ352": "Railway Transport Route Administration (state organisation)",
        "CZ353": "Council for Public Audit Supervision",
        "CZ361": "Public law institution (Czech Television, Czech Radio, Czech Press Agency)",
        "CZ381": "Fund (statutory)",
        "CZ391": "Health insurance company",
        "CZ501": "Branch or other organisational unit of an incorporated enterprise",
        "CZ521": "Independent small office of a municipal office",
        "CZ541": "Unit trust or pension fund",
        "CZ601": "University, college",
        "CZ641": "Educational legal entity",
        "CZ661": "Public research institution",
        "CZ703": "Trade union organisation and emloyers’ organisation",
        "CZ704": "Special organisation to represent Czech interests in international non-governmental organisations",
        "CZ705": "Enterprise or economic organisation of an association",
        "CZ706": "Society",
        "CZ707": "Trade union organisation",
        "CZ708": "Employers organisation",
        "CZ711": "Political party, political movement",
        "CZ715": "Enterprise or economic organisation of a political party",
        "CZ721": "Church organisation and religious societes",
        "CZ722": "Registered church (legal entity)",
        "CZ723": "Unions of churches and religious societies",
        "CZ731": "Organisational unit of an association",
        "CZ732": "Organisational unit of a political party or political movement",
        "CZ733": "Organisational unit of a trade union organisation and emloyers’ organisation",
        "CZ734": "Organisational unit of the special organisation to represent Czech interests in international non-governmental organisations",
        "CZ736": "Subsidiary society",
        "CZ741": "Professional chamber",
        "CZ745": "Chamber (excluding professional chambers)",
        "CZ751": "Special interest club of legal entities",
        "CZ761": "Hunting society",
        "CZ771": "Union of municipalities",
        "CZ801": "Municipality or city district of Prague",
        "CZ804": "Region or capital city Prague",
        "CZ805": "Regional Council of a cohesion region",
        "CZ901": "Representative office of another state",
        "CZ907": "International trade union organisation",
        "CZ908": "International organisation of employers",
        "CZ921": "International non-governmental organisation",
        "CZ922": "Organisational unit of the international non-governmental organisation",
        "CZ931": "An eu legal entity designed to enable cross-border cooperation between companies",
        "CZ937": "Subsidiary international trade union organisation",
        "CZ938": "Subsidiary international organisation of employers",
        "CZ950": "Entity not explicitly defined by law",
        "CZ960": "Legal entity of an public register established by the special law",
        "CZ961": "Trust fund",
        "DE101": "Partnership under civil law",
        "DE102": "General partnership",
        "DE103": "Limited partnership",
        "DE105": "Registered partnership company",
        "DE108": "Limited partnership (fully limited) ",
        "DE109": "Partnership limited by shares (fully lmited)",
        "DE110": "General partnership (partially limited)",
        "DE201": "Public limited company",
        "DE202": "Partnership limited by shares",
        "DE205": "Public limited investment company",
        "DE206": "Private limited company",
        "DE207": "Entrepreneurial company (limited liability)",
        "DE209": "Registered association by charter ",
        "DE211": "Legal entity under old Hamburg law",
        "DE301": "Registered cooperative company",
        "DE401": "Mutual insurance company",
        "DE501": "Regional Authority",
        "DE502": "Institution established under public law",
        "DE503": "Public body / statutory company",
        "DE504": "Public foundation",
        "DE505": "Municipal undertaking",
        "DE506": "Other public legal form",
        "DE507": "Special-purpose association",
        "DE601": "Private foundation",
        "DE602": "Registered association",
        "DE603": "Religious community",
        "DE701": "Other",
        "DK100": "Commercial foundation",
        "DK110": "Association ",
        "DK115": "Voluntary association",
        "DK130": "Cooperative society",
        "DK140": "Limited liability cooperative society",
        "DK150": "Limited liability association or company",
        "DK151": "Limited liability company",
        "DK152": "Limited liability association",
        "DK20": "Estate of deceased person",
        "DK230": "Entitiy of central government",
        "DK235": "Independent public company",
        "DK240": "County",
        "DK245": "Region",
        "DK250": "Municipality",
        "DK260": "Establishmentarian church institution",
        "DK270": "Unit under creation in business register",
        "DK280": "Other companies",
        "DK285": "Special financial company",
        "DK30": "General partnership",
        "DK40": "Limited partnership",
        "DK45": "Employee investment company",
        "DK50": "Shipping partnership",
        "DK60": "Limited company ",
        "DK70": "Limited partnership with a share capital",
        "DK80": "Private limited company ",
        "DK81": "Entrepreneurial limited company",
        "DK90": "Self-governing institution, association, foundation etc.",
        "DK990": "Unknown legal form",
        "EE101": "Public limited company ",
        "EE102": "Private limited company",
        "EE201": "General partnership",
        "EE202": "Limited partnership",
        "EE203": "Non-profit association",
        "EE204": "Commercial association",
        "EE205": "Foundation",
        "EE206": "Central and local government authorities ",
        "ESC04": "Public limited company",
        "ESC05": "Single-member public limited company",
        "ESC06": "Worker-owned public limited company ",
        "ESC07": "Private limited company",
        "ESC08": "Single-member private limited company",
        "ESC09": "Worker-owned private limited company ",
        "ESC10": "\"New firm\" private limited company ",
        "ESC11": "General partnerships",
        "ESC12": "Simple limited partnership",
        "ESC13": "Limited stock partnership",
        "ESC14": "Cooperative company",
        "ESC16": "Mutual Guarantee Company",
        "ESC17": "Farming partnerships",
        "ESC19": "Non-commercial partnership with independent legal status",
        "ESC20": "Mutual company",
        "ESC21": "Economic interest grouping",
        "ESC25": "Other legal forms",
        "ESC30": "Private company of professional members",
        "ESC31": "Foundation",
        "ESC32": "Associations and other non-profit institutions serving households",
        "ESC33": "Public law entity",
        "ESC34": "Investment funds without independent legal status",
        "EU100": "European company (a type of public, limited-liability company regulated under EU law)",
        "EU200": "European cooperative society",
        "EU300": "European economic interest grouping",
        "EU400": "European Grouping of Territorial cooperation",
        "FI10": "General partnership",
        "FI11": "Limited partnership",
        "FI12": "Limited company",
        "FI13": "Housing company",
        "FI16": "Mutual joint-stock property company",
        "FI17": "Other joint-stock property company (not mutual)",
        "FI18": "Enterprise group",
        "FI19": "Other enterprise",
        "FI20": "Voluntary association",
        "FI21": "Association based on separate legislation",
        "FI22": "Mutual indemnity insurance association",
        "FI23": "Forestry society",
        "FI24": "Cooperative bank",
        "FI25": "Co-operative society",
        "FI26": "Mutual benefit society",
        "FI27": "Unemployment fund",
        "FI28": "Other economic association",
        "FI29": "Other association",
        "FI30": "Foundation (according to the Foundations Act)",
        "FI31": "Savings bank",
        "FI32": "Pension foundation (founded by a charter of foundation)",
        "FI33": "Pension fund",
        "FI35": "Mortgage society",
        "FI39": "Other foundation",
        "FI40": "State and its agencies",
        "FI41": "Municipality",
        "FI42": "Joint municipal board",
        "FI43": "Region of Åland and its agencies",
        "FI44": "Evangelical Lutheran Church",
        "FI45": "Greek Orthodox Church",
        "FI46": "Registered religious community",
        "FI47": "Students' union or association",
        "FI48": "Governmental institution with separate administration",
        "FI49": "Other legal person subject to public law",
        "FI50": "Mutual interest bodies (e.g. fishery collectives)",
        "FI55": "Jointly owned forest",
        "FI56": "Farm",
        "FI60": "State-owned company",
        "FI61": "Municipally-owned company",
        "FI62": "Joint local authority company",
        "FI63": "Company owned by the Regional Government of Åland",
        "FI99": "Others (e.g. temporary legal form)",
        "GB100": "Corporations",
        "GB200": "Cooperatives",
        "GB300": "Partnerships",
        "GB400": "Sole traders",
        "GB500": "Limited liability company",
        "GB600": "Any other legal form not included in the above list",
        "GR901": "Civil-law Association",
        "GR902": "General Partnership",
        "GR903": "Limited partnership (partnership company)",
        "GR904": "Silent Partnership",
        "GR905": "Public Limited Company, Societe Anonyme, Incorporated Company, Joint-stock Company",
        "GR906": "Limited Liability Company",
        "GR907": "Private Capital Company",
        "GR908": "Joint Ship-ownership",
        "GR909": "Shipping Company",
        "GR910": "Cooperative Company, Association",
        "GR911": "Club, Union, Syndicate, Foundation",
        "GR912": "Joint Venture",
        "GR913": "Legal Entities of Public Law",
        "GR999": "Other Legal Forms",
        "HR01": "Joint stock company",
        "HR02": "Limited liability company",
        "HR03": "Public company",
        "HR04": "Limited partnership",
        "HR06": "Institution",
        "HR07": "Other",
        "HR08": "Simple limited liability company",
        "HR09": "Other entities as prescribed by law",
        "HR10": "Public organisations",
        "HR11": "Socially-owned enterprise",
        "HR12": "Unlimited joint and several liability company",
        "HR13": "Funds",
        "HR14": "Foundations",
        "HR15": "Economic cooperations",
        "HR16": "Economic interest grouping",
        "HR17": "Town",
        "HR19": "City government",
        "HR20": "City council",
        "HR21": "Croatian National Bank",
        "HR22": "Croatian Parliament",
        "HR23": "Investment and pension funds",
        "HR24": "Public enterprise",
        "HR25": "Ministries and other independent bodies of \ngovernment administration",
        "HR26": "Pension funds",
        "HR27": "Local committee, town district and town block",
        "HR28": "Non-money market investment funds",
        "HR29": "Municipality",
        "HR31": "Municipal government",
        "HR32": "Municipal council",
        "HR33": "Public organ",
        "HR34": "Other organisations",
        "HR35": "Other organisational forms",
        "HR36": "Company for the employment of persons with disabilities",
        "HR37": "Political parties",
        "HR38": "Justice",
        "HR39": "President of the Republic of Croatia",
        "HR40": "Private enterprise",
        "HR42": "Republic of Croatia",
        "HR43": "Compound pooling system",
        "HR44": "Administrative staffs, offices and other bodies",
        "HR45": "Sport joint-stock company",
        "HR47": "Association",
        "HR48": "Civil cooperatives",
        "HR49": "Higher-level association",
        "HR50": "Contracted company",
        "HR51": "Constitutional Court of the Republic of Croatia",
        "HR52": "Government of the Republic of Croatia",
        "HR53": "Cooperative",
        "HR54": "Cooperative undertaking/Cooperative company",
        "HR55": "Communities of institutions",
        "HR56": "Joint financial organisation",
        "HR57": "Trusts",
        "HR59": "County",
        "HR60": "County Assembly",
        "HR61": "County government",
        "HU113": "Private limited-liability company",
        "HU114": "Limited company",
        "HU116": "General partnership",
        "HU117": "Limited partnership",
        "HU122": "Savings and loan association savings and credit cooperative",
        "HU129": "Other cooperative",
        "HU226": "Branch establishment of foreign enterprise",
        "HU517": "Union (except sport union)",
        "HU524": "Mutual insurance association",
        "HU529": "Other association",
        "HU549": "Other public corporation",
        "HU569": "Other foundation",
        "HU581": "Voluntary mutual insurance fund",
        "HU582": "Private pension fund",
        "HU611": "Commercial agency of a foreign enterprise",
        "HU736": "Public benefit nonprofit institution",
        "HU915": "Investment fund",
        "HU916": "National deposit insurance fund",
        "HU931": "Other taxpayer",
        "HU999": "Other legal form",
        "IE01": "LTD",
        "IE02": "DAC",
        "IE03": "DAC",
        "IE04": "CLG",
        "IE05": "PLC",
        "IE06": "SMC",
        "IE07": "UC ",
        "IE08": "UCITS",
        "IE11": null,
        "IE12": null,
        "IE13": null,
        "IE14": null,
        "IE15": null,
        "IE16": null,
        "IT101": "General government",
        "IT201": "General partnership (commercial)",
        "IT301": "Limited partnership",
        "IT401": "General partnership (non commercial)",
        "IT402": "De facto corporation",
        "IT501": "Consortium",
        "IT601": "Cooperative society",
        "IT701": "Plc (UK)",
        "IT702": "Partnership limited by shares",
        "IT703": "Ltd (UK)",
        "IT999": "Other, e.g. Foundation, Association, No profit organization",
        "LT101": "Public Limited Company",
        "LT102": "Private Limited Company",
        "LT103": "Cooperative Society (Cooperative)",
        "LT104": "General Partnership",
        "LT105": "Limited Partnership",
        "LT106": "Association",
        "LT107": "Small Partnership",
        "LT108": "Agricultural Company",
        "LT109": "Individual Enterprise / Sole proprietorship",
        "LT110": "Lawyers' Professional Partnership",
        "LT111": "Society of Private Detectives",
        "LT201": "State Enterprise",
        "LT202": "Municipal Enterprise",
        "LT203": "Public Institution",
        "LT204": "Budgetary Institution",
        "LT205": "Charity and Sponsorship Fund",
        "LT206": "Partnership",
        "LT207": "Gardeners’ Partnership",
        "LT208": "Political Party",
        "LT209": "Traditional Lithuanian Religious Congregation or Community",
        "LT210": "Religious Community and Association",
        "LT211": "Trade Union",
        "LT212": "Domicile Arbitration Institution",
        "LT213": "Foster Family",
        "LT214": "Chamber of commerce, industry and crafts",
        "LT215": "The Association of Lithuanian Chambers of Commerce, Industry and Crafts ",
        "LT216": "Combined Control and Reporting Centre",
        "LT217": "The Radio and Television Commission of Lithuania",
        "LT218": "Riflemen’s Union",
        "LT301": "Central Bank",
        "LU01": "Sole proprietorship",
        "LU03": "Limited liability company",
        "LU04": "Simplified limited liability company",
        "LU05": "Limited partnership",
        "LU06": "Special limited partnership",
        "LU07": "Public limited company",
        "LU08": "Partnership limited by shares",
        "LU09": "Open-ended investment company",
        "LU10": "Closed-ended investment company",
        "LU11": "Variable Capital Pension Savings Company ",
        "LU12": "Cooperative company",
        "LU13": "Civil company ",
        "LU14": "Temporary partnership",
        "LU15": "Economic interest group",
        "LU16": "Non-profit association ",
        "LU17": "Foundation",
        "LU18": "Pensions Savings Association ",
        "LU19": "Mutual Insurance Association ",
        "LU20": "Agricultural association ",
        "LU21": "Public establishment",
        "LU22": "Partnership",
        "LU23": "Company branch",
        "LU24": "Branch of a simplified limited liability company",
        "LU26": "Mutual Funds",
        "LU27": "Alternative investment funds reserved",
        "LU28": "Branch of an economic interest grouping",
        "LU30": "Branch of a civil company ",
        "LU32": "Other legal person",
        "LU33": "Public sector",
        "LV101": "Stock company",
        "LV103": "Limited liability company",
        "LV104": "State enterprise",
        "LV105": "Municipal enterprise",
        "LV106": "Enterprise of the company",
        "LV107": "General partnership",
        "LV108": "Limited partnership",
        "LV109": "Partnership with full responsibility",
        "LV110": "Joint stock company",
        "LV111": "Additional liability company",
        "LV301": "Sole proprietorship (family enterprise)  ",
        "LV302": "Individual merchant",
        "LV303": "Sole proprietorship (individual enterprise)  ",
        "LV401": "Cooperative society",
        "LV402": "Union of cooperative societies",
        "LV403": "Enterprise of cooperative societies",
        "LV404": "Enterprise of union of cooperative societies",
        "LV405": "Farm (farming enterprise)",
        "LV406": "Farm (fishing enterprise)",
        "LV801": "Enterprise of religious organisation",
        "LV802": "Enterprise of NGO",
        "LV902": "Branch",
        "LV903": "Permanent representative office",
        "MT020": "A limited Partnership",
        "MT021": "A general Partnership",
        "MT030": "Private limited company",
        "MT031": "Overseas Company",
        "MT032": "Investment companies with fixed share capital",
        "MT033": "Investment companies with variable share capital",
        "MT034": "Protected cell company",
        "MT040": "Voluntary/Non-for profit Organisations",
        "MT050": "General Government",
        "MT060": "Public limited company",
        "MT070": "Corporations",
        "MT080": "Cooperatives",
        "NL101": "private limited company",
        "NL102": "public limited company",
        "NL201": "cooperative",
        "NL202": "mutual insurance association",
        "NL203": "association, society",
        "NL204": "(home) owners' association",
        "NL205": "church or spiritual organisation",
        "NL206": "foundation, trust",
        "NL207": "other legal entities governed by private law",
        "NL401": "Legal entities governed by public law under Section 2:1(1) of the Dutch Civil Code, legal entities under public law as referred to in Section 2:1(1) of the DCC",
        "NL402": "Legal entities governed by public law under Section 2:1(2) of the Dutch Civil Code, legal entities under public law as referred to in Section 2:1(2) of the DCC",
        "PLA019": "civil law partnership",
        "PLA044": "higher education institution",
        "PLA070": "political party",
        "PLA085": "condominium",
        "PLA099": "sole proprietor",
        "PLA115": "professional partnership",
        "PLA116": "joint-stock company",
        "PLA117": "limited liability company",
        "PLA118": "registered partnership",
        "PLA120": "limited partnership",
        "PLA121": "limited joint-stock partnership",
        "PLA124": "state-owned enterprise (SOE)",
        "PLA126": "mutual insurance society",
        "PLA132": "state budget entity",
        "PLA134": "mutual reinsurance society",
        "PLA140": "co-operative",
        "PLA146": "independent public health care unit",
        "PLA148": "foundation",
        "PLA177": "machinery ring",
        "PLA180": "co-operative savings and credit union",
        "PLA403": "self-governed community",
        "PLA409": "the State Treasury",
        "PLA428": "state organizational unit",
        "PLB050": "churches and religious unions",
        "PLB055": "association or union of associations",
        "PLB060": "non-profit or professional organisatoin",
        "PLB133": "trade union",
        "PLB137": "federation",
        "PLB138": "union other than a trade union",
        "PLB141": "research institute ",
        "PLB147": "guild and craft chamber, chamber of commerce",
        "PLB381": "education system institution",
        "PLB401": "public authority body, government administration authority, state inspection authority",
        "PLB429": "self-government organizational unit",
        "PLC049": "investment fund",
        "PLD049": "open pension fund",
        "PLE049": "fund other than investment fund or open pension fund ",
        "PT111": "Complementary Grouping of Companies ",
        "PT121": "Private limited company",
        "PT122": "Single holder private limited company",
        "PT131": "Public limited company",
        "PT141": "Limited partnership",
        "PT151": "Partnerships",
        "PT161": "Public limited sports company",
        "PT171": "Civil society",
        "PT181": "Unregistered company",
        "PT182": "Individual business with limited liability",
        "PT211": "Cooperative",
        "PT221": "Association",
        "PT231": "Foundation",
        "PT311": "Public corporation",
        "PT312": "Public law institution",
        "PT321": "Municipal, Intermunicipal and Regional public company",
        "PT331": "Public Institution",
        "PT411": "Religious legal person",
        "PT711": "Funds",
        "PT901": "International Organizations",
        "RO101": "Joint Stock Company",
        "RO102": "Limited Liability Company (Ltd)",
        "RO103": "Limited partnership",
        "RO104": "Limited partnership with shares",
        "RO105": "Other legal forms",
        "RO107": "Non-Governmental Organization/Non-Profit institution",
        "RO108": "General partnership",
        "RO110": "Public company",
        "RO111": "Economic interest grouping",
        "RO114": "Consumer cooperative",
        "RO115": "Credit cooperative",
        "RO116": "Handicraft cooperative",
        "RO117": "Representative Office",
        "RO120": "Branch",
        "RO121": "Fiscal representative",
        "RO122": "Agricultural company",
        "RW100": "Corporations",
        "RW200": "Cooperatives",
        "RW300": "Partnerships",
        "RW400": "Sole traders",
        "RW500": "Limited liability company",
        "RW600": "Any other legal form not included in the above list",
        "SE21": "Regulated partnership between two parts",
        "SE22": "Limited shipping partnerships",
        "SE31": "Limited partnership",
        "SE32": "Mining partnerships",
        "SE41": "Limited banking companies",
        "SE42": "Limited insurance companies",
        "SE49": "Other limited companies",
        "SE51": "Economic association (minimum three members)",
        "SE53": "Tenant owners’ associations",
        "SE54": "Cooperative renting rights associations",
        "SE61": "Non-profit organisation",
        "SE62": "Joint-ownership associations",
        "SE63": "Registered religious communities",
        "SE71": "Family foundations",
        "SE72": "Other foundations and funds",
        "SE81": "Entities of central government",
        "SE82": "Municipalities",
        "SE83": "Federations of local government authorities",
        "SE84": "County councils",
        "SE85": "Social security offices",
        "SE87": "Public corporate bodies and institutions",
        "SE88": "Mortgage associations",
        "SE89": "Regional entities of central government",
        "SE91": "Estates of deceased persons",
        "SE92": "Mutual insurance corporations",
        "SE93": "Savings banks",
        "SE94": "Friendly societies",
        "SE95": "Unemployment benefit funds",
        "SE98": "Other Swedish legal persons subject to special legislation",
        "SI101": "Unlimited company (UK)",
        "SI102": "Limited partnership (UK)",
        "SI103": "Ltd (UK)",
        "SI104": "Plc (UK)",
        "SI105": "Limited partnership with share capital",
        "SI108": "Economic Interest Grouping EIG",
        "SI112": "Cooperative z.o.o.",
        "SI113": "Cooperative z.b.o.",
        "SI201": "Central Bank",
        "SI210": "Trust",
        "SI211": "Mutual insurance company d.v.z.",
        "SI213": "Public Fund",
        "SI300": "Public Agency",
        "SI301": "Republic of Slovenia",
        "SI302": "President of the Republic",
        "SI303": "Representative body (parliament, National council)",
        "SI304": "Human rights ombudsman",
        "SI305": "Constitutional Court",
        "SI306": "The court of Auditors",
        "SI307": "Government, government service",
        "SI308": "Ministry",
        "SI309": "Court (supreme, higher, district, county)",
        "SI310": "The prosecutor's office",
        "SI311": "Attorneys Office",
        "SI313": "Administrative body",
        "SI315": "Administrative unit",
        "SI316": "Authority, organization wider local community",
        "SI318": "Local communities",
        "SI319": "The local community, other local community",
        "SI321": "The Commissioner for Access to Public Information",
        "SI322": "Autonomous and independent state authority",
        "SI351": "Public company",
        "SI352": "Public economic institute",
        "SI354": "Institute",
        "SI355": "Public institute",
        "SI357": "Community of institutes",
        "SI358": "Chamber",
        "SI359": "University member",
        "SI360": "Chamber of Commerce",
        "SI361": "Public research institut",
        "SI362": "Community of homeowners",
        "SI401": "Institution",
        "SI402": "Agriculture, grazing and village communities",
        "SI403": "Other communities",
        "SI404": "Youth Council",
        "SI405": "Ethnic community",
        "SI406": "Student organization",
        "SI407": "Non-government organization",
        "SI451": "Political party",
        "SI452": "Union",
        "SI453": "Association, Federation",
        "SI458": "Religious community and religious organizations",
        "SI702": "Housing Association",
        "SI703": "Chamber of Crafts",
        "SI704": "Savings and credit services",
        "SI708": "Agricultural cooperative",
        "SI713": "Institute in private property",
        "SI715": "Social enterprise",
        "SI719": "Cooperative",
        "SI799": "Other forms of business entities",
        "SI801": "Branch of domestic companies",
        "SI803": "Overheads plant",
        "SI804": "Business unit",
        "SI806": "The cooperative unit",
        "SI807": "Organizational unit",
        "SI899": "Other forms of parts of business entities",
        "SK111": "Public commercial company",
        "SK112": "Limited liability company",
        "SK113": "Société commandite",
        "SK117": "Foundation",
        "SK118": "Non-investment fund",
        "SK119": "Not profitable organization",
        "SK120": "Non-profit organization providing community services",
        "SK121": "Joint stock company",
        "SK125": "Simple joint stock company",
        "SK205": "Cooperative",
        "SK271": "Associations of land owners, flats owner etc.",
        "SK301": "State enterprise",
        "SK311": "National Bank of Slovakia",
        "SK312": "Bank - state monetary institution",
        "SK321": "Budgetary organization",
        "SK331": "Organization based on state contributions",
        "SK381": "Funds",
        "SK382": "Public legal institution",
        "SK383": "Other organization of public administration",
        "SK421": "Foreign person, legal unit",
        "SK434": "Complementary pension funding",
        "SK445": "Commodity Exchange",
        "SK701": "Association (league, union, society, club, etc.)",
        "SK711": "Political party, political movement",
        "SK721": "Ecclesiastical organization",
        "SK741": "Professional organization - professional chamber",
        "SK745": "Chamber (except professional chambers)",
        "SK751": "Interest association of legal persons",
        "SK801": "Municipality (municipal office)",
        "SK803": "Office of local government (regional level)",
        "SK901": "Diplomatic corps of foreign country",
        "SK911": "Foreign centre for culture and information, agency for radio, press and television",
        "SK921": "International organization and association",
        "SK931": "Representation of foreign legal unit",
        "SPFUND": "Special funds are unincorporated investment funds comprising investment portfolios owned by the group of participants and whose management is undertaken, in general, by other financial corporations. Such funds are institutional units that are separate fro"
      },
      "LGL_PRCDNG_STTS": {
        "1": "Nesiimta teisinių veiksmų",
        "2": "Teisminės administracijos priežiūra, turto valdymo įmonės paskyrimas arba panašios priemonės",
        "3": "Bankrotas/nemokumas",
        "4": "Kitos teisinės priemonės"
      },
      "PRPS": {
        "4": "Garantinės įmokos skolinimas",
        "5": "Skolos finansavimas",
        "6": "Importas",
        "7": "Eksportas",
        "9": "Apyvartinio kapitalo priemonė",
        "11_A": "Kiti tikslai: vartojimo reikmėms",
        "11_B": "Kiti tikslai: vertybinių popierių įsigijimo finansavimas, išskyrus garantinės įmokos skolinimo sandorius",
        "11_C": "Kiti tikslai: transporto priemonių įsigijimas, išskyrus importui ir eksportui",
        "11_D": "Kiti tikslai: gamybos priemonių ir kito ilgalaikio materialaus turto įsigijimas, išskyrus importui ir eksportui",
        "11_E": "Kiti tikslai: kiti tikslai",
        "12_A": "Gyvenamojo nekilnojamojo turto pirkimas: pirmo gyvenamojo nekilnojamojo turto, skirto savo reikmėms, pirkimas",
        "12_B": "Gyvenamojo nekilnojamojo turto pirkimas: gyvenamojo nekilnojamojo turto, skirto nuomoti, pirkimas",
        "12_C": "Gyvenamojo nekilnojamojo turto pirkimas: kitas gyvenamojo nekilnojamojo turto pirkimas",
        "13_A": "Komercinio nekilnojamojo turto pirkimas: komercinio nekilnojamojo turto, skirto nuomoti, pirkimas",
        "13_B": "Komercinio nekilnojamojo turto pirkimas: kitas komercinio nekilnojamojo turto pirkimas",
        "8_A": "Statybų investicija: statybų investicija į pirmą gyvenamąjį nekilnojamąjį turtą, skirtą savo reikmėms",
        "8_B": "Statybų investicija: statybų investicija į gyvenamąjį nekilnojamąjį turtą, skirtą nuomoti",
        "8_C": "Statybų investicija: kita statybų investicija į gyvenamąjį nekilnojamąjį turtą",
        "8_D": "Statybų investicija: statybų investicija į komercinį nekilnojamąjį turtą, skirtą nuomoti",
        "8_E": "Statybų investicija: kita statybų investicija į komercinį nekilnojamąjį turtą"
      },
      "CNSMR_CRDT": {
        "1": "Taip",
        "2": "Ne"
      },
      "IMPRMNT_ASSSSMNT_MTHD": {
        "0": "Vertė nesumažėjo",
        "1": "Kolektyviai įvertinta",
        "2": "Individualiai įvertinta"
      },
      "IMPRMNT_STTS": {
        "0": "Vertė nesumažėjo",
        "21": "Bendrieji atidėjiniai (BAP)",
        "23": "1 etapas (TFAS)",
        "24": "2 etapas (TFAS)",
        "25": "3 etapas (TFAS)",
        "26": "Specialieji atidėjiniai (BAP)"
      },
      "CLNG": {
        "CLNG1": "Lietuvių",
        "CLNG2": "Rusų",
        "CLNG3": "Lenkų",
        "CLNG4": "Anglų",
        "CLNG7": "Ispanų",
        "CLNG6": "Prancūzų",
        "CLNG5": "Vokiečių",
        "CLNG8": "Kita"
      },
      "ADOR": {
        "ADOR1": "Iš kredito lėšų",
        "ADOR2": "Iš nuosavų lėšų"
      },
      "ACCC": {
        "ACCC99": "Kliento tranzitinė sąskaita",
        "ACCC16": "Mokėjimo kortelės sąskaita",
        "ACCC91": "Banko sąskaita",
        "ACCC92": "Indėlio sąskaita",
        "ACCC10": "Atsiskaitomoji sąskaita",
        "ACCC60": "Riboto naudojimo sąskaita",
        "ACCC90": "Kasininko sąskaita"
      },
      "ADREP": {
        "ADREP3": "Nuomininkas",
        "ADREP1": "Sąvininkas",
        "ADREP2": "Bendrasąvininkas"
      },
      "ADRET": {
        "ADRET4": "Gamybinės patalpos",
        "ADRET3": "Biurų patalpos",
        "ADRET2": "Butas",
        "ADRET1": "Gyvenamasis namas"
      },
      "ADRT": {
        "ADRT2": "Faktinis adresas",
        "ADRT1": "Deklaruotos gyvenamosios vietos/Registracijos adresas",
        "ADRT3": "Korespondencijos adresas"
      },
      "AMLRG": {
        "AMLRG1": "I (įprastos) rizikos grupė",
        "AMLRG2": "II (įprastos) rizikos grupė",
        "AMLRG3": "III (vidutinės) rizikos grupė",
        "AMLRG4": "IV (didelės) rizikos grupė"
      },
      "LANG": {
        "LT": "LT",
        "EN": "EN",
        "RU": "RU",
        "PL": "PL"
      },
      "CAP": {
        "CAP1": "1",
        "CAP2": "3",
        "CAP3": "6",
        "CAP4": "12"
      },
      "DERT": {
        "DERT1": "Su palūkanomis",
        "DERT2": "Be palūkanų",
        "DERT3": "Netaikoma"
      },
      "LOJO": {
        "LOJO1": "1",
        "LOJO2": "2",
        "LOJO3": "3",
        "LOJO4": "4",
        "LOJO5": "5"
      },
      "CCHAN": {
        "CCHAN1": "El.paštu",
        "CCHAN2": "Telefonu",
        "CCHAN3": "Paštu",
        "CCHAN4": "Unijoje",
        "CCHAN5": "Internetinės bankininkystės sistemoje"
      },
      "PRSTATE": {
        "PRSTNEW": "Ruošiama",
        "PRSTACT": "Aktyvi",
        "PRSTCLO": "Uždaryta",
        "PRSTBLO": "Blokuota",
        "PRSTCNL": "Atmesta",
        "SUSPENDED": "Sustabdyta"
      },
      "PEPLINK": {
        "PEPLINK1": "Sutuoktinis (-ė)/Sugyventinis (-ė)",
        "PEPLINK2": "Tėvas",
        "PEPLINK3": "Motina",
        "PEPLINK4": "Brolis",
        "PEPLINK5": "Sesuo",
        "PEPLINK6": "Sūnus",
        "PEPLINK7": "Dukra",
        "PEPLINK8": "Sūnaus sutuoktinė/Sugyventinė",
        "PEPLINK9": "Dukters sutuoktinis/Sugyventinis"
      },
      "PEPLIST": {
        "PEPLIST1": "Pats",
        "PEPLIST2": "Artimas šeimos narys",
        "PEPLIST3": "Artimas pagalbininkas"
      },
      "DJAA": {
        "0": "Nepasirinktas",
        "1": "Pasirinktas",
        "2": "Atmestas"
      },
      "DOCS": {
        "DOCS1": "LR piliečio pasas",
        "DOCS2": "Užsienio valstybės piliečio pasas",
        "DOCS3": "LR tarnybinis pasas",
        "DOCS4": "LR užsieniečio pasas",
        "DOCS5": "ES valstybės narės piliečio pasas",
        "DOCS6": "LR asmens tapatybės kortelė",
        "DOCS7": "ES valstybės narės piliečio asmens tapatybės kortelė",
        "DOCS8": "Leidimas nuolat ar laikinai gyventi Lietuvos Respublikoje"
      },
      "DJAST": {
        "DJAST1": "1",
        "DJAST10": "10",
        "DJAST2": "2",
        "DJAST3": "3",
        "DJAST4": "4",
        "DJAST5": "5",
        "DJAST6": "6",
        "DJAST7": "7",
        "DJAST8": "8",
        "DJAST9": "9"
      },
      "MAILL": {
        "MAILL1": "Asmeninis",
        "MAILL2": "Darbo",
        "MAILL3": "Įmonės"
      },
      "CPLSEF": {
        "CPLSEF1": "1",
        "CPLSEF2": "2",
        "CPLSEF3": "3",
        "CPLSEF4": "4",
        "CPLSEF5": "5",
        "CPLSEF6": "6",
        "CPLSEF7": "7",
        "CPLSEF8": "8",
        "CPLSEF9": "9"
      },
      "CPLSE": {
        "CPLSE1": "Pinigų pervedimai",
        "CPLSE10": "Prekybos finansavimas",
        "CPLSE11": "Žemės ūkio finansavimas",
        "CPLSE12": "Lizingai/faktoringai",
        "CPLSE13": "Vartojimo kreditai",
        "CPLSE14": "Kita",
        "CPLSE15": "Grynųjų pinigų operacijos",
        "CPLSE16": "Elektroninė bankininkystė",
        "CPLSE17": "Mokėjimo kortelės",
        "CPLSE2": "Valiutos keitimas",
        "CPLSE3": "Indėliai",
        "CPLSE4": "Darbo užmokesčio pervedimas",
        "CPLSE5": "Kita",
        "CPLSE6": "Investicinis kreditas",
        "CPLSE7": "Kreditas smulkiam verslui",
        "CPLSE8": "Kredito linija",
        "CPLSE9": "Kreditas su valstybės parama"
      },
      "REP": {
        "REP1": "1",
        "REP2": "2",
        "REP3": "3",
        "REP4": "4",
        "REP5": "5"
      },
      "CEO": {
        "CEO1": "1",
        "CEO2": "2",
        "CEO3": "3",
        "CEO4": "4",
        "CEO5": "5"
      },
      "BEN": {
        "BEN1": "1",
        "BEN2": "2",
        "BEN3": "3",
        "BEN4": "4",
        "BEN5": "5"
      },
      "ADC": {
        "ADC1": "1",
        "ADC2": "2",
        "ADC3": "3",
        "ADC4": "4",
        "ADC5": "5"
      },
      "MORERE": {
        "NT": "Būsto",
        "VART": "Vartojimo (Kortelių limitai)",
        "ZU": "Žemės ūkio",
        "VERSL": "Smulkaus ir vidutinio verslo",
        "SPEK": "Spekuliacinė",
        "KRED": "Kreditai užtikrinami NT"
      },
      "COMP": {
        "COMP1": "1",
        "COMP2": "2",
        "COMP3": "3",
        "COMP4": "4",
        "COMP5": "5"
      },
      "LOII": {
        "E3": "Euribor 3",
        "E6": "Euribor 6",
        "E12": "Euribor 12"
      },
      "LOIP": {
        "QUART": "3",
        "HALF": "6",
        "MONTH": "12"
      },
      "DEJO": {
        "DEJO1": "1",
        "DEJO2": "2",
        "DEJO3": "3",
        "DEJO4": "4",
        "DEJO5": "5"
      },
      "DEPT": {
        "DEPT1": "Terminuotas indėlis",
        "DEPT2": "Lojalus terminuotas indėlis",
        "DEPT3": "Terminuotas indėlis internetu",
        "DEPT4": "Taupomasis indėlis (Taupymo sąskaita)",
        "DEPT5": "Tikslinis taupomasis indėlis",
        "DEPT6": "Ilgalaikis taupomasis indėlis (Senatvės kaupimo indėlis)",
        "DEPT7": "Vaiko indėlis",
        "DEPT8": "Kaupiamasis indėlis",
        "DEPT9": "Indėlio palūkanos dabar (arba Indėlis su palūkanomis avansu)",
        "DEPT10": "Palūkanų normos indėlis",
        "DEPT11": "Indėlis bankui",
        "DEPT12": "Terminuotas indėlis su pajumi",
        "DEPT99": "Informacija indėlininkui"
      },
      "ACCOW": {
        "ONE": "Vienas",
        "TWO": "Du"
      },
      "PCC": {
        "PCC1": "1",
        "PCC2": "2",
        "PCC3": "3",
        "PCC4": "4",
        "PCC5": "5"
      },
      "PAYM": {
        "PAYM1": "Grynais",
        "PAYM2": "Pavedimu",
        "PAYM3": "Pavedimu tiekėjui pagal sąskaitą"
      },
      "CLED": {
        "CLED1": "Beraštis",
        "CLED10": "Magistratūra",
        "CLED11": "Doktarantūra",
        "CLED2": "Pradinis",
        "CLED3": "Nebaigtas vidurinis",
        "CLED4": "Vidurinis",
        "CLED5": "Spec. Vidurinis",
        "CLED6": "Aukštesnysis",
        "CLED7": "Aukštasis neuniversitetinis",
        "CLED8": "Aukštasis universitetinis",
        "CLED9": "Bakalauras"
      },
      "CCAP": {
        "CCAP1": "Privatus (>50 proc.)",
        "CCAP2": "Valstybės ir savivaldybės (>50 proc.)"
      },
      "REPC": {
        "REPC1": "1",
        "REPC2": "2",
        "REPC3": "3",
        "REPC4": "4",
        "REPC5": "5"
      },
      "CEOC": {
        "CEOC1": "1",
        "CEOC2": "2",
        "CEOC3": "3",
        "CEOC4": "4",
        "CEOC5": "5"
      },
      "CASH": {
        "CASH1": "1",
        "CASH2": "2",
        "CASH3": "3",
        "CASH4": "4",
        "CASH5": "5"
      },
      "OP": {
        "USER": "Naudotojas",
        "JOINT": "Bendraskolis",
        "SPO": "Sutuoktinis"
      },
      "TAXPER": {
        "TAXPER1": "Termino pabaigoje",
        "TAXPER2": "Kas mėnesį",
        "TAXPER3": "Kas ketvirtį",
        "TAXPER4": "Metinis",
        "TAXPER5": "Vienkartinis"
      },
      "RELT": {
        "RELT1": "BusPartner",
        "RELT2": "Beneficiaries",
        "RELT3": "CEO",
        "RELT4": "Rep",
        "RELT5": "AccountBank",
        "RELT6": "Delegate",
        "RELT7": "Joint"
      },
      "CSIZE": {
        "CSIZE1": "Labai maža įmonė (10 darbuotojų, apyvarta 700000 Eur)",
        "CSIZE2": "Maža įmonė (50 darbuotojų, apyvarta 8000000 Eur)",
        "CSIZE3": "Vidutinė įmonė (250 darbuotojų, apyvarta 40000000 Eur)",
        "CSIZE4": "Didelė įmonė (>250 darbuotojų, apyvarta > 40000000 Eur)"
      },
      "LIAB": {
        "LIAB1": "1",
        "LIAB10": "10",
        "LIAB2": "2",
        "LIAB3": "3",
        "LIAB4": "4",
        "LIAB5": "5",
        "LIAB6": "6",
        "LIAB7": "7",
        "LIAB8": "8",
        "LIAB9": "9"
      },
      "BENEF": {
        "BENEF1": "1",
        "BENEF2": "2",
        "BENEF3": "3",
        "BENEF4": "4",
        "BENEF5": "5"
      },
      "CPROF": {
        "CPROF1": "Fizinis asmuo",
        "CPROF2": "Advokatas",
        "CPROF3": "Notaras",
        "CPROF4": "Antstolis",
        "CPROF5": "Ūkininkas",
        "CPROF6": "Fizinis Idv_verslo liud.",
        "CPROF7": "Juridinis asmuo",
        "CPROF8": "Finansinė veikla",
        "CPROF9": "Lietuvos Bankai",
        "CPROF10": "Bankai ES",
        "CPROF11": "Bankai ne ES",
        "CPROF12": "Juridinis asmuo TŪB_KŪB",
        "CPROF13": "Kredito unijos",
        "CPROF14": "Advokatų bendrija",
        "CPROF15": "Kitos kooperatinės  bendrovės",
        "CPROF16": "Centrinė kredito unija",
        "CPROF17": "Kredito unijų asociacijos",
        "CPROF18": "Lietuvos centrinis bankas",
        "CPROF19": "Valstybinės įmonės",
        "CPROF20": "Savivaldybių įmonės",
        "CPROF21": "Biudžetinės įstaigos",
        "CPROF22": "Viešosios įstaigos",
        "CPROF23": "Kitos organizacijos",
        "CPROF24": "Nepilnametis fizinis asmuo",
        "CPROF25": "Tikrasis narys",
        "CPROF26": "Juridinis asocijuotas narys",
        "CPROF27": "Darbuotojas",
        "CPROF28": "Tiekėjas",
        "CPROF29": "Paskolų teikėjas"
      },
      "CRGT": {
        "AML": "AML",
        "DJ": "Dow Jones",
        "Final": "Final Risk"
      },
      "RISK": {
        "RISK1": "1",
        "RISK10": "10",
        "RISK11": "11",
        "RISK12": "12",
        "RISK13": "13",
        "RISK14": "14",
        "RISK15": "15",
        "RISK16": "16",
        "RISK17": "17",
        "RISK18": "18",
        "RISK19": "19",
        "RISK2": "2",
        "RISK20": "20",
        "RISK21": "21",
        "RISK22": "22",
        "RISK23": "23",
        "RISK24": "24",
        "RISK25": "25",
        "RISK26": "26",
        "RISK27": "27",
        "RISK28": "28",
        "RISK29": "29",
        "RISK3": "3",
        "RISK30": "30",
        "RISK4": "4",
        "RISK5": "5",
        "RISK6": "6",
        "RISK7": "7",
        "RISK8": "8",
        "RISK9": "9"
      },
      "CLSTAT": {
        "CLSTAT1": "Nepatvirtintas",
        "CLSTAT2": "Patvirtintas",
        "CLSTAT3": "Atmestas",
        "CLSTAT4": "Uždarytas",
        "CLSTAT5": "Kontaktas"
      },
      "CLSTAR": {
        "CLSTAR1": "Nepriimtina riziką",
        "CLSTAR2": "Neatitinka įstatymų ir kredito unijos įstatų reikalavimų"
      },
      "CLST": {
        "CLST1": "1",
        "CLST10": "10",
        "CLST2": "2",
        "CLST3": "3",
        "CLST4": "4",
        "CLST5": "5",
        "CLST6": "6",
        "CLST7": "7",
        "CLST8": "8",
        "CLST9": "9"
      },
      "CSTAT": {
        "FA": "Fizinis asmuo",
        "JA": "Juridinis asmuo"
      },
      "REL": {
        "REL1": "1",
        "REL10": "10",
        "REL11": "11",
        "REL2": "2",
        "REL3": "3",
        "REL4": "4",
        "REL5": "5",
        "REL6": "6",
        "REL7": "7",
        "REL8": "8",
        "REL9": "9"
      },
      "CARI": {
        "CARI1": "B",
        "CARI2": "C"
      },
      "CAT": {
        "CAT1": "MasterCard",
        "CAT2": "Maestro"
      },
      "PT": {
        "PT1": "1",
        "PT10": "10",
        "PT2": "2",
        "PT3": "3",
        "PT4": "4",
        "PT5": "5",
        "PT6": "6",
        "PT7": "7",
        "PT8": "8",
        "PT9": "9"
      },
      "LOAF": {
        "LOAF1": "Nuosavos lėšos",
        "LOAF2": "Invega",
        "LOAF3": "Invega2",
        "LOAF4": "ŽŪPGF",
        "LOAF5": "Stabilizacijos fondas",
        "LOAF6": "Kiti lėšų šaltiniai"
      },
      "PONE": {
        "PONE1": "Teigiamas",
        "PONE2": "Neigiamas"
      },
      "SVFST": {
        "SVFST1": "Maža",
        "SVFST2": "Labai maža"
      },
      "SVFSA": {
        "SVFSA1": "Akmenės rajono savivaldybė",
        "SVFSA10": "Jonavos rajono savivaldybė",
        "SVFSA11": "Joniškio rajono savivaldybė",
        "SVFSA12": "Jurbarko rajono savivaldybė",
        "SVFSA13": "Kaišiadorių rajono savivaldybė",
        "SVFSA14": "Kalvarijos savivaldybė",
        "SVFSA15": "Kauno miesto savivaldybė",
        "SVFSA16": "Kauno rajono savivaldybė",
        "SVFSA17": "Kazlų Rūdos savivaldybė",
        "SVFSA18": "Kelmės rajono savivaldybė",
        "SVFSA19": "Klaipėdos miesto savivaldybė",
        "SVFSA2": "Alytaus miesto savivaldybė",
        "SVFSA20": "Klaipėdos rajono savivaldybė",
        "SVFSA21": "Kretingos rajono savivaldybė",
        "SVFSA22": "Kupiškio rajono savivaldybė",
        "SVFSA23": "Kėdainių rajono savivaldybė",
        "SVFSA24": "Lazdijų rajono savivaldybė",
        "SVFSA25": "Marijampolės savivaldybė",
        "SVFSA26": "Mažeikių rajono savivaldybė",
        "SVFSA27": "Molėtų rajono savivaldybė",
        "SVFSA28": "Neringos savivaldybė",
        "SVFSA29": "Pagėgių savivaldybė",
        "SVFSA3": "Alytaus rajono savivaldybė",
        "SVFSA30": "Pakruojo rajono savivaldybė",
        "SVFSA31": "Palangos miesto savivaldybė",
        "SVFSA32": "Panevėžio miesto savivaldybė",
        "SVFSA33": "Panevėžio rajono savivaldybė",
        "SVFSA34": "Pasvalio rajono savivaldybė",
        "SVFSA35": "Plungės rajono savivaldybė",
        "SVFSA36": "Prienų rajono savivaldybė",
        "SVFSA37": "Radviliškio rajono savivaldybė",
        "SVFSA38": "Raseinių rajono savivaldybė",
        "SVFSA39": "Rietavo savivaldybė",
        "SVFSA4": "Anykščių rajono savivaldybė",
        "SVFSA40": "Rokiškio rajono savivaldybė",
        "SVFSA41": "Skuodo rajono savivaldybė",
        "SVFSA42": "Tauragės rajono savivaldybė",
        "SVFSA43": "Telšių rajono savivaldybė",
        "SVFSA44": "Trakų rajono savivaldybė",
        "SVFSA45": "Ukmergės rajono savivaldybė",
        "SVFSA46": "Utenos rajono savivaldybė",
        "SVFSA47": "Varėnos rajono savivaldybė",
        "SVFSA48": "Vilkaviškio rajono savivaldybė",
        "SVFSA49": "Vilniaus miesto savivaldybė",
        "SVFSA5": "Birštono savivaldybė",
        "SVFSA50": "Vilniaus rajono savivaldybė",
        "SVFSA51": "Visagino savivaldybė",
        "SVFSA52": "Zarasų rajono savivaldybė",
        "SVFSA53": "Šakių rajono savivaldybė",
        "SVFSA54": "Šalčininkų rajono savivaldybė",
        "SVFSA55": "Šiaulių miesto savivaldybė",
        "SVFSA56": "Šiaulių rajono savivaldybė",
        "SVFSA57": "Šilalės rajono savivaldybė",
        "SVFSA58": "Šilutės rajono savivaldybė",
        "SVFSA59": "Širvintų rajono savivaldybė",
        "SVFSA6": "Biržų rajono savivaldybė",
        "SVFSA60": "Švenčionių rajono savivaldybė",
        "SVFSA7": "Druskininkų savivaldybė",
        "SVFSA8": "Elektrėnų savivaldybė",
        "SVFSA9": "Ignalinos rajono savivaldybė"
      },
      "LORT": {
        "LORT2": "Linijinis",
        "LORT1": "Anuitetas",
        "LORT3": "Individualus",
        "LORT4": "Grąžinimas termino pabaigoje",
        "LORT5": "Palūkanų kas mėnesį paskola"
      },
      "CRET": {
        "CRET1": "1",
        "CRET2": "2",
        "CRET3": "3",
        "CRET4": "4",
        "CRET5": "5"
      },
      "SVFCT": {
        "SVFCT1": "Investicinis",
        "SVFCT2": "Apyvartinis"
      },
      "CFUSC": {
        "CFUSC1": "1",
        "CFUSC10": "10",
        "CFUSC2": "2",
        "CFUSC3": "3",
        "CFUSC4": "4",
        "CFUSC5": "5",
        "CFUSC6": "6",
        "CFUSC7": "7",
        "CFUSC8": "8",
        "CFUSC9": "9"
      },
      "MEMB": {
        "1": "1",
        "2": "2",
        "3": "3"
      },
      "DAY": {
        "DAY1": "1",
        "DAY2": "2",
        "DAY3": "3",
        "DAY4": "4",
        "DAY5": "5",
        "DAY6": "6",
        "DAY7": "7",
        "DAY8": "8",
        "DAY9": "9",
        "DAY10": "10",
        "DAY11": "11",
        "DAY12": "12",
        "DAY13": "13",
        "DAY14": "14",
        "DAY15": "15",
        "DAY16": "16",
        "DAY17": "17",
        "DAY18": "18",
        "DAY19": "19",
        "DAY20": "20",
        "DAY21": "21",
        "DAY22": "22",
        "DAY23": "23",
        "DAY24": "24",
        "DAY25": "25",
        "DAY26": "26",
        "DAY27": "27",
        "DAY28": "28",
        "DAY29": "29",
        "DAY30": "30",
        "DAY31": "31"
      },
      "LIAT": {
        "LIAB1": "Paskola",
        "LIAB2": "Lizingas",
        "LIAB3": "Skola",
        "LIAB4": "Laidavimas",
        "LIAB5": "Alimentai"
      },
      "TAXC": {
        "TAXC1": "Valstybė 1",
        "TAXC2": "Valstybė 2",
        "TAXC3": "Valstybė 3",
        "TAXC4": "Valstybė 4",
        "TAXC5": "Valstybė 5"
      },
      "NTT": {
        "NTT1": "Butas",
        "NTT2": "Individualus gyvenamasis namas",
        "NTT3": "Daugiabutis gyvenamasi namas",
        "NTT4": "Ūkinės paskirties pastatas"
      },
      "PROP": {
        "PROP1": "Nekilnojamas turtas",
        "PROP2": "Kitas turtas",
        "PROP3": "Vertybiniai popieriai",
        "PROP4": "Likučiai kredito įstaigose",
        "PROP5": "Negautos pajamos už prod."
      },
      "OVET": {
        "OVET1": "1",
        "OVET2": "2",
        "OVET3": "3",
        "OVET4": "4",
        "OVET5": "5"
      },
      "CBB": {
        "A.": "ŽEMĖS ŪKIS, MIŠKININKYSTĖ IR ŽUVININKYSTĖ",
        "A.01.13.40": "Daržovių auginimas uždarame grunte",
        "B.08": "Kita kasyba ir karjerų eksploatavimas",
        "M.74.10": "Specializuota projektavimo veikla",
        "M.74.2": "Fotografavimo veikla",
        "M.74.20": "Fotografavimo veikla",
        "M.74.3": "Vertimo raštu ir žodžiu veikla",
        "M.74.30": "Vertimo raštu ir žodžiu veikla",
        "M.74.9": "Kita, niekur kitur nepriskirta, profesinė, mokslinė ir techninė veikla",
        "M.74.90": "Kita, niekur kitur nepriskirta, profesinė, mokslinė ir techninė veikla",
        "M.75": "Veterinarinė veikla",
        "M.75.0": "Veterinarinė veikla",
        "M.75.00": "Veterinarinė veikla",
        "B.08.1": "Akmens, smėlio ir molio karjerų eksploatavimas",
        "M.75.00.10": "Gyvulių ir gyvūnų stacionarinis gydymas",
        "M.75.00.20": "Gyvulių ir gyvūnų ambulatorinis gydymas",
        "M.75.00.30": "Veterinarinė diagnostinė veikla",
        "M.75.00.40": "Veterinarijos laboratorijų veikla",
        "N.": "ADMINISTRACINĖ IR APTARNAVIMO VEIKLA",
        "N.77": "Nuoma ir išperkamoji nuoma",
        "N.77.1": "Variklinių transporto priemonių nuoma ir išperkamoji nuoma",
        "N.77.11": "Automobilių ir lengvųjų variklinių transporto priemonių nuoma ir išperkamoji nuoma",
        "N.77.12": "Sunkiasvorių variklinių transporto priemonių nuoma ir išperkamoji nuoma",
        "N.77.12.10": "Krovininių automobilių nuoma",
        "B.08.11": "Dekoratyvinio ir statybinio akmens, klinčių, gipso, kreidos ir skalūno karjerų eksploatavimas",
        "N.77.12.20": "Turistinių autobusų nuoma",
        "N.77.2": "Asmeninių ir namų ūkio prekių nuoma ir išperkamoji nuoma",
        "N.77.21": "Poilsio ir sporto reikmenų nuoma ir išperkamoji nuoma",
        "N.77.21.10": "Pramoginių valčių nuoma",
        "N.77.21.20": "Jojamųjų žirgų nuoma",
        "N.77.21.30": "Dviračių nuoma",
        "N.77.21.40": "Sporto įrangos nuoma",
        "N.77.21.50": "Kitų turizmo priemonių nuoma",
        "N.77.22": "Vaizdajuosčių ir kompaktinių diskų nuoma",
        "N.77.29": "Kitų asmeninių ir namų ūkio prekių nuoma ir išperkamoji nuoma",
        "B.08.12": "Smėlio ir žvyro karjerų eksploatavimas; molio ir kaolino kasyba",
        "N.77.29.10": "Tekstilės dirbinių, drabužių ir avalynės nuoma",
        "N.77.29.20": "Baldų ir kitų asmeniniam naudojimui skirtų daiktų nuoma",
        "N.77.29.30": "Muzikos instrumentų, teatro dekoracijų ir kostiumų nuoma",
        "N.77.3": "Kitų mašinų, įrangos ir materialiųjų vertybių nuoma ir išperkamoji nuoma",
        "N.77.31": "Žemės ūkio mašinų ir įrenginių nuoma ir išperkamoji nuoma",
        "N.77.32": "Statybos ir inžinerinių statybos darbų mašinų ir įrenginių nuoma ir išperkamoji nuoma",
        "N.77.33": "Įstaigos mašinų ir įrangos, įskaitant kompiuterius, nuoma ir išperkamoji nuoma",
        "N.77.33.10": "Kompiuterių nuoma",
        "N.77.33.20": "Kopijavimo, spausdinimo ir teksto apdorojimo mašinų nuoma",
        "N.77.33.30": "Kasos aparatų nuoma",
        "B.08.9": "Niekur kitur nepriskirta kasyba ir karjerų eksploatavimas",
        "N.77.34": "Vandens transporto priemonių ir įrangos nuoma ir išperkamoji nuoma",
        "N.77.35": "Oro transporto priemonių ir įrangos nuoma ir išperkamoji nuoma",
        "N.77.39": "Kitų, niekur kitur nepriskirtų, mašinų, įrangos ir materialiųjų vertybių nuoma ir išperkamoji nuoma",
        "N.77.39.10": "Geležinkelio transporto priemonių nuoma",
        "N.77.39.20": "Motociklų nuoma",
        "N.77.39.30": "Automobilinių namelių nuoma",
        "N.77.39.40": "Konteinerių, kilnojamųjų platformų ir padėklų nuoma",
        "N.77.39.50": "Pramoninių elektrinių ir neelektrinių mašinų nuoma",
        "N.77.39.60": "Radijo ir televizijos įrenginių nuoma",
        "N.77.39.70": "Ryšių įrenginių nuoma",
        "B.08.91": "Mineralinių iškasenų chemijos pramonei ir trąšoms gaminti kasyba",
        "N.77.39.80": "Matavimo ir kontrolės įrenginių nuoma",
        "N.77.4": "Intelektinės nuosavybės ir panašių produktų, išskyrus autorių teisių saugomus objektus, išperkamoji nuoma",
        "N.77.40": "Intelektinės nuosavybės ir panašių produktų, išskyrus autorių teisių saugomus objektus, išperkamoji nuoma",
        "N.78": "Įdarbinimo veikla",
        "N.78.1": "Įdarbinimo agentūrų veikla",
        "N.78.10": "Įdarbinimo agentūrų veikla",
        "N.78.2": "Laikinojo įdarbinimo agentūrų veikla",
        "N.78.20": "Laikinojo įdarbinimo agentūrų veikla",
        "N.78.3": "Kitas darbo jėgos teikimas",
        "N.78.30": "Kitas darbo jėgos teikimas",
        "B.08.92": "Durpių gavyba",
        "N.79": "Kelionių agentūrų, ekskursijų organizatorių, išankstinio užsakymo paslaugų ir susijusi veikla (PPP)",
        "N.79.1": "Kelionių agentūrų ir ekskursijų organizatorių veikla (PPP)",
        "N.79.11": "Kelionių agentūrų veikla (PPP)",
        "N.79.12": "Ekskursijų organizatorių veikla (PPP)",
        "N.79.9": "Kitų išankstinio užsakymo ir susijusių paslaugų veikla",
        "N.79.90": "Kitų išankstinio užsakymo ir susijusių paslaugų veikla",
        "N.80": "Apsaugos ir tyrimo veikla",
        "N.80.1": "Privati apsauga",
        "N.80.10": "Privati apsauga",
        "N.80.2": "Apsaugos sistemų paslaugų veikla",
        "B.08.93": "Druskos gavyba",
        "N.80.20": "Apsaugos sistemų paslaugų veikla",
        "N.80.3": "Tyrimo veikla",
        "N.80.30": "Tyrimo veikla",
        "N.81": "Pastatų aptarnavimas ir kraštovaizdžio tvarkymas",
        "N.81.1": "Kombinuota patalpų funkcionavimo užtikrinimo veikla",
        "N.81.10": "Kombinuota patalpų funkcionavimo užtikrinimo veikla",
        "N.81.2": "Valymo veikla",
        "N.81.21": "Paprastasis pastatų valymas",
        "N.81.22": "Kita pastatų ir pramoninio valymo veikla",
        "N.81.29": "Kita valymo veikla",
        "B.08.99": "Kita, niekur kitur nepriskirta, kasyba ir karjerų eksploatavimas",
        "N.81.3": "Kraštovaizdžio tvarkymas",
        "N.81.30": "Kraštovaizdžio tvarkymas",
        "N.82": "Administracinė veikla, įstaigų ir kitų verslo įmonių aptarnavimo veikla",
        "N.82.1": "Įstaigų administracinė ir aptarnavimo veikla",
        "N.82.11": "Kombinuotųjų įstaigos administracinių paslaugų veikla",
        "N.82.19": "Fotokopijavimo, dokumentų rengimo ir kita specializuota įstaigai būdingų paslaugų veikla",
        "N.82.2": "Užsakomųjų informacinių paslaugų centrų veikla",
        "N.82.20": "Užsakomųjų informacinių paslaugų centrų veikla",
        "N.82.3": "Posėdžių ir verslo renginių organizavimas",
        "N.82.30": "Posėdžių ir verslo renginių organizavimas",
        "B.09": "Kasybai būdingų paslaugų veikla",
        "N.82.9": "Niekur kitur nepriskirta verslui būdingų paslaugų veikla",
        "N.82.91": "Išieškojimo agentūrų ir kredito biurų veikla",
        "N.82.92": "Fasavimo ir pakavimo veikla",
        "N.82.99": "Kita, niekur kitur nepriskirta, verslui būdingų paslaugų veikla",
        "O.": "VIEŠASIS VALDYMAS IR GYNYBA; PRIVALOMASIS SOCIALINIS DRAUDIMAS",
        "O.84": "Viešasis valdymas ir gynyba; privalomasis socialinis draudimas",
        "O.84.1": "Valstybės valdymas ir bendroji ekonominė bei socialinė bendruomenės politika",
        "O.84.11": "Bendroji viešojo valdymo veikla",
        "O.84.11.10": "Lietuvos Respublikos apskričių veikla",
        "O.84.11.20": "Lietuvos Respublikos savivaldybių veikla",
        "A.01.13.50": "Daržovių sėklų gavyba",
        "B.09.1": "Naftos ir gamtinių dujų gavybai būdingų paslaugų veikla",
        "O.84.11.30": "Lietuvos Respublikos seniūnijų veikla",
        "O.84.11.40": "Iždo valdymas ir priežiūra",
        "O.84.11.50": "Biudžeto vykdymas ir valstybinių fondų tvarkymas",
        "O.84.11.60": "Centrinių administracinių institucijų įstatymų leidžiamoji ir vykdomoji veikla",
        "O.84.11.70": "Vadovavimas muitinės tarnyboms ir jų veikla",
        "O.84.11.80": "Vadovavimas statistikos ir sociologijos tarnyboms įvairiuose valstybės valdymo lygiuose bei jų veikla",
        "O.84.12": "Sveikatos priežiūros, švietimo, kultūros ir kitų socialinių paslaugų, išskyrus socialinį draudimą, veiklos reguliavimas",
        "O.84.13": "Verslo veiklos reguliavimas ir parama efektyviau ją organizuoti",
        "O.84.2": "Bendruomenei teikiamų paslaugų užtikrinimas",
        "O.84.21": "Užsienio reikalai",
        "B.09.10": "Naftos ir gamtinių dujų gavybai būdingų paslaugų veikla",
        "O.84.22": "Gynybos veikla",
        "O.84.23": "Teisingumo ir teisminė veikla",
        "O.84.24": "Viešosios tvarkos ir apsaugos veikla",
        "O.84.25": "Priešgaisrinių tarnybų veikla",
        "O.84.3": "Privalomojo (valstybinio) socialinio draudimo veikla",
        "O.84.30": "Privalomojo (valstybinio) socialinio draudimo veikla",
        "P.": "ŠVIETIMAS",
        "P.85": "Švietimas",
        "P.85.1": "Ikimokyklinis ugdymas",
        "P.85.10": "Ikimokyklinis ugdymas",
        "B.09.10.10": "Gamtinių dujų parengimas transportuoti (gabenti)",
        "P.85.10.10": "Ikimokyklinio amžiaus vaikų ugdymas",
        "P.85.10.20": "Priešmokyklinio amžiaus vaikų ugdymas",
        "P.85.2": "Pradinis ugdymas",
        "P.85.20": "Pradinis ugdymas",
        "P.85.3": "Vidurinis ugdymas",
        "P.85.31": "Bendrasis vidurinis ugdymas",
        "P.85.31.10": "Pagrindinis ugdymas",
        "P.85.31.20": "Vidurinis ugdymas",
        "P.85.32": "Techninis ir profesinis vidurinis mokymas",
        "P.85.4": "Aukštasis mokslas",
        "B.09.9": "Kitai kasybai ir karjerų eksploatavimui būdingų paslaugų veikla",
        "P.85.41": "Aukštojo mokslo laipsnio nesuteikiantis mokymas baigus vidurinę mokyklą",
        "P.85.42": "Aukštasis (tretinis) mokslas",
        "P.85.42.10": "Aukštasis neuniversitetinis mokslas",
        "P.85.42.20": "Aukštasis universitetinis mokslas",
        "P.85.42.30": "Doktorantūra",
        "P.85.5": "Kitas mokymas",
        "P.85.51": "Sportinis ir rekreacinis švietimas",
        "P.85.52": "Kultūrinis švietimas",
        "P.85.53": "Vairavimo mokyklų veikla",
        "P.85.59": "Kitas, niekur kitur nepriskirtas, švietimas",
        "B.09.90": "Kitai kasybai ir karjerų eksploatavimui būdingų paslaugų veikla",
        "P.85.6": "Švietimui būdingų paslaugų veikla",
        "P.85.60": "Švietimui būdingų paslaugų veikla",
        "Q.": "ŽMONIŲ SVEIKATOS PRIEŽIŪRA IR SOCIALINIS DARBAS",
        "Q.86": "Žmonių sveikatos priežiūros veikla",
        "Q.86.1": "Ligoninių veikla",
        "Q.86.10": "Ligoninių veikla",
        "Q.86.10.10": "Bendrosios paskirties ligoninių veikla",
        "Q.86.10.20": "Specializuotųjų ligoninių veikla",
        "Q.86.10.30": "Reabilitacijos ligoninių veikla",
        "Q.86.10.40": "Slaugos ligoninių veikla",
        "C.": "APDIRBAMOJI GAMYBA",
        "Q.86.2": "Medicininės ir odontologinės praktikos veikla",
        "Q.86.21": "Bendrosios praktikos gydytojų veikla",
        "Q.86.22": "Gydytojų specialistų veikla",
        "Q.86.23": "Odontologinės praktikos veikla",
        "Q.86.9": "Kita žmonių sveikatos priežiūros veikla",
        "Q.86.90": "Kita žmonių sveikatos priežiūros veikla",
        "Q.86.90.10": "Viduriniojo medicinos personalo paslaugų teikiamas ligoniams ne ligoninėse",
        "Q.86.90.20": "Kraujo perpylimo įstaigų ir kraujo bankų veikla",
        "Q.86.90.30": "Medicinos laboratorijų veikla",
        "Q.86.90.40": "Greitosios pagalbos veikla",
        "C.10": "Maisto produktų gamyba",
        "Q.87": "Kita stacionarinė globos veikla",
        "Q.87.1": "Stacionarinė slaugos įstaigų veikla",
        "Q.87.10": "Stacionarinė slaugos įstaigų veikla",
        "Q.87.2": "Stacionarinė protiškai atsilikusių, psichikos ligonių, sergančiųjų priklausomybės ligomis globos veikla",
        "Q.87.20": "Stacionarinė protiškai atsilikusių, psichikos ligonių, sergančiųjų priklausomybės ligomis globos veikla",
        "Q.87.3": "Stacionarinė pagyvenusių ir neįgaliųjų asmenų globos veikla",
        "Q.87.30": "Stacionarinė pagyvenusių ir neįgaliųjų asmenų globos veikla",
        "Q.87.9": "Kita stacionarinė globos veikla",
        "Q.87.90": "Kita stacionarinė globos veikla",
        "Q.88": "Nesusijusio su apgyvendinimu socialinio darbo veikla",
        "C.10.1": "Mėsos perdirbimas ir konservavimas ir mėsos produktų gamyba",
        "Q.88.1": "Nesusijusio su apgyvendinimu socialinio darbo su pagyvenusiais ir neįgaliaisiais asmenimis veikla",
        "Q.88.10": "Nesusijusio su apgyvendinimu socialinio darbo su pagyvenusiais ir neįgaliaisiais asmenimis veikla",
        "Q.88.9": "Kita, nesusijusi su apgyvendinimu, socialinio darbo veikla",
        "Q.88.91": "Vaikų dienos priežiūros veikla",
        "Q.88.99": "Kita, niekur kitur nepriskirta, nesusijusi su apgyvendinimu socialinio darbo veikla",
        "R.": "MENINĖ, PRAMOGINĖ IR POILSIO ORGANIZAVIMO VEIKLA",
        "R.90": "Kūrybinė, meninė ir pramogų organizavimo veikla",
        "R.90.0": "Kūrybinė, meninė ir pramogų organizavimo veikla",
        "R.90.01": "Scenos pastatymų veikla",
        "R.90.02": "Scenos pastatymams būdingų paslaugų veikla",
        "C.10.11": "Mėsos perdirbimas ir konservavimas",
        "R.90.03": "Meninė kūryba",
        "R.90.04": "Meno įrenginių eksploatavimo veikla (PPP)",
        "R.91": "Bibliotekų, archyvų, muziejų ir kita kultūrinė veikla",
        "R.91.0": "Bibliotekų, archyvų, muziejų ir kita kultūrinė veikla",
        "R.91.01": "Bibliotekų ir archyvų veikla",
        "R.91.02": "Muziejų veikla",
        "R.91.03": "Istorinių vietų ir pastatų bei panašių turistų lankomų vietų eksploatavimas",
        "R.91.04": "Botanikos ir zoologijos sodų bei gamtos rezervatų veikla",
        "R.91.04.10": "Zoologijos sodų veikla",
        "R.91.04.20": "Botanikos sodų veikla",
        "C.10.12": "Paukštienos perdirbimas ir konservavimas",
        "R.91.04.30": "Gamtos rezervatų ir draustinių veikla",
        "R.92": "Azartinių žaidimų ir lažybų organizavimo veikla (PPP)",
        "R.92.0": "Azartinių žaidimų ir lažybų organizavimo veikla (PPP)",
        "R.92.00": "Azartinių žaidimų ir lažybų organizavimo veikla (PPP)",
        "R.92.00.10": "Loterijų organizavimo veikla (PPP)",
        "R.92.00.20": "Azartinių lošimų ir lažybų organizavimo veikla (PPP)",
        "R.92.00.30": "Kitų azartinių žaidimų organizavimo veikla (PPP)",
        "R.93": "Sportinė veikla, pramogų ir poilsio organizavimo veikla",
        "R.93.1": "Sportinė veikla",
        "R.93.11": "Sporto įrenginių eksploatavimas",
        "A.01.13.60": "Grybų ir valgomųjų trumų auginimas",
        "C.10.13": "Mėsos ir paukštienos produktų gamyba",
        "R.93.12": "Sporto klubų veikla",
        "R.93.13": "Kūno rengybos centrų veikla",
        "R.93.19": "Kita sportinė veikla",
        "R.93.19.10": "Sportinė ar mėgėjų medžioklė ir su ja susijusi veikla",
        "R.93.19.20": "Sportinė ar mėgėjų žvejyba ir su ja susijusi veikla",
        "R.93.2": "Pramogų ir poilsio organizavimo veikla",
        "R.93.21": "Atrakcionų ir teminių parkų veikla",
        "R.93.29": "Kita pramogų ir poilsio organizavimo veikla",
        "S.": "KITA APTARNAVIMO VEIKLA",
        "S.94": "Narystės organizacijų veikla",
        "C.10.13.10": "Rūkytų mėsos ir paukštienos produktų gamyba",
        "S.94.1": "Verslininkų, darbdavių ir profesinių narystės organizacijų veikla",
        "S.94.11": "Verslininkų ir darbdavių narystės organizacijų veikla",
        "S.94.12": "Profesinių narystės organizacijų veikla",
        "S.94.2": "Profesinių sąjungų veikla",
        "S.94.20": "Profesinių sąjungų veikla",
        "S.94.9": "Kitų narystės organizacijų veikla",
        "S.94.91": "Religinių organizacijų veikla",
        "S.94.91.10": "Religinių bendrijų veikla",
        "S.94.91.20": "Vienuolynų veikla",
        "S.94.92": "Politinių organizacijų veikla",
        "C.10.2": "Žuvų, vėžiagyvių ir moliuskų perdirbimas ir konservavimas",
        "S.94.99": "Kitų, niekur kitur nepriskirtų, narystės organizacijų veikla",
        "S.95": "Kompiuterių ir asmeninių bei namų ūkio reikmenų taisymas",
        "S.95.1": "Kompiuterių ir ryšių įrangos remontas",
        "S.95.11": "Kompiuterių ir išorinės įrangos remontas",
        "S.95.12": "Ryšių įrangos remontas",
        "S.95.12.10": "Ryšio sistemų techninė priežiūra",
        "S.95.2": "Asmeninių ir namų ūkio reikmenų taisymas",
        "S.95.21": "Vartotojiškos elektroninės įrangos remontas",
        "S.95.22": "Buitinių aparatų ir prietaisų, namų bei sodo įrangos remontas",
        "S.95.23": "Avalynės ir odos gaminių taisymas",
        "C.10.20": "Žuvų, vėžiagyvių ir moliuskų perdirbimas ir konservavimas",
        "S.95.24": "Baldų ir interjero reikmenų taisymas",
        "S.95.25": "Įvairių tipų laikrodžių ir juvelyrinių dirbinių taisymas (PPP)",
        "S.95.29": "Kitų asmeninių ir namų ūkio reikmenų taisymas",
        "S.96": "Kita asmenų aptarnavimo veikla",
        "S.96.0": "Kita asmenų aptarnavimo veikla",
        "S.96.01": "Tekstilės ir kailių gaminių skalbimas ir (sausasis) valymas",
        "S.96.02": "Kirpyklų ir kitų grožio salonų veikla",
        "S.96.03": "Laidotuvių ir su jomis susijusi veikla",
        "S.96.04": "Fizinės gerovės užtikrinimo veikla",
        "S.96.09": "Kita, niekur kitur nepriskirta, asmenų aptarnavimo veikla",
        "C.10.3": "Vaisių ir daržovių perdirbimas ir konservavimas",
        "T.": "NAMŲ ŪKIŲ, SAMDANČIŲ DARBININKUS, VEIKLA; NAMŲ ŪKIŲ VEIKLA, SUSIJUSI SU SAVOMS REIKMĖMS TENKINTI SKIRTŲ NEDIFERENCIJUOJAMŲ GAMINIŲ GAMYBA IR PASLAUGŲ TEIKIMU",
        "T.97": "Namų ūkių, samdančių namų ūkio personalą, veikla",
        "T.97.0": "Namų ūkių, samdančių namų ūkio personalą, veikla",
        "T.97.00": "Namų ūkių, samdančių namų ūkio personalą, veikla",
        "T.98": "Privačių namų ūkių veikla, susijusi su savoms reikmėms tenkinti skirtų nediferencijuojamų gaminių gamyba ir paslaugų teikimu",
        "T.98.1": "Privačių namų ūkių veikla, susijusi su savoms reikmėms tenkinti skirtų nediferencijuojamų gaminių ar reikmenų gamyba",
        "T.98.10": "Privačių namų ūkių veikla, susijusi su savoms reikmėms tenkinti skirtų nediferencijuojamų gaminių ar reikmenų gamyba",
        "T.98.2": "Privačių namų ūkių veikla, susijusi su savoms reikmėms tenkinti skirtų nediferencijuojamų paslaugų teikimu",
        "T.98.20": "Privačių namų ūkių veikla, susijusi su savoms reikmėms tenkinti skirtų nediferencijuojamų paslaugų teikimu",
        "U.": "EKSTRATERITORINIŲ ORGANIZACIJŲ IR ĮSTAIGŲ VEIKLA",
        "C.10.31": "Bulvių perdirbimas ir konservavimas",
        "U.99": "Ekstrateritorinių organizacijų ir įstaigų veikla",
        "U.99.0": "Ekstrateritorinių organizacijų ir įstaigų veikla",
        "U.99.00": "Ekstrateritorinių organizacijų ir įstaigų veikla",
        "C.10.31.10": "Bulvių miltų gamyba",
        "C.10.32": "Vaisių, uogų ir daržovių sulčių gamyba",
        "C.10.39": "Kitas vaisių ir daržovių perdirbimas ir konservavimas",
        "C.10.4": "Gyvūninių ir augalinių riebalų bei aliejaus gamyba",
        "A.01.14": "Cukranendrių auginimas",
        "C.10.41": "Aliejaus ir riebalų gamyba",
        "C.10.42": "Margarino ir panašių valgomųjų riebalų gamyba",
        "C.10.5": "Pieno produktų gamyba",
        "C.10.51": "Pieninių veikla ir sūrių gamyba",
        "C.10.52": "Valgomųjų ledų gamyba",
        "C.10.6": "Grūdų malimo produktų, krakmolo ir krakmolo produktų gamyba",
        "C.10.61": "Grūdų malimo produktų gamyba",
        "C.10.61.10": "Miltų gamyba",
        "C.10.61.20": "Kruopų gamyba",
        "C.10.62": "Krakmolo ir krakmolo produktų gamyba",
        "A.01.15": "Tabako auginimas",
        "C.10.62.10": "Gliukozės sirupo ir maltozės gamyba",
        "C.10.62.20": "Krakmolo gamyba",
        "C.10.7": "Kepyklos ir miltinių produktų gamyba",
        "C.10.71": "Duonos gamyba; šviežių konditerijos kepinių ir pyragaičių gamyba",
        "C.10.72": "Džiūvėsių ir sausainių gamyba; ilgai išsilaikančių konditerijos kepinių ir pyragaičių gamyba",
        "C.10.73": "Makaronų, vermišelių, kuskuso ir panašių miltinių produktų gamyba",
        "C.10.8": "Kitų maisto produktų gamyba",
        "C.10.81": "Cukraus gamyba",
        "C.10.82": "Kakavos, šokolado ir cukraus saldumynų gamyba",
        "C.10.83": "Arbatos ir kavos apdorojimas ir perdirbimas",
        "A.01.16": "Pluoštinių augalų auginimas",
        "C.10.84": "Užgardų ir pagardų gamyba",
        "C.10.84.10": "Acto gamyba",
        "C.10.85": "Paruoštų valgių ir patiekalų gamyba",
        "C.10.86": "Homogenizuotų ir dietinių maisto produktų gamyba",
        "C.10.89": "Kitų, niekur kitur nepriskirtų, maisto produktų gamyba",
        "C.10.89.10": "Mielių gamyba",
        "C.10.9": "Paruoštų pašarų gyvuliams gamyba",
        "C.10.91": "Paruoštų pašarų ūkio gyvuliams gamyba",
        "C.10.92": "Paruošto ėdalo naminiams gyvūnėliams gamyba",
        "C.11": "Gėrimų gamyba",
        "A.01.19": "Kitų vienmečių augalų auginimas",
        "C.11.0": "Gėrimų gamyba",
        "C.11.01": "Spirito distiliavimas, rektifikavimas ir maišymas",
        "C.11.02": "Vynuogių vyno gamyba",
        "C.11.03": "Sidro ir kitokių vaisių, uogų vynų gamyba",
        "C.11.04": "Kitų nedistiliuotų fermentuotų gėrimų gamyba",
        "C.11.05": "Alaus gamyba",
        "C.11.06": "Salyklo gamyba",
        "C.11.07": "Nealkoholinių gėrimų gamyba; mineralinio ir kito, pilstomo į butelius, vandens gamyba",
        "C.11.07.10": "Nealkoholinių gėrimų gamyba",
        "C.11.07.20": "Natūralaus mineralinio ir kito, pilstomo į butelius, vandens gamyba",
        "A.01.19.10": "Gėlių auginimas",
        "C.12": "Tabako gaminių gamyba",
        "C.12.0": "Tabako gaminių gamyba",
        "C.12.00": "Tabako gaminių gamyba",
        "C.13": "Tekstilės gaminių gamyba",
        "C.13.1": "Tekstilės pluoštų paruošimas ir verpimas",
        "C.13.10": "Tekstilės pluoštų paruošimas ir verpimas",
        "C.13.2": "Tekstilės audimas",
        "C.13.20": "Tekstilės audimas",
        "C.13.20.10": "Lininių audinių audimas",
        "C.13.20.20": "Sintetinių audinių audimas",
        "A.01.2": "Daugiamečių augalų auginimas",
        "C.13.3": "Tekstilės apdaila",
        "C.13.30": "Tekstilės apdaila",
        "C.13.9": "Kitų tekstilės gaminių ir dirbinių gamyba",
        "C.13.91": "Megztų (trikotažinių) ir nertų medžiagų gamyba",
        "C.13.92": "Gatavų tekstilės dirbinių, išskyrus drabužius, gamyba",
        "C.13.93": "Kilimų ir kilimėlių gamyba",
        "C.13.94": "Virvių, lynų, virvelių ir tinklų gamyba",
        "C.13.95": "Neaustinių medžiagų ir neaustinių medžiagų gaminių ir dirbinių, išskyrus drabužius, gamyba",
        "C.13.96": "Kitų techninės ir pramoninės tekstilės gaminių ir dirbinių gamyba",
        "C.13.99": "Kitų, niekur kitur nepriskirtų, tekstilės gaminių ir dirbinių gamyba",
        "A.01.21": "Vynuogių auginimas",
        "C.14": "Drabužių siuvimas (gamyba)",
        "C.14.1": "Drabužių, išskyrus kailinius drabužius, siuvimas (gamyba)",
        "C.14.11": "Odinių drabužių siuvimas",
        "C.14.12": "Darbo drabužių siuvimas",
        "C.14.13": "Kitų viršutinių drabužių siuvimas",
        "C.14.13.10": "Vyriškų viršutinių drabužių siuvimas",
        "C.14.13.20": "Moteriškų viršutinių drabužių siuvimas",
        "C.14.14": "Apatinių drabužių siuvimas",
        "C.14.19": "Kitų drabužių siuvimas ir drabužių priedų gamyba",
        "C.14.19.10": "Vaiko drabužėlių siuvimas",
        "A.01": "Augalininkystė ir gyvulininkystė, medžioklė ir susijusių paslaugų veikla",
        "A.01.22": "Tropinių ir subtropinių vaisių ir uogų auginimas",
        "C.14.19.20": "Sportinės aprangos siuvimas",
        "C.14.19.30": "Kailinių kepurių ir kitų galvos apdangalų gamyba",
        "C.14.2": "Kailinių dirbinių ir gaminių gamyba",
        "C.14.20": "Kailinių dirbinių ir gaminių gamyba",
        "C.14.3": "Megztų (trikotažinių) ir nertų drabužių gamyba",
        "C.14.31": "Pėdkelnių, triko, kojinių ir kitų panašių megztų (trikotažinių) ir nertų gaminių bei dirbinių gamyba",
        "C.14.39": "Kitų megztų (trikotažinių) ir nertų drabužių gamyba",
        "C.15": "Odos ir odos dirbinių gamyba",
        "C.15.1": "Odų rauginimas ir išdirbimas; lagaminų, rankinių, balno reikmenų ir pakinktų gamyba; kailių išdirbimas ir dažymas",
        "C.15.11": "Odų rauginimas ir išdirbimas; kailių išdirbimas ir dažymas",
        "A.01.23": "Citrusų vaisių auginimas",
        "C.15.11.10": "Odų rauginimas, naudojant augalines medžiagas",
        "C.15.11.20": "Odų rauginimas, naudojant mineralines ir chemines medžiagas",
        "C.15.11.30": "Odų išdirbimas",
        "C.15.12": "Lagaminų, rankinių ir panašių reikmenų, balno reikmenų ir pakinktų gamyba",
        "C.15.2": "Avalynės gamyba",
        "C.15.20": "Avalynės gamyba",
        "C.16": "Medienos bei medienos ir kamštienos gaminių, išskyrus baldus, gamyba; gaminių iš šiaudų ir pynimo medžiagų gamyba",
        "C.16.1": "Medienos pjaustymas ir obliavimas",
        "C.16.10": "Medienos pjaustymas ir obliavimas",
        "C.16.10.10": "Cheminis medienos apdorojimas konservantais",
        "A.01.24": "Sėklavaisių ir kaulavaisių auginimas",
        "C.16.2": "Gaminių ir dirbinių iš medienos, kamštienos, šiaudų ir pynimo medžiagų gamyba",
        "C.16.21": "Faneravimo dangos ir medienos plokščių gamyba",
        "C.16.21.10": "Medienos plaušo plokščių, padengtų dekoratyvine plėvele, gamyba",
        "C.16.21.20": "Presuotos medienos gamyba",
        "C.16.22": "Sumontuotų parketo grindų gamyba",
        "C.16.23": "Kitų statybinių dailidžių ir stalių dirbinių gamyba",
        "C.16.23.10": "Fasoninių detalių ir malksnų (gontų) stogų dengimui gamyba",
        "C.16.23.20": "Medinių surenkamųjų statinių ar jų detalių gamyba",
        "C.16.23.30": "Medinių sieninių plokščių ir spintų gamyba",
        "C.16.24": "Medinės taros gamyba",
        "A.01.25": "Kitų vaismedžių, uogakrūmių ir riešutmedžių vaisių auginimas",
        "C.16.24.10": "Padėklų, stovų ir kitų medinių pakrovimo reikmenų gamyba",
        "C.16.29": "Kitų medienos gaminių gamyba; dirbinių iš kamštienos, šiaudų ir pynimo medžiagų gamyba",
        "C.17": "Popieriaus ir popieriaus gaminių gamyba",
        "C.17.1": "Plaušienos, popieriaus ir kartono gamyba",
        "C.17.11": "Plaušienos gamyba",
        "C.17.12": "Popieriaus ir kartono gamyba",
        "C.17.2": "Popieriaus ir kartoninių gaminių gamyba",
        "C.17.21": "Gofruotojo popieriaus ir kartono bei taros iš popieriaus ir kartono gamyba",
        "C.17.22": "Buitinių ir higienos reikmenų bei tualeto reikmenų gamyba",
        "C.17.22.10": "Tualetinio popieriaus gamyba",
        "A.01.26": "Aliejinių augalų vaisių ir uogų auginimas",
        "C.17.23": "Popierinių raštinės reikmenų gamyba",
        "C.17.23.10": "Kopijavimo popieriaus gamyba",
        "C.17.23.20": "Vokų ir atvirukų gamyba",
        "C.17.24": "Sienų apmušalų (tapetų) gamyba",
        "C.17.29": "Kitų popierinių ir kartoninių gaminių gamyba",
        "C.17.29.10": "Filtravimo popieriaus gamyba",
        "C.18": "Spausdinimas ir įrašytų laikmenų tiražavimas",
        "C.18.1": "Spausdinimas ir su spausdinimu susijusios paslaugos",
        "C.18.11": "Laikraščių spausdinimas",
        "C.18.12": "Kitas spausdinimas",
        "A.01.27": "Gėrimams gaminti vartojamų augalų auginimas",
        "C.18.13": "Parengiamoji spausdinimo ir žiniasklaidos veikla",
        "C.18.14": "Įrišimas ir susijusios paslaugos",
        "C.18.2": "Įrašytų laikmenų tiražavimas",
        "C.18.20": "Įrašytų laikmenų tiražavimas",
        "C.19": "Kokso ir rafinuotų naftos produktų gamyba",
        "C.19.1": "Koksavimo krosnių produktų gamyba",
        "C.19.10": "Koksavimo krosnių produktų gamyba",
        "C.19.2": "Rafinuotų naftos produktų gamyba",
        "C.19.20": "Rafinuotų naftos produktų gamyba",
        "C.19.20.10": "Skystojo arba dujinio kuro gamyba",
        "A.01.28": "Prieskoninių, kvapiųjų, vaistinių ir kitokių farmacijos pramonėje naudojamų augalų auginimas (PPP)",
        "C.19.20.20": "Tepalų ir kitų alyvų gamyba",
        "C.19.20.30": "Parafino ir techninio vazelino gamyba",
        "C.19.20.40": "Naftos bitumo gamyba",
        "C.20": "Chemikalų ir chemijos produktų gamyba",
        "C.20.1": "Pagrindinių chemikalų, trąšų ir azoto junginių, pirminių plastikų ir pirminio sintetinio kaučiuko gamyba",
        "C.20.11": "Pramoninių dujų gamyba",
        "C.20.12": "Dažiklių ir pigmentų gamyba",
        "C.20.13": "Kitų pagrindinių neorganinių chemikalų gamyba",
        "C.20.14": "Kitų pagrindinių organinių chemikalų gamyba",
        "C.20.15": "Trąšų ir azoto junginių gamyba",
        "A.01.29": "Kitų daugiamečių augalų auginimas",
        "C.20.15.10": "Grynųjų ar kompleksinių azoto ir fosforo trąšų gamyba",
        "C.20.15.20": "Karbamido gamyba",
        "C.20.15.30": "Amoniako gamyba",
        "C.20.16": "Pirminių plastikų gamyba",
        "C.20.17": "Pirminio sintetinio kaučiuko gamyba",
        "C.20.2": "Pesticidų ir kitų agrocheminių medžiagų gamyba",
        "C.20.20": "Pesticidų ir kitų agrocheminių medžiagų gamyba",
        "C.20.20.10": "Dezinfekantų gamyba",
        "C.20.3": "Dažų, lakų ir panašių dangų medžiagų, spaustuvinių dažų ir mastikų gamyba",
        "C.20.30": "Dažų, lakų ir panašių dangų medžiagų, spaustuvinių dažų ir mastikų gamyba",
        "A.01.3": "Augalų dauginimas",
        "C.20.30.10": "Emalinių dažų ir lakų gamyba",
        "C.20.30.20": "Organinių sudėtingų tirpiklių ir skiediklių gamyba",
        "C.20.4": "Muilo ir ploviklių, valiklių ir blizgiklių, kvepalų ir tualeto priemonių gamyba",
        "C.20.41": "Muilo ir ploviklių, valiklių ir blizgiklių gamyba",
        "C.20.42": "Kvepalų ir tualeto priemonių gamyba",
        "C.20.5": "Kitų cheminių medžiagų gamyba",
        "C.20.51": "Sprogiųjų medžiagų gamyba",
        "C.20.52": "Klijų gamyba",
        "C.20.53": "Eterinio aliejaus gamyba",
        "C.20.59": "Kitų, niekur kitur nepriskirtų, cheminių medžiagų gamyba",
        "A.01.30": "Augalų dauginimas",
        "C.20.59.10": "Lydymo, litavimo ar suvirinimo miltelių ir pastų gamyba",
        "C.20.59.20": "Aktyvintų anglių, tepalų priedų, paruoštų kaučiuko vulkanizavimo greitiklių, katalizatorių gamyba",
        "C.20.59.30": "Antidetonatorių, antifrizų, skysčių hidraulinėms sistemoms gamyba",
        "C.20.59.40": "Rašalo ir tušo gamyba",
        "C.20.6": "Cheminių pluoštų gamyba",
        "C.20.60": "Cheminių pluoštų gamyba",
        "C.21": "Pagrindinių vaistų pramonės gaminių ir farmacinių preparatų gamyba (PPP)",
        "C.21.1": "Pagrindinių vaistų pramonės gaminių gamyba (PPP)",
        "C.21.10": "Pagrindinių vaistų pramonės gaminių gamyba (PPP)",
        "C.21.10.10": "Narkotinių medžiagų gamyba (PPP)",
        "A.01.1": "Vienmečių augalų auginimas",
        "A.01.4": "Gyvulininkystė",
        "C.21.2": "Farmacinių preparatų gamyba (PPP)",
        "C.21.20": "Farmacinių preparatų gamyba (PPP)",
        "C.21.20.10": "Vaistų gamyba (PPP)",
        "C.21.20.20": "Veterinarinių vaistų gamyba (PPP)",
        "C.22": "Guminių ir plastikinių gaminių gamyba",
        "C.22.1": "Guminių gaminių gamyba",
        "C.22.11": "Guminių padangų ir kamerų gamyba; guminių padangų restauravimas ir atnaujinimas",
        "C.22.19": "Kitų guminių gaminių gamyba",
        "C.22.2": "Plastikinių gaminių gamyba",
        "C.22.21": "Plastikinių plokščių, lakštų, vamzdžių ir profiliuočių gamyba",
        "A.01.41": "Pieninių galvijų auginimas",
        "C.22.22": "Plastikinių pakuočių gamyba",
        "C.22.23": "Plastikinių statybos dirbinių gamyba",
        "C.22.29": "Kitų plastikinių gaminių gamyba",
        "C.23": "Kitų nemetalo mineralinių produktų gamyba",
        "C.23.1": "Stiklo ir stiklo gaminių bei dirbinių gamyba",
        "C.23.11": "Plokščiojo stiklo gamyba",
        "C.23.12": "Plokščiojo stiklo pjaustymas ir apdorojimas",
        "C.23.13": "Tuščiavidurio stiklo gamyba",
        "C.23.13.10": "Stiklinių talpyklų gamyba",
        "C.23.14": "Stiklo pluoštų gamyba",
        "A.01.42": "Kitų galvijų ir buivolų auginimas",
        "C.23.19": "Kito stiklo, įskaitant skirto techninėms reikmėms, gamyba ir apdorojimas",
        "C.23.19.10": "Stiklinių izoliatorių ir stiklinių izoliacinių jungiamųjų detalių gamyba",
        "C.23.2": "Ugniai atsparių gaminių gamyba",
        "C.23.20": "Ugniai atsparių gaminių gamyba",
        "C.23.3": "Statybinių medžiagų iš molio gamyba",
        "C.23.31": "Keraminių apdailos ir šaligatvio plytelių gamyba",
        "C.23.31.10": "Koklių gamyba",
        "C.23.31.20": "Keraminių grindinio dangų gamyba",
        "C.23.32": "Degto molio plytų, plytelių ir statybinių dirbinių gamyba",
        "C.23.4": "Kitų porcelianinių ir keraminių gaminių bei dirbinių gamyba",
        "A.01.42.10": "Galvijų auginimas ir penėjimas mėsai",
        "C.23.41": "Keraminių buities ir puošybos gaminių bei dirbinių gamyba",
        "C.23.42": "Keraminių santechnikos gaminių ir dirbinių gamyba",
        "C.23.43": "Keraminių izoliatorių ir keraminių izoliacinių detalių gamyba",
        "C.23.44": "Kitų techninės paskirties keraminių gaminių ir dirbinių gamyba",
        "C.23.49": "Kitų keraminių gaminių ir dirbinių gamyba",
        "C.23.5": "Cemento, kalkių ir gipso gamyba",
        "C.23.51": "Cemento gamyba",
        "C.23.52": "Kalkių ir gipso gamyba",
        "C.23.6": "Betono, cemento ir gipso gaminių bei dirbinių gamyba",
        "C.23.61": "Betono gaminių, skirtų statybinėms reikmėms, gamyba",
        "A.01.42.20": "Veislinių telyčių auginimas",
        "C.23.62": "Gipso gaminių, naudojamų statybinėms reikmėms, gamyba",
        "C.23.63": "Prekinio betono mišinio gamyba",
        "C.23.64": "Statybinių skiedinių gamyba",
        "C.23.65": "Fibrolito gamyba",
        "C.23.69": "Kitų betono, gipso ir cemento gaminių bei dirbinių gamyba",
        "C.23.7": "Akmens pjaustymas, tašymas ir apdailinimas",
        "C.23.70": "Akmens pjaustymas, tašymas ir apdailinimas",
        "C.23.9": "Abrazyvinių gaminių ir niekur kitur nepriskirtų nemetalo mineralinių produktų gamyba",
        "C.23.91": "Abrazyvinių gaminių gamyba",
        "C.23.99": "Kitų, niekur kitur nepriskirtų, nemetalo mineralinių produktų gamyba",
        "A.01.42.30": "Veislinių bulių auginimas",
        "C.23.99.10": "Asbestinio pluošto, verpalų ir audinių bei gaminių iš jų gamyba",
        "C.23.99.20": "Frikcinių medžiagų ir jų gaminių gamyba",
        "C.23.99.30": "Mineralinių izoliacinių medžiagų gamyba",
        "C.23.99.40": "Dirbinių iš bitumo gamyba",
        "C.24": "Pagrindinių metalų gamyba",
        "C.24.1": "Tomo ketaus ir plieno bei ferolydinių gamyba",
        "C.24.10": "Tomo ketaus ir plieno bei ferolydinių gamyba",
        "C.24.2": "Plieninių vamzdžių, vamzdelių, tuščiavidurių profilių ir susijusių jungiamųjų detalių gamyba",
        "C.24.20": "Plieninių vamzdžių, vamzdelių, tuščiavidurių profilių ir susijusių jungiamųjų detalių gamyba",
        "C.24.3": "Kitų plieno pirminio apdirbimo gaminių gamyba",
        "A.01.42.40": "Veislinių bulių spermos gavyba",
        "C.24.31": "Šaltasis strypų tempimas",
        "C.24.32": "Šaltasis siaurų juostų valcavimas",
        "C.24.33": "Šaltasis formavimas ar lankstymas",
        "C.24.34": "Šaltasis vielos tempimas",
        "C.24.4": "Pagrindinių tauriųjų ir kitų spalvotųjų metalų gamyba",
        "C.24.41": "Tauriųjų metalų gamyba",
        "C.24.42": "Aliuminio gamyba",
        "C.24.43": "Švino, cinko ir alavo gamyba",
        "C.24.44": "Vario gamyba",
        "C.24.45": "Kitų spalvotųjų metalų gamyba",
        "A.01.43": "Arklių ir kitų kanopinių gyvūnų auginimas",
        "C.24.46": "Branduolinio kuro perdirbimas",
        "C.24.5": "Metalų liejinių gamyba",
        "C.24.51": "Geležies liejinių gamyba",
        "C.24.52": "Plieno liejinių gamyba",
        "C.24.53": "Lengvųjų metalų liejinių gamyba",
        "C.24.54": "Kitų spalvotųjų metalų liejinių gamyba",
        "C.25": "Metalo gaminių, išskyrus mašinas ir įrenginius, gamyba",
        "C.25.1": "Konstrukcinių metalo gaminių gamyba",
        "C.25.11": "Metalo konstrukcijų ir jų dalių gamyba",
        "C.25.12": "Metalinių durų ir langų gamyba",
        "A.01.44": "Kupranugarių ir Camelidae šeimos gyvūnų auginimas",
        "C.25.2": "Metalinių cisternų, rezervuarų ir talpyklų gamyba",
        "C.25.21": "Centrinio šildymo radiatorių ir katilų gamyba",
        "C.25.29": "Kitų metalinių cisternų, rezervuarų ir talpyklų gamyba",
        "C.25.29.10": "Metalinių talpyklų suslėgtosioms ar suskystintosioms dujoms gamyba",
        "C.25.3": "Garo generatorių, išskyrus centrinio šildymo karšto vandens katilus, gamyba",
        "C.25.30": "Garo generatorių, išskyrus centrinio šildymo karšto vandens katilus, gamyba",
        "C.25.4": "Ginklų ir šaudmenų gamyba",
        "C.25.40": "Ginklų ir šaudmenų gamyba",
        "C.25.5": "Metalo kalimas, presavimas, štampavimas ir profiliavimas; miltelių metalurgija",
        "C.25.50": "Metalo kalimas, presavimas, štampavimas ir profiliavimas; miltelių metalurgija",
        "A.01.45": "Avių ir ožkų auginimas",
        "C.25.6": "Metalų apdorojimas ir dengimas; mechaninis apdirbimas",
        "C.25.61": "Metalų apdorojimas ir dengimas",
        "C.25.62": "Mechaninis apdirbimas",
        "C.25.7": "Valgomųjų įrankių, kitų įrankių ir bendrųjų metalo dirbinių gamyba",
        "C.25.71": "Valgomųjų ir kitų pjovimo įrankių gamyba",
        "C.25.72": "Spynų ir vyrių gamyba",
        "C.25.73": "Kitų įrankių gamyba",
        "C.25.9": "Kitų metalo gaminių gamyba",
        "C.25.91": "Plieninių statinių ir panašių talpyklų gamyba",
        "C.25.92": "Lengvųjų metalų taros gamyba",
        "A.01.11": "Grūdinių (išskyrus ryžius), ankštinių ir aliejingų sėklų augalų auginimas",
        "A.01.45.10": "Avių auginimas",
        "C.25.93": "Vielos gaminių, grandinių ir spyruoklių gamyba",
        "C.25.94": "Tvirtinimo detalių ir sriegimo mašinų gaminių gamyba",
        "C.25.99": "Kitų, niekur kitur nepriskirtų, metalo gaminių gamyba",
        "C.26": "Kompiuterinių, elektroninių ir optinių gaminių gamyba",
        "C.26.1": "Elektroninių komponentų ir plokščių gamyba",
        "C.26.11": "Elektroninių komponentų gamyba",
        "C.26.12": "Sumontuotų elektroninių plokščių gamyba",
        "C.26.2": "Kompiuterių ir išorinės įrangos gamyba",
        "C.26.20": "Kompiuterių ir išorinės įrangos gamyba",
        "C.26.3": "Ryšių įrangos gamyba",
        "A.01.45.20": "Ožkų auginimas",
        "C.26.30": "Ryšių įrangos gamyba",
        "C.26.4": "Vartotojiškos elektroninės įrangos gamyba",
        "C.26.40": "Vartotojiškos elektroninės įrangos gamyba",
        "C.26.5": "Matavimo, bandymo, navigacinės ir kontrolės įrangos gamyba; įvairių tipų laikrodžių gamyba",
        "C.26.51": "Matavimo, bandymo, navigacinės ir kontrolės įrangos prietaisų ir aparatų gamyba",
        "C.26.51.10": "Elektros skaitiklių gamyba",
        "C.26.51.20": "Vandens skaitiklių gamyba",
        "C.26.51.30": "Dujų skaitiklių gamyba",
        "C.26.51.40": "Automatinio reguliavimo ir kontrolės prietaisų gamyba",
        "C.26.52": "Įvairių tipų laikrodžių gamyba",
        "A.01.46": "Kiaulių auginimas",
        "C.26.6": "Švitinimo, elektromedicininės ir elektroterapinės įrangos gamyba",
        "C.26.60": "Švitinimo, elektromedicininės ir elektroterapinės įrangos gamyba",
        "C.26.7": "Optinių prietaisų ir fotografijos įrangos gamyba",
        "C.26.70": "Optinių prietaisų ir fotografijos įrangos gamyba",
        "C.26.8": "Magnetinių ir optinių laikmenų gamyba",
        "C.26.80": "Magnetinių ir optinių laikmenų gamyba",
        "C.27": "Elektros įrangos gamyba",
        "C.27.1": "Elektros variklių, generatorių, transformatorių bei elektros skirstomosios ir valdymo įrangos gamyba",
        "C.27.11": "Elektros variklių, generatorių ir transformatorių gamyba",
        "C.27.12": "Elektros skirstomosios ir valdymo įrangos gamyba",
        "A.01.46.10": "Kiaulių auginimas ir penėjimas mėsai",
        "C.27.2": "Baterijų ir akumuliatorių gamyba",
        "C.27.20": "Baterijų ir akumuliatorių gamyba",
        "C.27.3": "Laidų ir instaliacijos įtaisų gamyba",
        "C.27.31": "Skaidulinės optikos kabelių gamyba",
        "C.27.32": "Kitų elektronikos bei elektros laidų ir kabelių gamyba",
        "C.27.33": "Instaliacijos įtaisų gamyba",
        "C.27.4": "Elektros apšvietimo įrangos gamyba",
        "C.27.40": "Elektros apšvietimo įrangos gamyba",
        "C.27.5": "Buitinių aparatų ir prietaisų gamyba",
        "C.27.51": "Buitinių elektrinių aparatų ir prietaisų gamyba",
        "A.01.46.20": "Veislinių kiaulių auginimas",
        "C.27.52": "Buitinių neelektrinių aparatų ir prietaisų gamyba",
        "C.27.9": "Kitos elektros įrangos gamyba",
        "C.27.90": "Kitos elektros įrangos gamyba",
        "C.28": "Niekur kitur nepriskirtų mašinų ir įrangos gamyba",
        "C.28.1": "Bendrosios paskirties mašinų gamyba",
        "C.28.11": "Variklių ir turbinų, išskyrus orlaivių, transporto priemonių ir motociklų variklius, gamyba",
        "C.28.12": "Hidraulinės energijos įrangos gamyba",
        "C.28.13": "Kitų siurblių ir kompresorių gamyba",
        "C.28.14": "Kitų čiaupų ir sklendžių gamyba",
        "C.28.15": "Guolių, krumpliaračių, krumplinių pavarų ir varomųjų elementų gamyba",
        "A.01.47": "Naminių paukščių auginimas",
        "C.28.2": "Kitų bendrosios paskirties mašinų ir įrangos gamyba",
        "C.28.21": "Orkaičių, krosnių ir krosnių degiklių gamyba",
        "C.28.22": "Kėlimo ir krovimo įrangos gamyba",
        "C.28.23": "Įstaigos mašinų ir įrangos (išskyrus kompiuterius ir išorinę įrangą) gamyba",
        "C.28.24": "Variklinių rankinių įrankių gamyba",
        "C.28.25": "Nebuitinių aušinimo ir vėdinimo įrenginių gamyba",
        "C.28.29": "Kitų, niekur kitur nepriskirtų, bendrosios paskirties mašinų ir įrangos gamyba",
        "C.28.3": "Žemės ir miškų ūkio mašinų gamyba",
        "C.28.30": "Žemės ir miškų ūkio mašinų gamyba",
        "C.28.4": "Metalo formavimo įrangos ir staklių gamyba",
        "A.01.47.10": "Naminių paukščių auginimas mėsai ir kiaušinių gavybai",
        "C.28.41": "Metalo formavimo įrangos gamyba",
        "C.28.49": "Kitų staklių gamyba",
        "C.28.9": "Kitų specialiosios paskirties mašinų gamyba",
        "C.28.91": "Metalurgijos mašinų gamyba",
        "C.28.92": "Kasybos, karjerų eksploatavimo ir statybos mašinų gamyba",
        "C.28.93": "Maisto, gėrimų ir tabako apdorojimo mašinų gamyba",
        "C.28.94": "Tekstilės, drabužių ir odos gaminių gamybos mašinų gamyba",
        "C.28.95": "Popieriaus ir kartono gamybos mašinų gamyba",
        "C.28.96": "Plastikų ir gumos gamybos mašinų gamyba",
        "C.28.99": "Kitų, niekur kitur nepriskirtų, specialiosios paskirties mašinų gamyba",
        "A.01.47.20": "Veislinių naminių paukščių auginimas",
        "C.29": "Variklinių transporto priemonių, priekabų ir puspriekabių gamyba",
        "C.29.1": "Variklinių transporto priemonių gamyba",
        "C.29.10": "Variklinių transporto priemonių gamyba",
        "C.29.2": "Variklinių transporto priemonių kėbulų gamyba; priekabų ir puspriekabių gamyba",
        "C.29.20": "Variklinių transporto priemonių kėbulų gamyba; priekabų ir puspriekabių gamyba",
        "C.29.3": "Variklinių transporto priemonių dalių ir pagalbinių reikmenų gamyba",
        "C.29.31": "Variklinių transporto priemonių elektros ir elektroninės įrangos gamyba",
        "C.29.32": "Variklinių transporto priemonių kitų dalių ir reikmenų gamyba",
        "C.30": "Kitų transporto priemonių ir įrangos gamyba",
        "C.30.1": "Įvairių tipų laivų statyba",
        "A.01.49": "Kitų gyvūnų auginimas",
        "C.30.11": "Laivų ir plūdriųjų konstrukcijų statyba",
        "C.30.12": "Pramoginių ir sportinių katerių (laivų) statyba",
        "C.30.2": "Geležinkelio lokomotyvų bei riedmenų gamyba",
        "C.30.20": "Geležinkelio lokomotyvų bei riedmenų gamyba",
        "C.30.3": "Orlaivių ir erdvėlaivių bei susijusios įrangos gamyba",
        "C.30.30": "Orlaivių ir erdvėlaivių bei susijusios įrangos gamyba",
        "C.30.4": "Karinių kovinių transporto priemonių gamyba",
        "C.30.40": "Karinių kovinių transporto priemonių gamyba",
        "C.30.9": "Niekur kitur nepriskirtų transporto priemonių gamyba",
        "C.30.91": "Motociklų gamyba",
        "A.01.49.10": "Švelniakailių žvėrelių auginimas",
        "C.30.92": "Dviračių ir invalidų vežimėlių gamyba",
        "C.30.99": "Kitos, niekur kitur nepriskirtos, transporto įrangos gamyba",
        "C.31": "Baldų gamyba",
        "C.31.0": "Baldų gamyba",
        "C.31.01": "Įstaigos ir prekybos įmonių (parduotuvių) baldų gamyba",
        "C.31.02": "Virtuvės baldų gamyba",
        "C.31.03": "Čiužinių gamyba",
        "C.31.09": "Kitų baldų gamyba",
        "C.32": "Kita gamyba",
        "C.32.1": "Papuošalų, juvelyrinių, bižuterijos ir panašių dirbinių gamyba (PPP)",
        "A.01.12": "Ryžių auginimas",
        "A.01.49.20": "Bitininkystė",
        "C.32.11": "Monetų kalimas",
        "C.32.12": "Papuošalų, juvelyrinių ir panašių dirbinių gamyba (PPP)",
        "C.32.13": "Dirbtinės bižuterijos ir panašių dirbinių gamyba",
        "C.32.2": "Muzikos instrumentų gamyba",
        "C.32.20": "Muzikos instrumentų gamyba",
        "C.32.3": "Sporto reikmenų gamyba",
        "C.32.30": "Sporto reikmenų gamyba",
        "C.32.4": "Žaidimų ir žaislų gamyba",
        "C.32.40": "Žaidimų ir žaislų gamyba",
        "C.32.40.10": "Konstravimo rinkinių gamyba",
        "A.01.49.30": "Vynuoginių sraigių ir sliekų auginimas",
        "C.32.40.20": "Plastikinių žaislų gamyba",
        "C.32.40.30": "Medinių žaislų gamyba",
        "C.32.40.40": "Kimštinių žaislų gamyba",
        "C.32.40.50": "Stalo arba kambario žaidimų gamyba",
        "C.32.40.60": "Plastikinių triračių ir kitų žaislų su ratukais gamyba",
        "C.32.40.70": "Elektrinių žaislų ir žaidimų gamyba",
        "C.32.5": "Medicinos ir odontologijos prietaisų, instrumentų ir reikmenų gamyba",
        "C.32.50": "Medicinos ir odontologijos prietaisų, instrumentų ir reikmenų gamyba",
        "C.32.50.10": "Odontologinio cemento gamyba",
        "C.32.50.20": "Ortopedinių ir kitokių įtaisų gamyba",
        "A.01.5": "Mišrusis žemės ūkis",
        "C.32.50.30": "Protezų gamyba",
        "C.32.9": "Niekur kitur nepriskirta gamyba",
        "C.32.91": "Šluotų ir šepečių gamyba",
        "C.32.99": "Kita, niekur kitur nepriskirta, gamyba",
        "C.32.99.10": "Medinių karstų ir kitų laidojimo reikmenų gamyba",
        "C.33": "Mašinų ir įrangos remontas ir įrengimas",
        "C.33.1": "Metalo gaminių, mašinų ir įrangos remontas",
        "C.33.11": "Metalo gaminių remontas",
        "C.33.12": "Mašinų remontas",
        "C.33.13": "Elektroninės ir optinės įrangos remontas",
        "A.01.50": "Mišrusis žemės ūkis",
        "C.33.14": "Elektros įrangos remontas",
        "C.33.15": "Įvairių tipų laivų remontas ir techninė priežiūra",
        "C.33.16": "Orlaivių ir erdvėlaivių remontas ir techninė priežiūra",
        "C.33.17": "Kitų transporto priemonių remontas ir techninė priežiūra",
        "C.33.19": "Kitos įrangos remontas",
        "C.33.2": "Pramoninių mašinų ir įrangos įrengimas",
        "C.33.20": "Pramoninių mašinų ir įrangos įrengimas",
        "D.": "ELEKTROS, DUJŲ, GARO TIEKIMAS IR ORO KONDICIONAVIMAS",
        "D.35": "Elektros, dujų, garo tiekimas ir oro kondicionavimas",
        "D.35.1": "Elektros energijos gamyba, perdavimas ir paskirstymas",
        "A.01.6": "Žemės ūkiui būdingų paslaugų ir derliaus apdorojimo veikla",
        "D.35.11": "Elektros gamyba",
        "D.35.12": "Elektros perdavimas",
        "D.35.13": "Elektros paskirstymas",
        "D.35.14": "Elektros pardavimas",
        "D.35.2": "Dujų gamyba; dujinio kuro paskirstymas dujotiekiais",
        "D.35.21": "Dujų gamyba",
        "D.35.22": "Dujinio kuro paskirstymas dujotiekiais",
        "D.35.23": "Dujų pardavimas dujotiekiais",
        "D.35.3": "Garo tiekimas ir oro kondicionavimas",
        "D.35.30": "Garo tiekimas ir oro kondicionavimas",
        "A.01.61": "Augalininkystei būdingų paslaugų veikla",
        "D.35.30.10": "Garo tiekimas",
        "D.35.30.20": "Karšto vandens tiekimas",
        "E.": "VANDENS TIEKIMAS, NUOTEKŲ VALYMAS, ATLIEKŲ TVARKYMAS IR REGENERAVIMAS",
        "E.36": "Vandens surinkimas, valymas ir tiekimas",
        "E.36.0": "Vandens surinkimas, valymas ir tiekimas",
        "E.36.00": "Vandens surinkimas, valymas ir tiekimas",
        "E.36.00.10": "Vandens surinkimas ir valymas",
        "E.36.00.20": "Vandens tiekimas pramonės įmonėms",
        "E.36.00.30": "Vandens tiekimas gyventojams",
        "E.37": "Nuotekų valymas",
        "A.01.61.10": "Augalų apsaugos nuo ligų, kenkėjų ir piktžolių žemės ūkio paslaugų veikla",
        "E.37.0": "Nuotekų valymas",
        "E.37.00": "Nuotekų valymas",
        "E.38": "Atliekų surinkimas, tvarkymas ir šalinimas; medžiagų atgavimass",
        "E.38.1": "Atliekų surinkimas",
        "E.38.11": "Nepavojingų atliekų surinkimas",
        "E.38.12": "Pavojingų atliekų surinkimas",
        "E.38.2": "Atliekų tvarkymas ir šalinimas",
        "E.38.21": "Nepavojingų atliekų tvarkymas ir šalinimas",
        "E.38.22": "Pavojingų atliekų tvarkymas ir šalinimas",
        "E.38.3": "Medžiagų atgavimas",
        "A.01.61.20": "Žemės ūkio augalų tręšimas mineralinėmis ir organinėmis trąšomis",
        "E.38.31": "Mašinų duženų išmontavimas",
        "E.38.32": "Išrūšiuotų medžiagų atgavimas",
        "E.39": "Regeneravimas ir kita atliekų tvarkyba",
        "E.39.0": "Regeneravimas ir kita atliekų tvarkyba",
        "E.39.00": "Regeneravimas ir kita atliekų tvarkyba",
        "F.": "STATYBA",
        "F.41": "Pastatų statyba",
        "F.41.1": "Statybų plėtra",
        "F.41.10": "Statybų plėtra",
        "F.41.2": "Gyvenamųjų ir negyvenamųjų pastatų statyba",
        "A.01.62": "Gyvulininkystei būdingų paslaugų veikla",
        "F.41.20": "Gyvenamųjų ir negyvenamųjų pastatų statyba",
        "F.41.20.10": "Naujų pastatų statyba",
        "F.41.20.20": "Pastatų remontas, restauravimas ir rekonstravimas",
        "F.42": "Inžinerinių statinių statyba",
        "F.42.1": "Kelių ir geležinkelių tiesimas",
        "F.42.11": "Kelių ir automagistralių tiesimas",
        "F.42.11.10": "Kelio dangos ir stovėjimo aikštelių ženklinimas",
        "F.42.12": "Geležinkelių ir požeminių geležinkelių tiesimas",
        "F.42.13": "Tiltų ir tunelių statyba",
        "F.42.2": "Komunalinių statinių statyba",
        "A.01.62.10": "Dirbtinio apsėklinimo veikla",
        "F.42.21": "Komunalinių nuotekų statinių statyba",
        "F.42.22": "Komunalinių elektros ir telekomunikacijos statinių statyba",
        "F.42.9": "Kitų inžinerinių statinių statyba",
        "F.42.91": "Vandens statinių statyba",
        "F.42.99": "Kitų, niekur kitur nepriskirtų, inžinerinių statinių statyba",
        "F.43": "Specializuota statybos veikla",
        "F.43.1": "Statinių nugriovimas ir statybvietės paruošimas",
        "F.43.11": "Statinių nugriovimas",
        "F.43.12": "Statybvietės paruošimas",
        "F.43.12.10": "Paruošiamieji žemės kasimo darbai tiesiant kelius",
        "A.01.13": "Daržovių ir melionų, šakniavaisių ir gumbavaisių auginimas",
        "A.01.63": "Derliaus apdorojimo veikla",
        "F.43.12.20": "Žemės darbai statybos aikštelėse",
        "F.43.12.30": "Sausinimo ir drėkinimo sistemų tiesimas",
        "F.43.13": "Žvalgomasis gręžimas",
        "F.43.2": "Elektros, vandentiekio ir kitos įrangos įrengimas",
        "F.43.21": "Elektros sistemų įrengimas",
        "F.43.21.10": "Pastatų ir statinių elektros tinklų įrengimas",
        "F.43.21.20": "Gaisro pavojaus ir apsaugos signalizacijos įrengimas",
        "F.43.21.30": "Antenų, ryšio sistemų įrengimas",
        "F.43.22": "Vandentiekio, šildymo ir oro kondicionavimo sistemų įrengimas",
        "F.43.29": "Kitos įrangos įrengimas",
        "A.01.64": "Sėklininkystė",
        "F.43.3": "Statybos baigimas ir apdaila",
        "F.43.31": "Tinkavimas",
        "F.43.32": "Staliaus dirbinių įrengimas",
        "F.43.33": "Grindų ir sienų dengimas",
        "F.43.34": "Dažymas ir stiklinimas",
        "F.43.39": "Kiti statybos baigiamieji ir apdailos darbai",
        "F.43.9": "Kita specializuota statybos veikla",
        "F.43.91": "Stogų dengimas",
        "F.43.99": "Kita, niekur kitur nepriskirta, specializuota statybos veikla",
        "FF.41.20.20": "Daugiabučių renovacija",
        "A.01.7": "Medžioklė, gaudymas spąstais ir susijusių paslaugų veikla",
        "G.": "DIDMENINĖ IR MAŽMENINĖ PREKYBA; VARIKLINIŲ TRANSPORTO PRIEMONIŲ IR MOTOCIKLŲ REMONTAS",
        "G.45": "Variklinių transporto priemonių ir motociklų didmeninė ir mažmeninė prekyba bei remontas (PPP)",
        "G.45.1": "Variklinių transporto priemonių pardavimas (PPP)",
        "G.45.11": "Automobilių ir lengvųjų variklinių transporto priemonių pardavimas (PPP)",
        "G.45.19": "Kitų variklinių transporto priemonių pardavimas (PPP)",
        "G.45.2": "Variklinių transporto priemonių techninė priežiūra ir remontas",
        "G.45.20": "Variklinių transporto priemonių techninė priežiūra ir remontas",
        "G.45.3": "Variklinių transporto priemonių atsarginių dalių ir pagalbinių reikmenų pardavimas",
        "G.45.31": "Variklinių transporto priemonių atsarginių dalių ir pagalbinių reikmenų didmeninė prekyba",
        "G.45.32": "Variklinių transporto priemonių atsarginių dalių ir pagalbinių reikmenų mažmeninė prekyba",
        "A.01.70": "Medžioklė, gaudymas spąstais ir susijusių paslaugų veikla",
        "G.45.4": "Motociklų ir jų atsarginių dalių bei pagalbinių reikmenų pardavimas, techninė priežiūra ir remontas",
        "G.45.40": "Motociklų ir jų atsarginių dalių bei pagalbinių reikmenų pardavimas, techninė priežiūra ir remontas",
        "G.46": "Didmeninė prekyba, išskyrus prekybą variklinėmis transporto priemonėmis ir motociklais",
        "G.46.1": "Didmeninė prekyba už atlygį ar pagal sutartį",
        "G.46.11": "Žemės ūkio žaliavų, gyvų gyvulių, tekstilės žaliavų ir pusgaminių pardavimo agentų veikla",
        "G.46.12": "Degalų, rūdų, metalų ir pramoninių cheminių preparatų pardavimo agentų veikla",
        "G.46.13": "Statybinio miško ir statybinių medžiagų pardavimo agentų veikla",
        "G.46.14": "Mašinų, pramonės įrangos, laivų ir lėktuvų pardavimo agentų veikla",
        "G.46.15": "Baldų, namų ūkio reikmenų, metalo ir geležies dirbinių pardavimo agentų veikla",
        "G.46.16": "Tekstilės, drabužių, kailių, avalynės ir odos dirbinių pardavimo agentų veikla",
        "A.02": "Miškininkystė ir medienos ruoša",
        "G.46.17": "Maisto produktų, gėrimų ir tabako pardavimo agentų veikla",
        "G.46.18": "Kitų specifinių produktų pardavimo agentų specializuota veikla",
        "G.46.19": "Įvairių prekių pardavimo agentų veikla",
        "G.46.2": "Žemės ūkio žaliavų ir gyvų gyvulių didmeninė prekyba",
        "G.46.21": "Grūdų, neperdirbto tabako, sėklų ir pašarų gyvuliams didmeninė prekyba",
        "G.46.22": "Gėlių ir sodinukų didmeninė prekyba",
        "G.46.23": "Gyvų gyvulių didmeninė prekyba",
        "G.46.24": "Kailių ir odų didmeninė prekyba",
        "G.46.3": "Maisto produktų, gėrimų, tabako ir jo gaminių didmeninė prekyba (PPP)",
        "G.46.31": "Vaisių, uogų ir daržovių didmeninė prekyba",
        "A.02.1": "Miško medžių auginimas ir kita miškininkystės veikla",
        "G.46.32": "Mėsos ir mėsos produktų didmeninė prekyba",
        "G.46.33": "Pieno produktų, kiaušinių bei valgomųjų aliejaus ir riebalų didmeninė prekyba",
        "G.46.34": "Gėrimų didmeninė prekyba",
        "G.46.34.10": "Alkoholinių gėrimų didmeninė prekyba (PPP)",
        "G.46.34.20": "Nealkoholinių gėrimų didmeninė prekyba",
        "G.46.35": "Tabako gaminių didmeninė prekyba (PPP)",
        "G.46.36": "Cukraus, šokolado ir cukraus saldumynų didmeninė prekyba",
        "G.46.37": "Kavos, arbatos, kakavos ir prieskonių didmeninė prekyba",
        "G.46.38": "Kitų maisto produktų, įskaitant žuvis, vėžiagyvius ir moliuskus, didmeninė prekyba",
        "G.46.39": "Maisto produktų, gėrimų ir tabako nespecializuota didmeninė prekyba (PPP)",
        "A.02.10": "Miško medžių auginimas ir kita miškininkystės veikla",
        "G.46.4": "Namų ūkio reikmenų didmeninė prekyba",
        "G.46.41": "Tekstilės gaminių didmeninė prekyba",
        "G.46.42": "Drabužių ir avalynės didmeninė prekyba",
        "G.46.42.10": "Guminės avalynės didmeninė prekyba",
        "G.46.42.20": "Odinės avalynės didmeninė prekyba",
        "G.46.42.30": "Kailinių gaminių didmeninė prekyba",
        "G.46.42.40": "Drabužių ir drabužių priedų didmeninė prekyba",
        "G.46.43": "Elektrinių buitinių aparatų arba prietaisų didmeninė prekyba",
        "G.46.44": "Porceliano ir stiklo dirbinių bei valymo priemonių didmeninė prekyba",
        "G.46.44.10": "Porceliano ir stiklo dirbinių didmeninė prekyba",
        "A.02.2": "Medienos ruoša",
        "G.46.44.20": "Valymo priemonių didmeninė prekyba",
        "G.46.45": "Kvepalų ir kosmetikos priemonių didmeninė prekyba",
        "G.46.46": "Farmacijos prekių didmeninė prekyba (PPP)",
        "G.46.46.10": "Chirurginių ir ortopedinių instrumentų bei protezų didmeninė prekyba",
        "G.46.46.20": "Vaistų ir vaistinių medžiagų didmeninė prekyba (PPP)",
        "G.46.47": "Baldų, kilimų ir apšvietimo įrangos didmeninė prekyba",
        "G.46.48": "Laikrodžių, papuošalų ir juvelyrinių dirbinių didmeninė prekyba (PPP)",
        "G.46.49": "Kitų namų ūkio reikmenų didmeninė prekyba",
        "G.46.5": "Informacijos ir ryšių technologijų (IRT) įrangos didmeninė prekyba",
        "G.46.51": "Kompiuterių, jų išorinės ir programinės įrangos didmeninė prekyba",
        "A.02.20": "Medienos ruoša",
        "G.46.52": "Elektroninės ir telekomunikacinės įrangos ir jos dalių didmeninė prekyba",
        "G.46.6": "Kitų mašinų, įrangos ir reikmenų didmeninė prekyba",
        "G.46.61": "Žemės ūkio mašinų, įrangos ir reikmenų didmeninė prekyba",
        "G.46.62": "Staklių didmeninė prekyba",
        "G.46.63": "Kasybos, statybos ir statybos inžinerijos mašinų didmeninė prekyba",
        "G.46.64": "Tekstilės pramonės mašinų bei siuvamųjų ir mezgimo mašinų didmeninė prekyba",
        "G.46.65": "Įstaigos baldų didmeninė prekyba",
        "G.46.66": "Kitų įstaigos mašinų ir įrangos didmeninė prekyba",
        "G.46.69": "Kitų mašinų ir įrangos didmeninė prekyba",
        "G.46.7": "Kita specializuota didmeninė prekyba",
        "A.02.3": "Laukinių nemedieninių produktų rinkimas",
        "G.46.71": "Kietojo, skystojo ir dujinio kuro bei priedų didmeninė prekyba",
        "G.46.71.10": "Kietojo kuro didmeninė prekyba",
        "G.46.71.20": "Benzino didmeninė prekyba (PPP)",
        "G.46.71.30": "Dujinio kuro didmeninė prekyba",
        "G.46.71.40": "Dyzelinio kuro didmeninė prekyba (PPP)",
        "G.46.71.50": "Tepalų didmeninė prekyba",
        "G.46.72": "Metalų rūdų ir metalų didmeninė prekyba",
        "G.46.73": "Medienos, statybinių medžiagų ir sanitarinių įrenginių didmeninė prekyba",
        "G.46.73.10": "Popierinių sienų apmušalų didmeninė prekyba",
        "G.46.74": "Metalinių dirbinių, vandentiekio ir šildymo įrangos bei reikmenų didmeninė prekyba",
        "A.01.13.10": "Bulvių auginimas",
        "A.02.30": "Laukinių nemedieninių produktų rinkimas",
        "G.46.74.10": "Geležies dirbinių didmeninė prekyba",
        "G.46.74.20": "Vandentiekio įrangos didmeninė prekyba",
        "G.46.74.30": "Šildymo įrangos didmeninė prekyba",
        "G.46.75": "Chemijos produktų didmeninė prekyba",
        "G.46.75.10": "Agrocheminių produktų ir trąšų didmeninė prekyba",
        "G.46.75.20": "Ne vaistinės paskirties stipriai veikiančiųjų ir nuodingųjų medžiagų didmeninė prekyba",
        "G.46.76": "Kitų tarpinių produktų didmeninė prekyba",
        "G.46.76.10": "Popieriaus ritinių ir kartono didmeninė prekyba",
        "G.46.76.20": "Linų pluošto didmeninė prekyba",
        "G.46.77": "Atliekų ir laužo didmeninė prekyba",
        "A.02.30.10": "Miško grybų rinkimas",
        "G.46.9": "Nespecializuota didmeninė prekyba",
        "G.46.90": "Nespecializuota didmeninė prekyba",
        "G.47": "Mažmeninė prekyba, išskyrus variklinių transporto priemonių ir motociklų prekybą",
        "G.47.1": "Mažmeninė prekyba nespecializuotose parduotuvėse",
        "G.47.11": "Mažmeninė prekyba nespecializuotose parduotuvėse, kuriose vyrauja maistas, gėrimai ir tabakas",
        "G.47.19": "Kita mažmeninė prekyba nespecializuotose parduotuvėse",
        "G.47.2": "Maisto, gėrimų ir tabako mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.21": "Vaisių, uogų ir daržovių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.22": "Mėsos ir mėsos produktų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.23": "Žuvų, vėžiagyvių ir moliuskų mažmeninė prekyba specializuotose parduotuvėse",
        "A.02.30.20": "Riešutų ir miško uogų rinkimas",
        "G.47.24": "Duonos, bandelių, konditerijos gaminių ir cukraus saldumynų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.24.10": "Duonos, pyrago ir kitų miltinių produktų mažmeninė prekyba",
        "G.47.24.20": "Konditerijos gaminių ir saldumynų mažmeninė prekyba",
        "G.47.25": "Gėrimų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.25.10": "Alkoholinių gėrimų mažmeninė prekyba",
        "G.47.25.20": "Gaivinamųjų gėrimų mažmeninė prekyba",
        "G.47.26": "Tabako gaminių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.29": "Kita maisto produktų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.3": "Automobilių degalų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.30": "Automobilių degalų mažmeninė prekyba specializuotose parduotuvėse",
        "A.02.4": "Miškininkystei būdingų paslaugų veikla",
        "G.47.4": "Informacijos ir ryšių technologijų (IRT) įrangos mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.41": "Kompiuterių, jų išorinės ir programinės įrangos mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.42": "Telekomunikacijų įrangos mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.43": "Garso ir vaizdo įrangos mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.5": "Kitos namų ūkio įrangos mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.51": "Tekstilės gaminių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.52": "Metalo dirbinių, dažų ir stiklo mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.52.10": "Dažų, lakų ir politūrų mažmeninė prekyba",
        "G.47.52.20": "Plokščiojo stiklo mažmeninė prekyba",
        "G.47.52.30": "Statybinių medžiagų mažmeninė prekyba",
        "A.02.40": "Miškininkystei būdingų paslaugų veikla",
        "G.47.52.40": "Medžiagų ir smulkiojo remonto darbams įrangos mažmeninė prekyba",
        "G.47.53": "Kilimų, kilimėlių, sienų ir grindų dangų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.54": "Elektrinių buitinių aparatų ir prietaisų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.59": "Baldų, apšvietimo įrangos ir kitų namų ūkio prekių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.6": "Kultūros ir poilsio prekių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.61": "Knygų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.62": "Laikraščių ir raštinės reikmenų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.63": "Muzikos ir vaizdo įrašų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.64": "Sporto įrangos mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.65": "Žaidimų ir žaislų mažmeninė prekyba specializuotose parduotuvėse",
        "A.03": "Žvejyba ir akvakultūra",
        "G.47.7": "Kitų prekių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.71": "Drabužių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.72": "Avalynės ir odos gaminių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.73": "Vaistinių, ruošiančių ir parduodančių vaistus, veikla",
        "G.47.74": "Medicinos ir ortopedinių prekių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.75": "Kosmetikos ir tualeto reikmenų mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.76": "Gėlių, sodinukų, sėklų, trąšų, naminių gyvūnėlių ir jų ėdalo mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.77": "Laikrodžių, papuošalų ir juvelyrinių dirbinių mažmeninė prekyba specializuotose parduotuvėse (PPP)",
        "G.47.78": "Kita naujų prekių mažmeninė prekyba specializuotose parduotuvėse",
        "G.47.78.10": "Suvenyrų, meno dirbinių ir religinių reikmenų specializuota mažmeninė prekyba (PPP)",
        "A.03.1": "Žvejyba",
        "G.47.78.20": "Buitinio skystojo kuro, dujų balionų, anglies ir malkų specializuota mažmeninė prekyba",
        "G.47.78.30": "Ginklų ir šaudmenų specializuota mažmeninė prekyba",
        "G.47.78.40": "Optikos prekių mažmeninė prekyba",
        "G.47.78.90": "Kita specializuota mažmeninė prekyba",
        "G.47.79": "Naudotų daiktų mažmeninė prekyba parduotuvėse",
        "G.47.79.10": "Antikvarinių daiktų mažmeninė prekyba",
        "G.47.8": "Mažmeninė prekyba kioskuose ir prekyvietėse",
        "G.47.81": "Maisto, gėrimų ir tabako gaminių mažmeninė prekyba kioskuose ir prekyvietėse",
        "G.47.82": "Tekstilės, drabužių ir avalynės mažmeninė prekyba kioskuose ir prekyvietėse",
        "G.47.89": "Kitų prekių mažmeninė prekyba kioskuose ir prekyvietėse",
        "A.03.11": "Jūrinė žvejyba",
        "G.47.9": "Mažmeninė prekyba ne parduotuvėse, kioskuose ar prekyvietėse",
        "G.47.91": "Užsakomasis pardavimas paštu arba internetu",
        "G.47.99": "Kita mažmeninė prekyba ne parduotuvėse, kioskuose ar prekyvietėse",
        "G.47.99.10": "Mažmeninė prekyba per keliaujančius firmos atstovus",
        "G.47.99.20": "Mažmeninė prekyba iš automatų smulkioms prekėms pardavinėti",
        "H.": "TRANSPORTAS IR SAUGOJIMAS",
        "H.49": "Sausumos transportas ir transportavimas vamzdynais",
        "H.49.1": "Tarpmiestinis keleivinis geležinkelio transportas",
        "H.49.10": "Tarpmiestinis keleivinis geležinkelio transportas",
        "H.49.2": "Krovininis geležinkelio transportas",
        "A.03.11.10": "Žuvų perdirbimas žvejybiniuose laivuose",
        "H.49.20": "Krovininis geležinkelio transportas",
        "H.49.3": "Kitas keleivinis sausumos transportas",
        "H.49.31": "Keleivių vežimas miesto arba priemiestiniu sausumos transportu",
        "H.49.31.10": "Keleivių vežimas autobusais mieste ar priemiestyje",
        "H.49.31.20": "Keleivių vežimas troleibusais mieste ar priemiestyje",
        "H.49.32": "Taksi veikla",
        "H.49.39": "Kitas, niekur kitur nepriskirtas, keleivinis sausumos transportas",
        "H.49.4": "Krovininis kelių transportas ir perkraustymo veikla",
        "H.49.41": "Krovininis kelių transportas",
        "H.49.42": "Perkraustymo veikla",
        "A.03.12": "Gėlųjų vandenų žvejyba",
        "H.49.5": "Transportavimas vamzdynais",
        "H.49.50": "Transportavimas vamzdynais",
        "H.50": "Vandens transportas",
        "H.50.1": "Jūrų ir pakrančių keleivinis vandens transportas",
        "H.50.10": "Jūrų ir pakrančių keleivinis vandens transportas",
        "H.50.2": "Jūrų ir pakrančių krovininis vandens transportas",
        "H.50.20": "Jūrų ir pakrančių krovininis vandens transportas",
        "H.50.3": "Vidaus vandenų keleivinis transportas",
        "H.50.30": "Vidaus vandenų keleivinis transportas",
        "H.50.4": "Vidaus vandenų krovininis transportas",
        "A.01.13.20": "Cukrinių runkelių auginimas",
        "A.03.2": "Akvakultūra",
        "H.50.40": "Vidaus vandenų krovininis transportas",
        "H.51": "Oro transportas",
        "H.51.1": "Keleivinis oro transportas",
        "H.51.10": "Keleivinis oro transportas",
        "H.51.2": "Krovininis oro transportas ir kosminis transportas",
        "H.51.21": "Krovininis oro transportas",
        "H.51.22": "Kosminis transportas",
        "H.52": "Sandėliavimas ir transportui būdingų paslaugų veikla",
        "H.52.1": "Sandėliavimas ir saugojimas",
        "H.52.10": "Sandėliavimas ir saugojimas",
        "A.03.21": "Jūrinė akvakultūra",
        "H.52.2": "Transportui būdingų paslaugų veikla",
        "H.52.21": "Sausumos transportui būdingų paslaugų veikla",
        "H.52.21.10": "Traukinių eismo organizavimas ir reguliavimas",
        "H.52.21.20": "Automobilių stovėjimo aikštelių eksploatavimas",
        "H.52.21.30": "Techninių priemonių, reguliuojančių gatvių judėjimą, eksploatavimas",
        "H.52.21.40": "Gatvių, kelių, tiltų, tunelių eksploatavimas",
        "H.52.21.50": "Sauskelių transporto stočių eksploatavimas",
        "H.52.21.60": "Riedmenų techninė priežiūra ir smulkus remontas",
        "H.52.21.70": "Geležinkelių eksploatavimas",
        "H.52.22": "Vandens transportui būdingų paslaugų veikla",
        "A.03.22": "Gėlųjų vandenų akvakultūra",
        "H.52.23": "Oro transportui būdingų paslaugų veikla",
        "H.52.24": "Krovinių tvarkymas",
        "H.52.29": "Kita transportui būdingų paslaugų veikla",
        "H.52.29.10": "Muitinės tarpininkų veikla",
        "H.52.29.20": "Krovinių gabenimo agentų ir ekspeditorių veikla",
        "H.52.29.30": "Vežimo dokumentų ir kelionės lapų parengimas ir išdavimas",
        "H.53": "Pašto ir pasiuntinių (kurjerių) veikla",
        "H.53.1": "Pašto pagal įpareigojimą teikti universaliąsias paslaugas atliekama veikla",
        "H.53.10": "Pašto pagal įpareigojimą teikti universaliąsias paslaugas atliekama veikla",
        "H.53.2": "Kita pašto ir pasiuntinių (kurjerių) veikla",
        "B.": "KASYBA IR KARJERŲ EKSPLOATAVIMAS",
        "H.53.20": "Kita pašto ir pasiuntinių (kurjerių) veikla",
        "I.": "APGYVENDINIMO IR MAITINIMO PASLAUGŲ VEIKLA",
        "I.55": "Apgyvendinimo veikla",
        "I.55.1": "Viešbučių ir panašių laikinų buveinių veikla",
        "I.55.10": "Viešbučių ir panašių laikinų buveinių veikla",
        "I.55.2": "Poilsiautojų ir kita trumpalaikio apgyvendinimo veikla",
        "I.55.20": "Poilsiautojų ir kita trumpalaikio apgyvendinimo veikla",
        "I.55.20.10": "Poilsio namų veikla",
        "I.55.20.20": "Vaikų poilsio stovyklų veikla",
        "I.55.3": "Poilsinių transporto priemonių, priekabų aikštelių ir stovyklaviečių veikla",
        "B.05": "Akmens anglių ir rusvųjų anglių kasyba",
        "I.55.30": "Poilsinių transporto priemonių, priekabų aikštelių ir stovyklaviečių veikla",
        "I.55.9": "Kita apgyvendinimo veikla",
        "I.55.90": "Kita apgyvendinimo veikla",
        "I.56": "Maitinimo ir gėrimų teikimo veikla",
        "I.56.1": "Restoranų ir pagaminto valgio teikimo veikla",
        "I.56.10": "Restoranų ir pagaminto valgio teikimo veikla",
        "I.56.2": "Pagaminto valgio tiekimas renginiams ir kitų maitinimo paslaugų veikla",
        "I.56.21": "Pagaminto valgio tiekimas renginiams",
        "I.56.29": "Kitų maitinimo paslaugų teikimas",
        "I.56.3": "Gėrimų pardavimo vartoti vietoje veikla",
        "B.05.1": "Juodųjų akmens anglių (antracito) kasyba",
        "I.56.30": "Gėrimų pardavimo vartoti vietoje veikla",
        "J.": "INFORMACIJA IR RYŠIAI",
        "J.58": "Leidybinė veikla",
        "J.58.1": "Knygų, periodinių leidinių leidyba ir kita leidybinė veikla",
        "J.58.11": "Knygų leidyba",
        "J.58.12": "Žinynų, katalogų ir adresų sąrašų leidyba",
        "J.58.13": "Laikraščių leidyba",
        "J.58.14": "Žurnalų ir periodinių leidinių leidyba",
        "J.58.19": "Kita leidyba",
        "J.58.2": "Programinės įrangos leidyba",
        "B.05.10": "Juodųjų akmens anglių (antracito) kasyba",
        "J.58.21": "Kompiuterinių žaidimų leidyba",
        "J.58.29": "Kita programinės įrangos leidyba",
        "J.59": "Kino filmų, vaizdo filmų ir televizijos programų gamyba, garso įrašymo ir muzikos įrašų leidybos veikla",
        "J.59.1": "Kino filmų, vaizdo filmų ir televizijos programų rengėjų veikla",
        "J.59.11": "Kino filmų, vaizdo filmų ir televizijos programų gamyba",
        "J.59.12": "Pagamintų kino filmų, vaizdo filmų ir televizijos programų meninis apipavidalinimas",
        "J.59.13": "Kino filmų, vaizdo filmų ir televizijos programų platinimas",
        "J.59.14": "Kino filmų rodymas",
        "J.59.2": "Garso įrašymas ir muzikos įrašų leidyba",
        "J.59.20": "Garso įrašymas ir muzikos įrašų leidyba",
        "B.05.2": "Rusvųjų anglių kasyba",
        "J.60": "Programų rengimas ir transliavimas",
        "J.60.1": "Radijo programų transliavimas",
        "J.60.10": "Radijo programų transliavimas",
        "J.60.2": "Televizijos programų rengimas ir transliavimas",
        "J.60.20": "Televizijos programų rengimas ir transliavimas",
        "J.61": "Telekomunikacijos",
        "J.61.1": "Laidinio ryšio paslaugų veikla",
        "J.61.10": "Laidinio ryšio paslaugų veikla",
        "J.61.2": "Belaidžio ryšio paslaugų veikla",
        "J.61.20": "Belaidžio ryšio paslaugų veikla",
        "B.05.20": "Rusvųjų anglių kasyba",
        "J.61.3": "Palydovinio ryšio paslaugų veikla",
        "J.61.30": "Palydovinio ryšio paslaugų veikla",
        "J.61.9": "Kitų ryšių paslaugų veikla",
        "J.61.90": "Kitų ryšių paslaugų veikla",
        "J.62": "Kompiuterių programavimo, konsultacinė ir susijusi veikla",
        "J.62.0": "Kompiuterių programavimo, konsultacinė ir susijusi veikla",
        "J.62.01": "Kompiuterių programavimo veikla",
        "J.62.02": "Kompiuterių konsultacinė veikla",
        "J.62.03": "Kompiuterinės įrangos tvarkyba",
        "J.62.09": "Kita informacinių technologijų ir kompiuterių paslaugų veikla",
        "B.06": "Žalios naftos ir gamtinių dujų gavyba",
        "J.63": "Informacinių paslaugų veikla",
        "J.63.1": "Duomenų apdorojimo, interneto serverių paslaugų (prieglobos) ir susijusi veikla; interneto vartų paslaugų veikla",
        "J.63.11": "Duomenų apdorojimo, interneto serverių paslaugų (prieglobos) ir susijusi veikla",
        "J.63.12": "Interneto vartų paslaugų veikla",
        "J.63.9": "Kita informacinių paslaugų veikla",
        "J.63.91": "Naujienų agentūrų veikla",
        "J.63.99": "Kita, niekur kitur nepriskirta, informacinių paslaugų veikla",
        "K.": "FINANSINĖ IR DRAUDIMO VEIKLA",
        "K.64": "Finansinių paslaugų veikla, išskyrus draudimą ir pensijų lėšų kaupimą",
        "K.64.1": "Piniginis tarpininkavimas",
        "A.01.13.30": "Daržovių auginimas atvirame grunte",
        "B.06.1": "Žalios naftos gavyba",
        "K.64.11": "Centrinė bankininkystė",
        "K.64.19": "Kitas piniginis tarpininkavimas",
        "K.64.2": "Kontroliuojančiųjų bendrovių veikla",
        "K.64.20": "Kontroliuojančiųjų bendrovių veikla",
        "K.64.3": "Trestų, fondų ir panašių finansinių institucijų veikla",
        "K.64.30": "Trestų, fondų ir panašių finansinių institucijų veikla",
        "K.64.9": "Kita finansinių paslaugų veikla, išskyrus draudimą ir pensijų lėšų kaupimą",
        "K.64.91": "Finansinė išperkamoji nuoma",
        "K.64.92": "Kitas kredito teikimas",
        "K.64.99": "Kita, niekur kitur nepriskirta, finansinių paslaugų veikla, išskyrus draudimą ir pensijų lėšų kaupimą",
        "B.06.10": "Žalios naftos gavyba",
        "K.65": "Draudimo, perdraudimo ir pensijų lėšų kaupimo, išskyrus privalomąjį socialinį draudimą, veikla",
        "K.65.1": "Draudimas",
        "K.65.11": "Gyvybės draudimas",
        "K.65.12": "Ne gyvybės draudimas",
        "K.65.12.10": "Kelionių draudimas",
        "K.65.2": "Perdraudimas",
        "K.65.20": "Perdraudimas",
        "K.65.3": "Pensijų lėšų kaupimas",
        "K.65.30": "Pensijų lėšų kaupimas",
        "K.66": "Pagalbinė finansinių paslaugų ir draudimo veikla",
        "B.06.2": "Gamtinių dujų gavyba",
        "K.66.1": "Pagalbinė finansinių paslaugų, išskyrus draudimą ir pensijų lėšų kaupimą, veikla",
        "K.66.11": "Finansų rinkos valdymas",
        "K.66.12": "Vertybinių popierių ir prekių sutarčių sudarymo tarpininkavimas",
        "K.66.19": "Kita pagalbinė finansinių paslaugų, išskyrus draudimą ir pensijų lėšų kaupimą, veikla",
        "K.66.2": "Pagalbinė draudimo ir pensijų lėšų kaupimo veikla",
        "K.66.21": "Rizikos ir žalos vertinimas",
        "K.66.22": "Draudimo agentų ir brokerių veikla",
        "K.66.29": "Kita pagalbinė draudimo ir pensijų lėšų kaupimo veikla",
        "K.66.3": "Fondų valdymo veikla",
        "K.66.30": "Fondų valdymo veikla",
        "B.06.20": "Gamtinių dujų gavyba",
        "L.": "NEKILNOJAMOJO TURTO OPERACIJOS",
        "L.68": "Nekilnojamojo turto operacijos (PPP)",
        "L.68.1": "Nuosavo nekilnojamojo turto pirkimas ir pardavimas",
        "L.68.10": "Nuosavo nekilnojamojo turto pirkimas ir pardavimas",
        "L.68.2": "Nuosavo arba nuomojamo nekilnojamojo turto nuoma ir eksploatavimas",
        "L.68.20": "Nuosavo arba nuomojamo nekilnojamojo turto nuoma ir eksploatavimas",
        "L.68.3": "Nekilnojamojo turto operacijos už atlygį arba pagal sutartį (PPP)",
        "L.68.31": "Nekilnojamojo turto agentūrų veikla (PPP)",
        "L.68.31.10": "Nekilnojamojo turto vertinimas (PPP)",
        "L.68.32": "Nekilnojamojo turto tvarkyba už atlygį arba pagal sutartį (PPP)",
        "B.07": "Metalų rūdų kasyba (PPP)",
        "M.": "PROFESINĖ, MOKSLINĖ IR TECHNINĖ VEIKLA",
        "M.69": "Teisinė ir apskaitos veikla (PPP)",
        "M.69.1": "Teisinė veikla (PPP)",
        "M.69.10": "Teisinė veikla (PPP)",
        "M.69.10.10": "Konsultacijos ir juridinis atstovavimas civilinėse ir baudžiamosiose bylose (PPP)",
        "M.69.10.20": "Konsultacijos ir atstovavimas darbo ginčuose (PPP)",
        "M.69.10.30": "Bendrieji patarimai ir konsultacijos, teisinių dokumentų rengimas (PPP)",
        "M.69.2": "Apskaitos, buhalterijos ir audito veikla; konsultacijos mokesčių klausimais (PPP)",
        "M.69.20": "Apskaitos, buhalterijos ir audito veikla; konsultacijos mokesčių klausimais (PPP)",
        "M.69.20.10": "Buhalterinė apskaita ir audito atlikimas (PPP)",
        "B.07.1": "Geležies rūdų kasyba (PPP)",
        "M.69.20.20": "Finansinių ataskaitų rengimas",
        "M.69.20.30": "Firmų ir kitų bendrovių komercinių operacijų apskaitos tvarkymas",
        "M.69.20.40": "Mokesčių konsultacijos",
        "M.70": "Pagrindinių buveinių veikla; konsultacinė valdymo veikla",
        "M.70.1": "Pagrindinių buveinių veikla",
        "M.70.10": "Pagrindinių buveinių veikla",
        "M.70.2": "Konsultacinė valdymo veikla",
        "M.70.21": "Viešųjų ryšių ir komunikacijos veikla",
        "M.70.22": "Konsultacinė verslo ir kito valdymo veikla",
        "M.71": "Architektūros ir inžinerijos veikla; techninis tikrinimas ir analizė",
        "B.07.10": "Geležies rūdų kasyba (PPP)",
        "M.71.1": "Architektūros ir inžinerijos veikla bei su ja susijusios techninės konsultacijos",
        "M.71.11": "Architektūros veikla",
        "M.71.12": "Inžinerijos veikla ir su ja susijusios techninės konsultacijos",
        "M.71.12.10": "Inžinerinė-technologinė veikla",
        "M.71.12.20": "Projektiniai-konstruktoriniai darbai",
        "M.71.12.30": "Gatvių eismo projektavimas",
        "M.71.12.40": "Geodezinė veikla",
        "M.71.12.50": "Geologinės paieškos ir žvalgyba",
        "M.71.12.60": "Miškotvarka ir žemėtvarka",
        "M.71.2": "Techninis tikrinimas ir analizė",
        "B.07.2": "Spalvotųjų metalų rūdų kasyba (PPP)",
        "M.71.20": "Techninis tikrinimas ir analizė",
        "M.71.20.10": "Aplinkos kontrolė, ekologinis monitoringas",
        "M.71.20.20": "Medžiagų bandymai ir analizė",
        "M.71.20.30": "Produkcijos kokybės bandymai ir analizė",
        "M.71.20.40": "Maisto produktų tyrimas pagal higienos reikalavimus, įskaitant veterinarinį, susijusį su maisto produktų gamyba, tyrimą ir tikrinimą",
        "M.71.20.50": "Variklinių transporto priemonių saugaus eismo periodinis patikrinimas",
        "M.71.20.60": "Matavimo priemonių patikra bei kalibravimas",
        "M.71.20.70": "Gaminių sertifikavimas, jų normatyvinių dokumentų reikalavimų kontrolė",
        "M.72": "Moksliniai tyrimai ir taikomoji veikla",
        "M.72.1": "Gamtos mokslų ir inžinerijos moksliniai tyrimai ir taikomoji veikla",
        "B.07.21": "Urano ir torio rūdų kasyba (PPP)",
        "M.72.11": "Biotechnologijos moksliniai tyrimai ir taikomoji veikla",
        "M.72.19": "Kiti gamtos mokslų ir inžinerijos moksliniai tyrimai ir taikomoji veikla",
        "M.72.19.10": "Agrarinių mokslų tiriamieji ir taikomieji darbai",
        "M.72.19.20": "Gamtos mokslų tiriamieji ir taikomieji darbai",
        "M.72.19.30": "Matematikos mokslų tiriamieji ir taikomieji darbai",
        "M.72.19.40": "Medicinos mokslų tiriamieji ir taikomieji darbai",
        "M.72.19.50": "Technikos mokslų tiriamieji ir taikomieji darbai",
        "M.72.2": "Socialinių ir humanitarinių mokslų moksliniai tyrimai ir taikomoji veikla",
        "M.72.20": "Socialinių ir humanitarinių mokslų moksliniai tyrimai ir taikomoji veikla",
        "M.72.20.10": "Humanitarinių mokslų tiriamieji ir taikomieji darbai",
        "B.07.29": "Kitų spalvotųjų metalų rūdų kasyba (PPP)",
        "M.72.20.20": "Socialinių mokslų tiriamieji ir taikomieji darbai",
        "M.72.20.30": "Teologijos mokslų tiriamieji ir taikomieji darbai",
        "M.73": "Reklama ir rinkos tyrimas",
        "M.73.1": "Reklama",
        "M.73.11": "Reklamos agentūrų veikla",
        "M.73.12": "Atstovavimas žiniasklaidai",
        "M.73.2": "Rinkos tyrimas ir viešosios nuomonės apklausa",
        "M.73.20": "Rinkos tyrimas ir viešosios nuomonės apklausa",
        "M.74": "Kita profesinė, mokslinė ir techninė veikla",
        "M.74.1": "Specializuota projektavimo veikla"
      },
      "CBBSN": {
        "CBBSN1": "1",
        "CBBSN10": "10",
        "CBBSN2": "2",
        "CBBSN3": "3",
        "CBBSN4": "4",
        "CBBSN5": "5",
        "CBBSN6": "6",
        "CBBSN7": "7",
        "CBBSN8": "8",
        "CBBSN9": "9"
      },
      "CBBLI": {
        "CBBLI1": "Teisinės paslaugos, advokato praktika, notaro veikla",
        "CBBLI10": "Didmeninė prekyba alkoholiniais gėrimais ir kitais alkoholio produktais, tabako gaminiais",
        "CBBLI11": "Prekyba naftos produktais",
        "CBBLI12": "Farmacinė veikla",
        "CBBLI2": "Loterijų, azartinių lošimų organizavimas ir jo vykdymas",
        "CBBLI3": "Veikla, susijusi su juodaisiais, spalvotaisiais arba tauriaisiais (retaisiais) metalais, brangakmeniais, juvelyriniais dirbiniais, meno kūriniais",
        "CBBLI4": "Prekyba transporto priemonėmis",
        "CBBLI5": "Prekyba nekilnojamuoju turtu",
        "CBBLI6": "Finansinių ataskaitų audito veikla",
        "CBBLI7": "Asmens sveikatos priežiūra",
        "CBBLI8": "Aukcionu organizavimas ir vykdymas",
        "CBBLI9": "Turizmo ir kelionių organizavimas"
      },
      "CBP": {
        "CBP1": "1",
        "CBP2": "2",
        "CBP3": "3",
        "CBP4": "4",
        "CBP5": "5"
      },
      "CBREG": {
        "CBREG1": "Lietuva",
        "CBREG2": "ES",
        "CBREG3": "NVS",
        "CBREG4": "JAV",
        "CBREG5": "Kita"
      },
      "CFURC": {
        "CFURC1": "1",
        "CFURC10": "10",
        "CFURC2": "2",
        "CFURC3": "3",
        "CFURC4": "4",
        "CFURC5": "5",
        "CFURC6": "6",
        "CFURC7": "7",
        "CFURC8": "8",
        "CFURC9": "9"
      },
      "SHRE": {
        "SHRE1": "Panaudoti paskolos paskutinės (-ių) įmokos (-ų) dengimui",
        "SHRE2": "Išmokėti visiškai atsiskaičius su kredito unija",
        "SHRE3": "Sumažinti pajinių įnašų dydį ne dažniau kaip kartą per metus"
      },
      "PDSH": {
        "PDSH1": "Pagrindinis (privalomas) pajus",
        "PDSH2": "Papildomas pajus",
        "PDSH3": "Papildomas tvarus pajus",
        "PDSH4": "Privilegijuotas pajus",
        "PDSH5": "Papildomas tvarus pajus prie indėlio"
      },
      "DEPP": {
        "DEPP1": "Termino pabaigoje",
        "DEPP2": "Kas mėnesį"
      },
      "INTER": {
        "INTER2": "Senjorams",
        "INTER3": "Sandoris sudarytas internetu",
        "INTER1": "Lojalumo premija",
        "INTER4": "Kita"
      },
      "LOIPP": {
        "1": "1 mėn.",
        "2": "2 mėn.",
        "3": "3 mėn.",
        "6": "6 mėn.",
        "12": "12 mėn."
      },
      "LOIT": {
        "LOIT1": "Fiksuotos",
        "LOIT2": "Kintamos"
      },
      "DOCSA": {
        "DOCSA1": "Pensininko pažymėjimas",
        "DOCSA2": "Studento pažymėjimas",
        "DOCSA3": "Įmonės registravimo pažymėjimas",
        "DOCSA4": "Ūkininko pažymėjimas",
        "DOCSA5": "Anstolio pažymėjimas",
        "DOCSA6": "Advokato pažymėjimas",
        "DOCSA7": "Notaro pažymėjimas",
        "DOCSA8": "Įgaliojimas",
        "DOCSA9": "Kita"
      },
      "PURP": {
        "PURP1": "Apyvartinės lėšos",
        "PURP2": "Automobilis",
        "PURP3": "Būstas (ne nuomai)",
        "PURP4": "Būstas pagal FAPM",
        "PURP5": "Būsto remontas",
        "PURP6": "Darbo kelionė",
        "PURP7": "Gamybos priemonės",
        "PURP8": "Įrenginiai",
        "PURP9": "Kita",
        "PURP10": "Pastatai (gyvenamoji paskirtis)",
        "PURP11": "Pastatai (kita paskirtis)",
        "PURP12": "Pastatai (komercinė paskirtis)",
        "PURP13": "Smulkus verslas",
        "PURP14": "Studijos",
        "PURP15": "Studijos pagal FAPM",
        "PURP16": "Transporto priemonės",
        "PURP17": "Vartojimas",
        "PURP18": "Vertybiniai popieriai",
        "PURP19": "Vystymas",
        "PURP20": "Žemės sklypas",
        "PURP21": "ŽŪ verslas",
        "PURP22": "Investiciniam projektui įgyvendinti pagal finansinę priemonę „Verslumo skatinimas 2014–2020, finansuojamą iš Europos socialinio fondo lėšų“",
        "PURP23": "Apvartinėms lėšoms papildyti pagal „Verslumo skatinimas 2014–2020, finansuojamą iš Europos socialinio fondo lėšų“"
      },
      "LOAT": {
        "LOAT1": "Vartojimo kreditas",
        "LOAT2": "Kreditas susijęs su NT (ne būsto)",
        "LOAT3": "Kreditas susijęs su NT (būsto)",
        "LOAT4": "Kreditas verslui arba profesinei veiklai",
        "LOAT5": "Investicinis verslo kreditas",
        "LOAT6": "Apyvartinio kapitalo kreditas",
        "LOAT7": "Kredito linija",
        "LOAT8": "Investicinis žemės ūkio kreditas",
        "LOAT9": "Sezonine paskola",
        "LOAT10": "Overdraftas",
        "LOAT11": "Verslumo skatinimo (VSF2)",
        "LOAT12": "Apyvartinio kapitalo kreditas (NMA išmokų įkeitimas)",
        "LOAT13": "Invega 1 (VSF1)",
        "LOAT14": "Garantija",
        "LOAT15": "Sandoris tarp unijų"
      },
      "PEN": {
        "PEN1": "1",
        "PEN2": "2",
        "PEN3": "3",
        "PEN4": "4",
        "PEN5": "5"
      },
      "CISO": {
        "AB": " Abchazija*",
        "AO": " Angola",
        "CA": " Kanada",
        "QA": " Kataras",
        "KZ": " Kazachstanas",
        "KE": " Kenija",
        "CN": " Kinija",
        "CY": " Kipras",
        "KG": " Kirgizija",
        "KI": " Kiribatis",
        "CC": " Kokosų salos*",
        "CO": " Kolumbija",
        "AQ": " Antarktida*",
        "KM": " Komorai",
        "CD": " Kongo Demokratinė Respublika",
        "CG": " Kongas",
        "KS": " Kosovas",
        "CR": " Kosta Rika",
        "HR": " Kroatija",
        "CU": " Kuba",
        "CK": " Kuko salos*",
        "KW": " Kuveitas",
        "LA": " Laosas",
        "AG": " Antigva ir Barbuda",
        "LV": " Latvija",
        "PL": " Lenkija",
        "LS": " Lesotas",
        "LB": " Libanas",
        "LR": " Liberija",
        "LY": " Libija",
        "LI": " Lichtenšteinas",
        "LT": " Lietuva",
        "LU": " Liuksemburgas",
        "YT": " Majotas*",
        "AR": " Argentina",
        "MO": " Makao*",
        "MG": " Madagaskaras",
        "MK": " Makedonija",
        "MY": " Malaizija",
        "MW": " Malavis",
        "MV": " Maldyvai",
        "ML": " Malis",
        "MT": " Malta",
        "MP": " Marianos šiaurinės salos*",
        "MA": " Marokas",
        "AM": " Armėnija",
        "MQ": " Martinika*",
        "MH": " Maršalo Salos",
        "MU": " Mauricijus",
        "MR": " Mauritanija",
        "MX": " Meksika",
        "IM": " Meno sala*",
        "VI": " Mergelių salos (JAV)*",
        "MM": " Mianmaras",
        "FM": " Mikronezijos Federacinės Valstijos",
        "MD": " Moldavija",
        "AW": " Aruba*",
        "MC": " Monakas",
        "MN": " Mongolija",
        "MS": " Montseratas*",
        "MZ": " Mozambikas",
        "NA": " Namibija",
        "NC": " Naujoji Kaledonija*",
        "NZ": " Naujoji Zelandija",
        "NR": " Nauru",
        "NP": " Nepalas",
        "NL": " Nyderlandai",
        "AU": " Australija",
        "AN": " Nyderlandų Antilai*",
        "NG": " Nigerija",
        "NE": " Nigeris",
        "NI": " Nikaragva",
        "NU": " Niujė*",
        "NF": " Norfolkas*",
        "NO": " Norvegija",
        "OM": " Omanas",
        "PX": " Padniestrė*",
        "PK": " Pakistanas",
        "AT": " Austrija",
        "PW": " Palau",
        "PS": " Palestina*",
        "PA": " Panama",
        "PG": " Papua Naujoji Gvinėja",
        "PY": " Paragvajus",
        "PE": " Peru",
        "ZA": " Pietų Afrikos Respublika",
        "GS": " Pietų Džordžija ir Pietų Sandvičo salos*",
        "KR": " Pietų Korėja",
        "PO": " Pietų Osetija*",
        "AZ": " Azerbaidžanas",
        "PD": " Pietų Sudanas",
        "PN": " Pitkerno salos*",
        "PT": " Portugalija",
        "GF": " Prancūzijos Gviana*",
        "PF": " Prancūzijos Polinezija*",
        "FR": " Prancūzija",
        "TF": " Prancūzijos Pietų ir Antarkties sritys*",
        "PR": " Puerto Rikas*",
        "GQ": " Pusiaujo Gvinėja",
        "RE": " Reunionas*",
        "AA": " Azorai*",
        "RW": " Ruanda",
        "RO": " Rumunija",
        "RU": " Rusija",
        "TP": " Rytų Timoras",
        "SB": " Saliamono salos",
        "SV": " Salvadoras",
        "WS": " Samoa",
        "SM": " San Marinas",
        "ST": " San Tomė ir Prinsipė",
        "SA": " Saudo Arabija",
        "AF": " Afganistanas",
        "BS": " Bahamos",
        "SC": " Seišeliai",
        "PM": " Sen Pjeras ir Mikelonas*",
        "SN": " Senegalas",
        "KN": " Sent Kitsas ir Nevis",
        "LC": " Sent Lusija",
        "VC": " Sent Vinsentas ir Grenadinai",
        "RS": " Serbija",
        "SL": " Siera Leonė",
        "SS": " Sylendas*",
        "SG": " Singapūras",
        "BH": " Bahreinas",
        "SY": " Sirija",
        "SK": " Slovakija",
        "SI": " Slovėnija",
        "SO": " Somalis",
        "SW": " Somalilandas*",
        "SD": " Sudanas",
        "FI": " Suomija",
        "SR": " Surinamas",
        "SJ": " Svalbardas*",
        "SZ": " Svazilandas",
        "BY": " Baltarusija",
        "KP": " Šiaurės Korėja",
        "LK": " Šri Lanka",
        "SH": " Šventoji Elena*",
        "SE": " Švedija",
        "CH": " Šveicarija",
        "TJ": " Tadžikija",
        "TH": " Tailandas",
        "TW": " Taivanas",
        "TZ": " Tanzanija",
        "TC": " Terksas ir Kaikosas*",
        "BD": " Bangladešas",
        "TI": " Tibetas*",
        "TG": " Togas",
        "TK": " Tokelau*",
        "TO": " Tonga",
        "TT": " Trinidadas ir Tobagas",
        "TS": " Tristanas da Kunja*",
        "TN": " Tunisas",
        "TR": " Turkija",
        "TM": " Turkmėnija",
        "TU": " Turkų Kipras*",
        "BB": " Barbadosas",
        "TV": " Tuvalu",
        "UG": " Uganda",
        "UA": " Ukraina",
        "UY": " Urugvajus",
        "UZ": " Uzbekija",
        "RA": " Vakarų Sachara**",
        "VU": " Vanuatu",
        "VA": " Vatikanas",
        "VS": " Velykų sala*",
        "VE": " Venesuela",
        "BE": " Belgija",
        "HU": " Vengrija",
        "VN": " Vietnamas",
        "DE": " Vokietija",
        "WF": " Volisas ir Futuna*",
        "ZM": " Zambija",
        "ZW": " Zimbabvė",
        "CV": " Žaliasis Kyšulys",
        "BZ": " Belizas",
        "BJ": " Beninas",
        "BM": " Bermuda*",
        "GW": " Bisau Gvinėja",
        "IE": " Airija",
        "BO": " Bolivija",
        "BA": " Bosnija ir Hercegovina",
        "BW": " Botsvana",
        "BR": " Brazilija",
        "BN": " Brunėjus",
        "BG": " Bulgarija",
        "BF": " Burkina Fasas",
        "BI": " Burundis",
        "BU": " Buvė*",
        "BT": " Butanas",
        "AX": " Alandai*",
        "CF": " Centrinės Afrikos Respublika",
        "TD": " Čadas",
        "CZ": " Čekija",
        "CL": " Čilė",
        "DK": " Danija",
        "VG": " Didžiosios Britanijos Mergelių salos*",
        "DM": " Dominika",
        "DO": " Dominikos Respublika",
        "CI": " Dramblio Kaulo Krantas",
        "JE": " Džersis",
        "AL": " Albanija",
        "DJ": " Džibutis",
        "EG": " Egiptas",
        "EC": " Ekvadoras",
        "ER": " Eritrėja",
        "EE": " Estija",
        "ET": " Etiopija",
        "FK": " Falklando salos*",
        "FO": " Farerų salos*",
        "FJ": " Fidžis",
        "PH": " Filipinai",
        "DZ": " Alžyras",
        "GA": " Gabonas",
        "GY": " Gajana",
        "GM": " Gambija",
        "GH": " Gana",
        "GG": " Gernsis*",
        "GI": " Gibraltaras*",
        "GR": " Graikija",
        "GD": " Grenada",
        "GL": " Grenlandija*",
        "GE": " Gruzija",
        "AS": " Amerikos Samoa*",
        "GU": " Guamas*",
        "GP": " Gvadelupa*",
        "GT": " Gvatemala",
        "GN": " Gvinėja",
        "HT": " Haitis",
        "HM": " Herdo ir Makdonaldo salos*",
        "HN": " Hondūras",
        "HK": " Honkongas*",
        "IN": " Indija",
        "IO": " Indijos vandenyno britų salos*",
        "AD": " Andora",
        "ID": " Indonezija",
        "IQ": " Irakas",
        "IR": " Iranas",
        "IS": " Islandija",
        "ES": " Ispanija",
        "IT": " Italija",
        "IL": " Izraelis",
        "JM": " Jamaika",
        "JP": " Japonija",
        "YE": " Jemenas",
        "AI": " Angilija*",
        "JO": " Jordanija",
        "AE": " Jungtiniai Arabų Emyratai",
        "GB": " Jungtinė Karalystė",
        "US": " JAV",
        "ME": " Juodkalnija",
        "KY": " Kaimanų salos*",
        "CX": " Kalėdų sala*",
        "KK": " Kalnų Karabachas*",
        "KH": " Kambodža",
        "CM": " Kamerūnas"
      },
      "CAPL": {
        "CAPL1": "Krepšelis K1",
        "CAPL10": "Krepšelis K10",
        "CAPL11": "Krepšelis K11",
        "CAPL12": "Krepšelis K12",
        "CAPL13": "Krepšelis K13",
        "CAPL14": "Krepšelis K14",
        "CAPL15": "Krepšelis K15",
        "CAPL16": "Krepšelis K16",
        "CAPL17": "Krepšelis K17",
        "CAPL18": "Krepšelis K18",
        "CAPL19": "Pagrindinė sąskaita",
        "CAPL2": "Krepšelis K2",
        "CAPL20": "Standartinis",
        "CAPL3": "Krepšelis K3",
        "CAPL4": "Krepšelis K4",
        "CAPL5": "Krepšelis K5",
        "CAPL6": "Krepšelis K6",
        "CAPL7": "Krepšelis K7",
        "CAPL8": "Krepšelis K8",
        "CAPL9": "Krepšelis K9"
      },
      "PLCASH": {
        "PLCASH1": "Iki 500 Eur",
        "PLCASH10": "Neplanuojama",
        "PLCASH2": "Iki 1500 Eur",
        "PLCASH3": "501-1500 Eur",
        "PLCASH4": "1501-3000 Eur",
        "PLCASH5": "Daugiau nei 3000 Eur",
        "PLCASH6": "3001-6000 Eur",
        "PLCASH7": "Daugiau nei 6000 Eur",
        "PLCASH8": "5001-15000 Eur",
        "PLCASH9": "Virš 15000 Eur"
      },
      "PLTUR": {
        "PLTUR1": "Iki 1000 Eur",
        "PLTUR2": "Iki 3000 Eur",
        "PLTUR3": "1001-3000 Eur",
        "PLTUR4": "1501-3000 Eur",
        "PLTUR5": "3001-6000 Eur",
        "PLTUR6": "Daugiau nei 6000 Eur",
        "PLTUR7": "6001-10000 Eur",
        "PLTUR8": "10001-15000 Eur",
        "PLTUR9": "10001-50000 Eur",
        "PLTUR10": "15001-25000 Eur",
        "PLTUR11": "Daugiau nei 25000 Eur",
        "PLTUR12": "50001-100000 Eur",
        "PLTUR13": "Virš 100000 Eur"
      },
      "PEP": {
        "PEP1": "1",
        "PEP10": "10",
        "PEP2": "2",
        "PEP3": "3",
        "PEP4": "4",
        "PEP5": "5",
        "PEP6": "6",
        "PEP7": "7",
        "PEP8": "8",
        "PEP9": "9"
      },
      "SVFGR": {
        "SVFGR1": "nepriklauso",
        "SVFGR2": "Bedarbiai",
        "SVFGR3": "Neįgalieji",
        "SVFGR4": "Asmenys iki 29 metų",
        "SVFGR5": "Vyresni negu 54 metų asmenys",
        "SVFGR6": "Moterys",
        "SVFGR7": "Tie, kurie kuria ir (ar) kurs \"žaliasias zonas"
      },
      "PROFFER": {
        "PRPROTOCOL": "Protokolas",
        "PROAPPROVED": "Patvirtintas",
        "PROREJECTED": "Atmestas",
        "PROCLOSED": "Uždarytas",
        "PROFFER": "Pasiūlymas",
        "PRWAIT": "Laukiama",
        "PRTERMINATED": "Nutrauktas",
        "PRCOMPLETE": "Aktyvus",
        "PRDONE": "Pasibaigęs"
      },
      "PRSTATUS": {
        "PRSTATUS1": "1",
        "PRSTATUS10": "10",
        "PRSTATUS2": "2",
        "PRSTATUS3": "3",
        "PRSTATUS4": "4",
        "PRSTATUS5": "5",
        "PRSTATUS6": "6",
        "PRSTATUS7": "7",
        "PRSTATUS8": "8",
        "PRSTATUS9": "9"
      },
      "RELST": {
        "CLO": "Uždarytas",
        "ACT": "Aktyvus"
      },
      "EMPC": {
        "EMPC1": "1",
        "EMPC2": "2",
        "EMPC3": "3",
        "EMPC4": "4",
        "EMPC5": "5"
      },
      "DEAST": {
        "DEAST1": "Uždarytas",
        "DEAST2": "Aktyvus"
      },
      "DEAL": {
        "SHARE": "Pajaus sandoris",
        "DEP": "Indėlio sandoris",
        "ACC": "Sąskaitos sandoris",
        "LOAN": "Paskolos sandoris",
        "CRLIN": "Kredito linijos sandoris",
        "CARD": "Mokėjimo kortelės sandoris",
        "OVER": "Overdrafto sandoris"
      },
      "ACC": {
        "ACC1": "1",
        "ACC2": "2",
        "ACC3": "3",
        "ACC4": "4",
        "ACC5": "5"
      },
      "ACCT": {
        "ACCT01": "Pagrindinio pajaus sąskaita",
        "ACCT62": "Mokėjimo kortelės sąskaita",
        "ACCT59": "Mokėjimo kortelės sąskaita",
        "ACCT91": "Banko sąskaita",
        "ACCT02": "Grąžinamo pajaus sąskaita",
        "ACCT03": "Papildomo tvaraus pajaus sąskaita",
        "ACCT04": "Grąžinamo papildomo tvaraus pajaus sąskaita",
        "ACCT06": "Grąžinamo papildomo pajaus sąskaita",
        "ACCT51": "Delspinigiai",
        "ACCT08": "Grąžinamo privilegijuoto tvaraus pajaus sąskaita",
        "ACCT10": "Einamoji sąskaita",
        "ACCT07": "Privilegijuoto tvaraus pajaus sąskaita",
        "ACCT16": "Mokėjimo kortelės sąskaita",
        "ACCT20": "Indėlio sąskaita",
        "ACCT21": "Mokėtinų palūkanų sąskaita",
        "ACCT50": "Nebalansinis įsipareigojimas",
        "ACCT53": "Įsipareigojimo mokestis",
        "ACCT61": "Kortelių rezervavimų sąskaita",
        "ACCT90": "Kasininko sąskaita",
        "ACCT60": "Riboto naudojimo sąskaita",
        "ACCT54": "Administravimo mokestis",
        "ACCT99": "Kliento tranzitinė sąskaita",
        "ACCT52": "Nurašyta paskola",
        "ACCT05": "Papildomo pajaus sąskaita",
        "ACCT15": "Paskolos sąskaita",
        "ACCT55": "Pradelstos paskolos sąskaita",
        "ACCT57": "Pradelstų palūkanų sąskaita",
        "ACCT58": "Sukaupti spec. atidėjiniai",
        "ACCT14": "Sukaupti spec. atidėjiniai (tik overdraftams)",
        "ACCT12": "Sukauptos palūkanos už indėlius iki pareikalvimo (už teigiamus likučius)",
        "ACCT30": "Sukauptos palūkanos už overdraftus (už neigiamus likučius)",
        "ACCT11": "Sukauptų palūkanų sąskaita",
        "ACCT56": "Sukauptų palūkanų sąskaita (paskoloms)"
      },
      "CLEMA": {
        "CLEMA1": "Vedęs/Ištekėjusi",
        "CLEMA2": "Našlys (-ė)",
        "CLEMA3": "Išsiskyręs (-usi)",
        "CLEMA4": "Nevedęs/ Netekėjusi",
        "CLEMA5": "Vedantis bendrą ūkį"
      },
      "STD": {
        "STD1": "1",
        "STD2": "2",
        "STD3": "3",
        "STD4": "4",
        "STD5": "5"
      },
      "LORET": {
        "LORET1": "Sumažinant viso laikotarpio įmokas",
        "LORET2": "Sutrumpinant grafiką iš priekio"
      },
      "CTIP": {
        "CTIP2": "Uždaroji akcinė bendrovė",
        "CTIP29": "Mažoji bendrija",
        "CTIP1": "Akcinė bendrovė",
        "CTIP7": "Individuali (personalinė) įmonė",
        "CTIP14": "Asociacija",
        "CTIP26": "Bankai ES",
        "CTIP27": "Bankai ne ES",
        "CTIP17": "Daugiabučių namų savininkų bendrija",
        "CTIP19": "Garažų statybos ir eksploatavimo bendrija",
        "CTIP16": "Gyvenamųjų namų statybos bendrija",
        "CTIP6": "Komanditinės (pasitikėjimo) ūkinė bendrija",
        "CTIP4": "Kooperatinė bendrovė",
        "CTIP8": "Kredito unija ir kitos kredito įstaigos",
        "CTIP15": "Labdaros ir paramos fondas",
        "CTIP28": "Lietuvos centrinis bankas",
        "CTIP24": "Nuolatinė arbitražo institucija",
        "CTIP20": "Politinės partija/ politinė organizacija",
        "CTIP23": "Profesinė sąjunga arba jų susivienijimas",
        "CTIP12": "Savivaldybių biudžetinė įstaiga",
        "CTIP10": "Savivaldybių įmonė",
        "CTIP25": "Šeimynos",
        "CTIP18": "Sodininkų bendrija",
        "CTIP5": "Tikroji ūkinė bendrija",
        "CTIP21": "Tradicinė Lietuvos religinė bendruomenė",
        "CTIP11": "Valstybės biudžetinė įstaiga",
        "CTIP9": "Valstybės įmonė",
        "CTIP13": "Viešoji įstaiga",
        "CTIP22": "Visuomeninė organizacija",
        "CTIP3": "Žemės ūkio bendrovė"
      },
      "PHON": {
        "Namu": "Namų",
        "Darbo": "Darbo",
        "Mob": "Mobilus",
        "Mobdarb": "Mobilus darbo"
      },
      "PER": {
        "DAY": "Dienos",
        "MONTH": "Mėnesiai",
        "YEAR": "Metai"
      },
      "UP": {
        "UP1": "AB akcijos ir analogai",
        "UP10": "Kitas kilnojamas turtas",
        "UP11": "Kitas nekilnojamas turtas",
        "UP12": "Kitas turtas",
        "UP13": "Kitos gautinos sumos",
        "UP14": "Kitos lėšos banko sąskaitoje",
        "UP15": "Kitos lėšos indėlio sąskaitoje",
        "UP16": "Kitos mašinos ir įrengimai",
        "UP17": "Kitos negyvenamosios patalpos",
        "UP18": "Komercinis transportas ir ŽŪ technika",
        "UP19": "Lengvieji automobiliai",
        "UP2": "Administracinės ir prekybos paskirties patalpos",
        "UP20": "LR įstaigos garantija",
        "UP21": "Netesybos",
        "UP22": "Paskolos gavėjo ar kitos asmens lėšos banko sąskaitoje KU",
        "UP23": "Paskolos gavėjo ar kitos asmens lėšos indėlio sąskaitoje KU",
        "UP24": "Prekių atsargos",
        "UP25": "Žemės ūkio paskirties žemė ne ūkininko veiklai",
        "UP26": "ŽŪ paskirties žemė ūkininko veiklai",
        "UP3": "FA garantija",
        "UP4": "FA laidavimas",
        "UP5": "FA laidavimas",
        "UP6": "Gautinos sumos iš Lietuvos valstybės institucijų",
        "UP7": "Gyvenamosios patalpos",
        "UP8": "JA laidavimas",
        "UP9": "Kita žemė"
      },
      "CURR": {
        "EUR": "EUR",
        "USD": "USD",
        "GBP": "GBP",
        "RUB": "RUB"
      },
      "CBREGZ": {
        "CBREGZ1": "1",
        "CBREGZ2": "2",
        "CBREGZ3": "3",
        "CBREGZ4": "4",
        "CBREGZ5": "5"
      },
      "EXPENS": {
        "EXPENS1": "Komunalinėms paslaugoms, telefonui",
        "EXPENS2": "Maistui",
        "EXPENS3": "Automobiliui (degalams, priežiūrai), transportui",
        "EXPENS4": "Draudimui (gyvybės, turto, transporto)",
        "EXPENS5": "Būsto nuoma",
        "EXPENS6": "Kitos išlaidos (drabužiai, laisvalaikis, investicijos)",
        "EXPENS7": "Paskolų ir palūkanų mokėjimai, kiti įsiskolinimai",
        "EXPENS8": "Lizingo, išperkamosios nuomos mokėjimai",
        "EXPENS9": "Prašomam kreditui grąžinti ir palūkanoms mokėti"
      },
      "INCMA": {
        "INCMA1": "Darbo užmokestis",
        "INCMA10": "Įmonės akcininkų lėšos",
        "INCMA11": "Pastovūs komandiruotpinigiai",
        "INCMA12": "Noumos pajamos",
        "INCMA13": "Ūkininkavimo pajamos",
        "INCMA14": "Alimentai",
        "INCMA15": "Kitos reguliarios pajamos",
        "INCMA16": "Kitos nereguliarios pajamos",
        "INCMA17": "Kintamos, abejotinos pajamos",
        "INCMA2": "Individuali veikla ar verslas",
        "INCMA3": "Pensija, stipendija",
        "INCMA4": "Vertybiniai popieriai",
        "INCMA5": "Santaupos",
        "INCMA6": "Pašalpa/išlaikymas, gauta parama",
        "INCMA7": "Parduotas nekilnojamasis turtas",
        "INCMA8": "Veiklos pajamos",
        "INCMA9": "Įmonei suteiktos paskolos"
      },
      "INCMP": {
        "INCMP1": "Esamos",
        "INCMP2": "Planuojamos"
      },
      "PRODGRPS": [
        {
          "classificatorTypeId": "GUARANTEE",
          "classificatorTypeName": "Garantijos tipas"
        },
        {
          "classificatorTypeId": "EBANK",
          "classificatorTypeName": "El. bankininkystė"
        },
        {
          "classificatorTypeId": "ACCC",
          "classificatorTypeName": "Sąskaitos tipas"
        },
        {
          "classificatorTypeId": "ACCC",
          "classificatorTypeName": "Sąskaitos tipas"
        },
        {
          "classificatorTypeId": "ACCC",
          "classificatorTypeName": "Sąskaitos tipas"
        },
        {
          "classificatorTypeId": "DEPT",
          "classificatorTypeName": "Indėlio rūšis (tipas)"
        },
        {
          "classificatorTypeId": "CASH",
          "classificatorTypeName": "Kasininko eilės numeris"
        },
        {
          "classificatorTypeId": "CAT",
          "classificatorTypeName": "Kortelės tipas"
        },
        {
          "classificatorTypeId": "CRET",
          "classificatorTypeName": "Kredito linijos tipas"
        },
        {
          "classificatorTypeId": "OVET",
          "classificatorTypeName": "Overdrafto tipas"
        },
        {
          "classificatorTypeId": "PDSH",
          "classificatorTypeName": "Pajaus tipas"
        },
        {
          "classificatorTypeId": "LOAT",
          "classificatorTypeName": "Paskolos tipas"
        }
      ]
    };
}

export const getClassificators = () => {
    //return getClassificatorsConst();
    return getClassificatorsFn();
};